import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import axios from "axios";
import { useSelector } from "../../redux/hooks";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import {
  LanguageActionTypes,
  changeLanguageActionCreator,
} from "../../redux/language/languageActions";
import { useTranslation } from "react-i18next";
import { withTranslation, WithTranslation } from "react-i18next";
import moment from "moment";
import { MessengerChat } from "react-messenger-chat-plugin";
import { LoginSocialGoogle } from "reactjs-social-login";
import { GoogleLoginButton } from "react-social-login-buttons";
import InteractiveBlock from "./InteractiveBlock";
import Popup from "./Popup";
import FloatingButton from "../../components/FloatingButton";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll";
import {
  Button,
  Descriptions,
  Row,
  Col,
  Select,
  Space,
  Steps,
  Table,
  Tag,
  Typography,
  AutoComplete,
  Form,
  Input,
  InputNumber,
  Checkbox,
  notification,
  Modal,
  Collapse,
  Carousel,
  Dropdown,
  Menu,
  Card,
  Divider,
  Radio,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusCircleFilled,
  CheckCircleFilled,
  CloseCircleFilled,
  WarningFilled,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  GlobalOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { useGoogleStoreSelector, useGoogleStoreAction } from "./GoogleStore";
import GoogleAuthButton from "./GoogleAuthButton";
import ScoreChart from "./ScoreChart";
import Device from "./Device";
import useSnapshotPolling from "../../hooks/useSnapshotPolling";
import useScrollTracking from "../../hooks/useScrollTracking";
import SnapshotCountdown from "./components/SnapshotCountdown";
import SnapshotCharts from "./components/SnapshotCharts";
import PreCheckContent from "./components/PreCheckContent";
import PostCheckContent from "./components/PostCheckContent";
import NoDataContent from "./components/NoDataContent";
import RealTimeReportModal from "./components/RealTimeReportModal";
import utilsIndex from "../../utils/index";
import docCookies from "../../utils/docCookies";
import { NEW_RADAR_OPTION, NEW_CLIENT_RATIO_OPTION } from "./analyticsOptions";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import "./CheckAssistant.scss";

import checkListInit from "./CheckListInit";
import CheckListCompareInit from "./CheckListCompareInit";

import imgLogo from "../../images/checkAssistant/logo.png";
import imgIconMain from "../../images/checkAssistant/icon-main.png";
import imgIconBeta from "../../images/checkAssistant/icon-beta.png";
import imgStep from "../../images/checkAssistant/step.png";
import imgLoginAuth from "../../images/checkAssistant/login-auth.png";
import imgContact from "../../images/checkAssistant/contact.png";
import imgFooter from "../../images/checkAssistant/footer.webp";
// import imgPremierPartner from "../../images/checkAssistant/premier-partner.png";
import imgPremierPartner from "../../images/checkAssistant/premier-partner.png.webp";
// import imgGooglePartner from "../../images/checkAssistant/google-partner.png";
import imgGooglePartner from "../../images/checkAssistant/google-partner-all.png";
import imgGMPC from "../../images/checkAssistant/GMPC.png";

import laurelLeft from "../../images/checkAssistant/laurel_left.png";
import laurelReft from "../../images/checkAssistant/laurel_right.png";
import iconOnModal from "../../images/checkAssistant/icon_on_modal_1.png";
import timesCheck from "../../images/checkAssistant/times_check.png";

import imgWarn from "../../images/checkAssistant/icon_warn.png";
import imgWarn1 from "../../images/checkAssistant/icon_warn1.png";
import imgService01 from "../../images/checkAssistant/service/01.webp";
import imgService01PC from "../../images/checkAssistant/service/01-pc.png";
import imgService03Plan01 from "../../images/checkAssistant/service/plan1.webp";
import imgService03Plan02 from "../../images/checkAssistant/service/plan2.webp";
import imgService03Plan03 from "../../images/checkAssistant/service/plan3.webp";
import imgService03Plan04 from "../../images/checkAssistant/service/plan4.webp";
import imgStep01 from "../../images/checkAssistant/step1.png";
import imgStep02 from "../../images/checkAssistant/step2.png";
import imgStep03 from "../../images/checkAssistant/step3.png";
import imgIconArrow from "../../images/checkAssistant/icon-arrow.png";
import imgIconFixBlue from "../../images/checkAssistant/icon-fix-blue.png";
import imgIconFixGreen from "../../images/checkAssistant/icon-fix-green.png";
import imgIconFixRed from "../../images/checkAssistant/icon-fix-red.png";
import imgIconFixYellow from "../../images/checkAssistant/icon-fix-yellow.png";
import taiwanGeoJson from "../../data/twCounty2010.geo.json";

// 尚未檢核
import statusNotYet from "../../images/checkAssistant/status/not-yet.png";
// 正常運作
import statusNormal from "../../images/checkAssistant/status/normal.png";
// 建議修正
import statusFix from "../../images/checkAssistant/status/fix.png";
// 數據異常
import statusError from "../../images/checkAssistant/status/error.png";

import utils from "../../utils/index";

const isProduction = location.hostname !== "localhost";
// const isProduction = true;

const CheckboxGroup = Checkbox.Group;

const { Panel } = Collapse;

const { Step } = Steps;

const contentStyle = {
  height: "160px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
};

const formLayout = {
  labelCol: {
    // span: 7,
    span: 3,
  },
  wrapperCol: {
    // span: 10,
    span: 24,
  },
};
let submitBtnOffset = 3;
// const { Step } = Steps

const validateMessages = {
  required: "${label} 是必填項目",
  types: {
    email: "信箱格式必須正確",
    // email: "${label} is not a valid email!",
    // number: "${label} is not a valid number!",
  },
  // number: {
  //   range: "${label} must be between ${min} and ${max}",
  // },
};

const TAIWAN_POPULATION_DATA = {
  台北市: 2553222,
  新北市: 4020143,
  桃園縣: 2276867,
  台中市: 2840705,
  台南市: 1866184,
  高雄市: 2733035,
  基隆市: 366331,
  新竹市: 453981,
  新竹縣: 580946,
  苗栗縣: 547284,
  彰化縣: 1263529,
  南投縣: 480953,
  雲林縣: 655125,
  嘉義市: 265109,
  嘉義縣: 495348,
  屏東縣: 795300,
  台東縣: 214599,
  花蓮縣: 322157,
  宜蘭縣: 458139,
  澎湖縣: 106287,
  金門縣: 141311,
  連江縣: 13624,
};

let taiwanMapRegistered = false;

// 預設的地區數據（當沒有 snapshot data 時使用）
const DEFAULT_COUNTRY_ENGAGEMENT_DATA = [
  { region: "台北", users: 621, change: 55.8 },
  { region: "新竹", users: 517, change: 48.0 },
  { region: "台中", users: 421, change: -23.3 },
];

function ensureTaiwanMapRegistered() {
  if (!taiwanMapRegistered) {
    echarts.registerMap("Taiwan", taiwanGeoJson, { nameProperty: "name" });
    taiwanMapRegistered = true;
  }
}

function onChange(value) {
  console.log(`selected ${value}`);
}

function onSearch(val) {
  console.log("search:", val);
}

const REDIRECT_URI = "http://localhost:3000/account/login";

// 🎯 事件名稱翻譯對照表（用於轉換漏斗和裝置分佈圖表）
const EVENT_NAME_MAPPING = {
  session_start: "工作階段開始",
  view_item: "瀏覽商品",
  add_to_cart: "加入購物車",
  begin_checkout: "開始結帳",
  purchase: "完成轉換",
};

// 🎯 渠道等級對照表（tier 數字對應到等級）
const TIER_LEVEL_MAPPING = {
  3: {
    level: "上游",
    tagColor: "blue",
    comparison: "高於產業平均表現亮眼✨",
    suggestion: (
      <ul style={{ margin: 0, paddingLeft: "20px" }}>
        <li>優先放大表現穩定的來源，再擴展至相近受眾與情境。</li>
        <li>將有效素材與版位同步應用到其他活動，維持訊息一致性。</li>
        <li>設定品質門檻與頻率控管，避免因擴量造成體驗下滑。</li>
      </ul>
    ),
  },
  2: {
    level: "中游",
    tagColor: "default",
    comparison: "與產業表現持平",
    suggestion: (
      <ul style={{ margin: 0, paddingLeft: "20px" }}>
        <li>針對高流量入口進行 A/B 測試。</li>
        <li>保留並放大表現穩定的組合，其餘維持觀察與微調。</li>
        <li>建立警告與降預算規則，確保品質維持在可接受範圍。</li>
      </ul>
    ),
  },
  1: {
    level: "下游",
    tagColor: "red",
    comparison: "低於產業平均表現落後❗",
    suggestion: (
      <ul style={{ margin: 0, paddingLeft: "20px" }}>
        <li>暫停或縮減低效來源，集中於相對表現較佳的入口。</li>
        <li>檢核追蹤完整性、頁面載入與首屏訊息，補齊關鍵互動要素。</li>
        <li>排除低相關族群並收窄投放範圍，先提升到站品質後再規劃擴量。</li>
      </ul>
    ),
  },
};

// 🎯 渠道名稱對照表（API key 對應到顯示名稱）
const CHANNEL_NAME_MAPPING = {
  google: "Google",
  meta: "Meta",
  line: "LINE",
};

const CheckAssistant = ({ displayMode = "full" }) => {
  const device = Device();
  const language = useSelector((state) => state.language);
  const languageList = useSelector((state) => state.languageList);
  const dispatch = useDispatch();
  const [collapseKeys, setCollapseKeys] = useState([]);
  // const prevKeysRef = useRef([]);
  const previousKeysRef = useRef([]);

  // Loading 狀態
  const [isBlockLoading, setBlockLoading] = useState(false);
  const [isPopupLoading, setPopupLoading] = useState(false);

  // Content Index 狀態
  const [blockContentIndex, setBlockContentIndex] = useState(0); // **獨立的 InteractiveBlock 狀態**
  const [popupContentIndex, setPopupContentIndex] = useState(0); // **獨立的 Popup 狀態**

  // InfoBox 狀態
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  // const [isInfoVisible, setIsInfoVisible] = useState(false); // **控制 InteractiveBlock 的 InfoBox**
  const [isBlockInfoVisible, setIsBlockInfoVisible] = useState(false); // **InteractiveBlock 的 InfoBox**
  const [isPopupInfoVisible, setIsPopupInfoVisible] = useState(false); // **Popup 的 InfoBox**

  // Badge 狀態 - 移除：不再使用 badge
  // const [isBadgeDismissed, setIsBadgeDismissed] = useState(false);

  const [currentContentIndex, setCurrentContentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [clearAutoShowTimer, setClearAutoShowTimer] = useState(() => () => {}); // **存儲 InteractiveBlock 提供的計時器清除函數**

  ensureTaiwanMapRegistered();

  const formatPercentChange = useCallback((value) => {
    return `${Math.abs(value).toFixed(1)}%`;
  }, []);

  // 🎯 判斷資料是否為 'no data'
  const isNoData = useCallback((value) => {
    return value === "no data" || value === null || value === undefined;
  }, []);

  // **當 Popup 打開時，自動關閉 InteractiveBlock 的 InfoBox**
  const openPopup = () => {
    setPopupContentIndex(1);
    setIsPopupVisible(true);
    setIsPopupInfoVisible(true); // **開啟 Popup 的 InfoBox**
    if (clearAutoShowTimer) {
      clearAutoShowTimer(); // **清除 15 秒後自動開啟的機制**
    }
  };

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  // 🎯 處理 .score-1 區域按鈕點擊（發送 GA 事件）
  const handleIndustryMetricButtonClick = (item) => {
    // 先打開 Popup
    openPopup();

    // 在 /rtga 頁面發送 rtga_button 事件
    if (isRtgaPage) {
      utilsIndex.sendGAEvent("rtga_button", {
        block_name: item.name.en, // 英文名稱
        block_name1: item.status, // 狀態（如『低於平均值』）
        block_name2: item.name.tw, // 中文名稱（如『參與度』）
        block_name3: "檢測結果", // 固定值
      });
    }
  };

  const handleSubmit = (values, setCurrentContentIndex, setIsLoading) => {
    // console.log("🚀 ~ handleSubmit ~ values:", values);
    setIsLoading(true); // 開啟 loading
    // setCurrentContentIndex(2);

    // 🎯 判斷是否為 /rtga 頁面（新版內容）
    const isRtgaPage = displayMode === "new-content-only";

    // console.log("🚀 ~ checkListResult:", checkListResult);
    const checkListResultError = checkListResult.filter((item) => {
      if (item.status == "數據異常" || item.status == "建議修正") {
        return true;
      }
    });
    // console.log("🚀 ~ checkListResultError:", checkListResultError);

    const checkListCompareResultError = checkListCompareResult.filter(
      (item) => {
        if (item.status == "數據異常" || item.status == "低於平均值") {
          return true;
        }
      }
    );
    // console.log("🚀 ~ checkListCompareResult:", checkListCompareResult);
    // console.log(
    //   "🚀 ~ checkListCompareResultError:",
    //   checkListCompareResultError
    // );

    const ResultError = [
      ...checkListResultError,
      ...checkListCompareResultError,
    ];
    // console.log("🚀 ~ ResultError:", ResultError);

    // 🎯 根據頁面類型決定 Contact_Items 的資料來源
    let items;
    if (isRtgaPage) {
      // /rtga 頁面：使用六力比較資料
      items = industryComparisonMetrics.map((item) => {
        return {
          name: item.name.tw,
          value: item.status,
        };
      });
    } else {
      // 首頁：使用錯誤檢測項目
      items = ResultError.map((item) => {
        return {
          name: item.name.tw,
          value: item.status,
        };
      });
    }
    // console.log("🚀 ~ items:", items);

    let apiData = {
      main: {
        ...checkListSummaries.main,
        Contact: true,
        Contact_Name: values.name,
        Contact_Phone: values.phone,
        Contact_Email: values.email,
        Contact_Others: values.others ? values.others : "",
        Contact_Items: items,
        Contact_Time: Array.isArray(values.time) ? values.time : [],
        Contact_Topics: [],
      },
    };

    console.log("apiData float submit = ", apiData);

    setCheckListSummaries(apiData);

    // 本地測試不用送 api
    if (isProduction) {
      // Modal.success({
      //   content: "表單送出中請稍候！",
      // });

      // utilsIndex.sendGAEvent("form_submit", {
      //   turing_01: "彈跳視窗表單",
      //   turing_02: "Check Assistant頁",
      // });
      // fbq("trackCustom", "form_submit");

      // 🎯 根據頁面類型決定使用哪個 API
      if (isRtgaPage) {
        // /rtga 頁面：使用 double11/connect API（與 contact-form 相同）
        const snapshotApiData = {
          main: {
            Contact_Name: values.name,
            Contact_Phone: values.phone,
            Contact_Email: values.email,
            Contact_Others: values.others ? values.others : "",
            Contact_Items: items,
            Contact_Topics: [],
            PropertyID: property,
          },
        };

        console.log("snapshot API data (popup) = ", snapshotApiData);

        axios
          .post(
            `https://freeanalysisapi.turingdigital.com.tw/double11/connect`,
            snapshotApiData
          )
          .then(function (response) {
            console.log("double11/connect submit (popup) = ", response);
            setIsLoading(false); // API 成功後關閉 loading
            setCurrentContentIndex(2); // 切換到第三個內容
          })
          .catch(function (error) {
            console.log("double11/connect submit error (popup) = ", error);
            setIsLoading(false); // API 失敗後關閉 loading
          });
      } else {
        // 首頁：使用原本的 mains_batch API
        axios
          .post(
            `https://freeanalysisapi.turingdigital.com.tw/mains_batch/${apiId}`,
            apiData
          )
          .then(function (response) {
            // console.log("mains_batch submit = ", response)
            // Modal.destroyAll();
            // openSuccessModal();

            setIsLoading(false); // API 成功後關閉 loading
            setCurrentContentIndex(2); // 切換到第三個內容
            // setIsBadgeDismissed(true); // 移除：不再使用 badge
          })
          .catch(function (error) {
            console.log("mains_batch flaot submit error = ", error);
            setIsLoading(false); // API 失敗後關閉 loading
          });
      }
    } else {
      // 本地測試直接跳到下一步
      setTimeout(() => {
        console.log("本地測試直接跳到下一步 ===");
        setIsLoading(false);
        setCurrentContentIndex(2);
        // setIsBadgeDismissed(true); // 移除：不再使用 badge
      }, 1000);
    }
  };

  const [isFloatFormNotificationVisible, setIsFloatFormNotificationVisible] =
    useState(false);
  const [isFloatFormVisible, setIsFloatFormVisible] = useState(false);

  const handleFloatFormNotificationClose = () => {
    setIsFloatFormNotificationVisible(false);
  };
  const handleFloatFormNotificationOpen = () => {
    setIsFloatFormNotificationVisible(true);
  };
  const handleFloatFormClose = () => {
    setIsFloatFormVisible(false);
  };
  const handleFloatFormOpen = (event, type, name) => {
    if (event) event.stopPropagation(); // 防止事件冒泡
    if (name == "造訪流量") {
      name = "流量";
    } else if (name == "客戶有效互動率") {
      name = "互動率";
    }
    if (type == "checkResult") {
      utilsIndex.sendGAEvent("reserve_service", {
        turing_01: `${name}_立即修正指標`,
        turing_02: "Check Assistant頁",
      });
    } else {
      utilsIndex.sendGAEvent("reserve_service", {
        turing_01: "彈跳視窗按鈕",
        turing_02: "Check Assistant頁",
      });
    }
    setIsFloatFormVisible(true);
    setIsSubmitFloatForm(false);
  };

  // useEffect(() => {
  //   if (collapseKeys.length > 0) {
  //     console.log("Items opened: ", collapseKeys);
  //   }
  // }, [collapseKeys]);

  const { t } = useTranslation();

  const setCookie = (pName, pValue, pTime, pType) => {
    // pValue = encodeURIComponent(pValue);  // 避免中文在 safari 會錯誤
    var d = new Date();
    var pTime = pTime !== undefined ? pTime : 30; // 預設 30 天
    if (pType == "hour") {
      // 依『小時』設定
      d.setTime(d.getTime() + pTime * 60 * 60 * 1000);
    } else {
      // 依『天』設定
      if (pTime === 0) {
        d.setHours(23, 59, 59, 999); // 記錄到當天23點59分59秒
      } else {
        d.setTime(d.getTime() + pTime * 24 * 60 * 60 * 1000);
      }
    }
    var expires = "expires=" + d.toUTCString();
    var path = "path=/";
    document.cookie = pName + "=" + pValue + "; " + expires + "; " + path;
  };

  const getCookie = (pName) => {
    var name = pName + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) == 0)
        return decodeURIComponent(c.substring(name.length, c.length));
    }
    return "";
  };
  const languageNavigator = window.navigator.language;
  const languageCookie = getCookie("td-language")
    ? getCookie("td-language")
    : "tw";
  const outOfQuotaCookie = getCookie("td-out_of_quota");

  useEffect(() => {
    let languageCurrect = "";
    if (languageCookie) {
      languageCurrect = languageCookie;
    } else {
      if (languageNavigator == "zh-TW") {
        languageCurrect = "tw";
      } else {
        languageCurrect = "cn";
      }
    }
    dispatch(changeLanguageActionCreator(languageCurrect));

    setOutOfQuota(outOfQuotaCookie);
  }, []);

  const menuClickHandler = (e) => {
    console.log(e);
    const key = e.key;
    dispatch(changeLanguageActionCreator(key));
    setCookie("td-language", key);
  };

  const [provider, setProvider] = useState("");
  const [profile, setProfile] = useState();

  const handleMenuClick = (e) => {
    console.log("click", e);
  };

  const items = languageList.map((l) => {
    return {
      label: l.name,
      key: l.code,
    };
  });

  const menuProps = {
    items,
    onClick: menuClickHandler,
  };

  const onLoginStart = useCallback(() => {
    alert("login start");
  }, []);

  const onLogoutSuccess = useCallback(() => {
    setProfile(null);
    setProvider("");
    alert("logout success");
  }, []);

  const openNotification = () => {
    notification.info({
      message: "表單資料傳輸中",
      description: "請稍待片刻",
      // onClick: () => {
      //   console.log("Notification Clicked!")
      // },
    });
  };

  const {
    google_gapi_loaded,
    google_gapi_loaded_error,
    google_gapi_analyticsadmin_loaded,
    google_gapi_analyticsadmin_loaded_error,
    google_gapi_analyticsdata_loaded,
    google_gapi_analyticsdata_loaded_error,

    google_is_signed_in,
    google_user_email,
  } = useGoogleStoreSelector((state) => state);

  /* api */
  const [checkListSummaries, setCheckListSummaries] = useState({
    main: {
      TimeStamp: "",
      PropertyID: "",
      CrossDomain: false,
      IndustryCategory: "",
      TimeZone: "",
      Currency: "",
      GoogleSignals: "",
      DataRetention: "",
      LoginEmail: "",
      Score: 0,
      EngagementRate: 0,
      DataStreams: [],
      Domains: [],
      UserProperties: [],
      GoogleAdsLinking: [],
      NondefConvEvents: [],
      Audiences: [],
      PredictiveAudiences: [],
      Eccomerce: [],
      Sessions: [],
      ReportingAttributionModel: "",
      AcquisitionConversionEventLookbackWindow: "",
      OtherConversionEventLookbackWindow: "",
      Contact: false,
      Contact_Name: "",
      Contact_Phone: "",
      Contact_Email: "",
      Contact_Others: "",
      Contact_Items: [],
      Contact_Time: [],
      Contact_Topics: [],
    },
  });
  const [isCheckApiFetchFinished, setIsCheckApiFetchFinished] = useState(false);
  const [hasNoData, setHasNoData] = useState(false); // 控制是否顯示無資料畫面
  const [isSubmitContactForm, setIsSubmitContactForm] = useState(false);
  const [isSubmitFloatForm, setIsSubmitFloatForm] = useState(false);
  const [apiId, setApiId] = useState(null);
  const [collapseActiveKey, setCollapseActiveKey] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isStarModalVisible, setIsStarModalVisible] = useState(false);
  const [isTimesWaringModalVisible, setIsTimesWaringModalVisible] =
    useState(false);
  const [outOfQuota, setOutOfQuota] = useState(false);

  const [accountSummaries, setAccountSummaries] = useState([]);
  const [accountSummariesLoading, setAccountSummariesLoading] = useState(false);
  const [accountSummariesLoaded, setAccountSummariesLoaded] = useState(false);
  const [account, setAccount] = useState("");

  // 總分
  const [score, setScore] = useState(0);
  const scoreRef = useRef(score);
  // 總分
  const [prScore, setPrScore] = useState(0);
  // 檢核時間 - 頁面載入時立即記錄，不會因為重新渲染而改變
  const checkTimeRef = useRef(moment().format("YYYY/MM/DD HH:mm:ss"));
  const [checkTime] = useState(moment().format("YYYY/MM/DD HH:mm:ss"));

  // 行業綜合評比圖表標題 refs（用於對齊高度）
  const leftChartTitleRef = useRef(null);
  const rightChartTitleRef = useRef(null);

  // 1. 追蹤代碼編號 Property ID
  const [propertySummaries, setPropertySummaries] = useState([]);
  const [property, setProperty] = useState("");

  // 追蹤使用者是否正在填寫聯絡表單（用於暫停倒數計時）
  const [isContactFormFocused, setIsContactFormFocused] = useState(false);

  // 即時報表 Modal 狀態
  const [isRealTimeModalVisible, setIsRealTimeModalVisible] = useState(false);
  const [hasShownRealTimeModal, setHasShownRealTimeModal] = useState(false);
  const funnelInsightsRef = useRef(null);

  // 檢核區間時間（檢測完成時的時間）
  const [checkEndTime, setCheckEndTime] = useState("");

  // 🎯 Snapshot API 輪詢 (當使用者選擇 property 後自動呼叫 API)
  // 15 分鐘自動更新一次
  // 當使用者填寫聯絡表單時暫停倒數
  const {
    data: snapshotData,
    loading: snapshotLoading,
    error: snapshotError,
    remainingSeconds: snapshotRemainingSeconds,
    refetch: refetchSnapshot,
  } = useSnapshotPolling(google_user_email, property, isContactFormFocused);

  // 🎯 滾動追蹤設定（僅在 /rtga 頁面啟用）
  const isRtgaPage = displayMode === "new-content-only";
  const scrollTrackingTargets = useMemo(
    () => [
      { selector: ".radar-chart-wrapper", blockName: "radar chart" },
      { selector: ".insights-grid", blockName: "Customer" },
      { selector: ".funnel-charts-row", blockName: "funnel" },
      { selector: ".real-time-report-video", blockName: "realtime" },
      { selector: ".channel-performance-table", blockName: "display" },
      { selector: ".score-charts-row", blockName: "score" },
      { selector: ".score-1", blockName: "average" },
      { selector: ".contact-form", blockName: "consult" },
    ],
    []
  );

  useScrollTracking(
    scrollTrackingTargets,
    "rtga_wheel",
    isRtgaPage && isCheckApiFetchFinished
  );

  // 🎯 當 snapshot 資料載入完成時，設定檢測完成標記
  useEffect(() => {
    // 處理錯誤情況
    if (snapshotError && !snapshotLoading) {
      console.error("========================================");
      console.error("❌ Snapshot API 錯誤：", snapshotError);
      console.error("========================================");

      notification.error({
        message: "API 呼叫失敗",
        description: "資料載入時發生錯誤，請稍後再試或選擇其他資源。",
        duration: 8,
      });
      setIsCheckApiFetchFinished(false);
      return;
    }

    // 處理成功回傳資料
    if (snapshotData && !snapshotLoading) {
      console.log("========================================");
      console.log("🎯 Snapshot API 回傳資料：");
      console.log(JSON.stringify(snapshotData, null, 2));
      console.log("========================================");

      // 檢查是否為 "no data"
      if (snapshotData._noData === true) {
        notification.warning({
          message: "此資源無資料",
          description:
            "目前選擇的 GA4 資源尚未有檢測資料，請選擇其他資源或稍後再試。",
          duration: 8,
        });
        setHasNoData(true); // 設定為無資料狀態
        setIsCheckApiFetchFinished(false);
        return;
      }

      // 有正常資料才設為完成
      setHasNoData(false); // 確保有資料時清除無資料狀態
      setIsCheckApiFetchFinished(true);

      // 記錄檢測完成時間（格式：HH:mm）
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      setCheckEndTime(`${hours}:${minutes}`);
    }
  }, [snapshotData, snapshotLoading, snapshotError]);

  // 🎯 台灣地圖資料處理
  const taiwanMapSeriesData = useMemo(() => {
    // 使用 Snapshot Data 的地區資料
    if (snapshotData && snapshotData.active_users_region) {
      const regionData = snapshotData.active_users_region;

      return (taiwanGeoJson.features || []).map((feature) => {
        const geoName = feature?.properties?.name; // GeoJSON 中的名稱

        // 地區名稱對應 (GeoJSON 名稱 → API 名稱)
        const nameMapping = {
          台北市: "Taipei City",
          新北市: "New Taipei City",
          桃園縣: "Taoyuan City",
          台中市: "Taichung City",
          台南市: "Tainan City",
          高雄市: "Kaohsiung City",
          基隆市: "Keelung City",
          新竹市: "Hsinchu City",
          新竹縣: "Hsinchu County",
          苗栗縣: "Miaoli County",
          彰化縣: "Changhua County",
          南投縣: "Nantou County",
          雲林縣: "Yunlin County",
          嘉義縣: "Chiayi County",
          嘉義市: "Chiayi City",
          屏東縣: "Pingtung County",
          宜蘭縣: "Yilan County",
          花蓮縣: "Hualien County",
          台東縣: "Taitung County",
          澎湖縣: "Penghu County",
          金門縣: "Kinmen County",
        };

        const apiName = nameMapping[geoName];
        const value = apiName ? regionData[apiName] || 0 : 0;

        return { name: geoName, value };
      });
    }

    // 沒有 snapshot data 時使用預設資料
    return (taiwanGeoJson.features || []).map((feature) => {
      const name = feature?.properties?.name;
      return {
        name,
        value: name ? TAIWAN_POPULATION_DATA[name] || 0 : 0,
      };
    });
  }, [snapshotData]);

  const taiwanMapMaxValue = useMemo(() => {
    return taiwanMapSeriesData.reduce(
      (max, item) => (item.value > max ? item.value : max),
      0
    );
  }, [taiwanMapSeriesData]);

  const taiwanMapOption = useMemo(
    () => ({
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          const { value, name } = params;
          const displayValue =
            typeof value === "number" && value > 0
              ? value.toLocaleString()
              : "無資料";
          return `${name || "未命名"}<br/>人數： ${displayValue}`;
        },
      },
      visualMap: {
        left: "left",
        bottom: 20,
        min: 0,
        max: Math.max(taiwanMapMaxValue, 1),
        text: ["高", "低"],
        calculable: true,
        inRange: {
          color: ["#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
        },
      },
      series: [
        {
          name: "GA 預設指標",
          type: "map",
          map: "Taiwan",
          nameProperty: "name",
          roam: false,
          zoom: 1.5,
          center: [121, 23.5],
          emphasis: {
            label: { show: true },
          },
          data: taiwanMapSeriesData,
        },
      ],
    }),
    [taiwanMapSeriesData, taiwanMapMaxValue]
  );

  // 🎯 從 active_users_region 生成前三名地區數據
  const COUNTRY_ENGAGEMENT_DATA = useMemo(() => {
    if (!snapshotData || !snapshotData.active_users_region) {
      return DEFAULT_COUNTRY_ENGAGEMENT_DATA;
    }

    const regionData = snapshotData.active_users_region;

    // API 名稱對應到中文名稱
    const nameMapping = {
      "Taipei City": "台北市",
      "New Taipei City": "新北市",
      "Taoyuan City": "桃園市",
      "Taichung City": "台中市",
      "Tainan City": "台南市",
      "Kaohsiung City": "高雄市",
      "Keelung City": "基隆市",
      "Hsinchu City": "新竹市",
      "Hsinchu County": "新竹縣",
      "Miaoli County": "苗栗縣",
      "Changhua County": "彰化縣",
      "Nantou County": "南投縣",
      "Yunlin County": "雲林縣",
      "Chiayi County": "嘉義縣",
      "Chiayi City": "嘉義市",
      "Pingtung County": "屏東縣",
      "Yilan County": "宜蘭縣",
      "Hualien County": "花蓮縣",
      "Taitung County": "台東縣",
      "Penghu County": "澎湖縣",
      "Kinmen County": "金門縣",
    };

    // 轉換為陣列並排序
    const sortedRegions = Object.entries(regionData)
      .filter(([key]) => key !== "(not set)") // 過濾掉 (not set)
      .map(([key, value]) => ({
        region: nameMapping[key] || key,
        users: value,
        change: 0, // 目前沒有變化數據
      }))
      .sort((a, b) => b.users - a.users) // 按人數降序排序
      .slice(0, 3); // 只取前三名

    return sortedRegions.length > 0
      ? sortedRegions
      : DEFAULT_COUNTRY_ENGAGEMENT_DATA;
  }, [snapshotData]);

  const countryMaxUsers = useMemo(() => {
    return COUNTRY_ENGAGEMENT_DATA.reduce(
      (max, item) => (item.users > max ? item.users : max),
      0
    );
  }, [COUNTRY_ENGAGEMENT_DATA]);

  // 🎯 從 propertySummaries 中找到當前選中的 property 的 displayName
  const propertyDisplayName = useMemo(() => {
    // 優先使用 snapshotData 的 propertyDisplayName（用於 mock 資料測試）
    if (snapshotData?.propertyDisplayName) {
      return snapshotData.propertyDisplayName;
    }

    const selectedProperty = propertySummaries.find(
      (item) => item.property === property
    );
    return selectedProperty?.displayName || "客戶名稱";
  }, [propertySummaries, property, snapshotData]);

  // 🎯 根據 Snapshot Data 計算雷達圖選項
  const radarOption = useMemo(() => {
    if (!snapshotData || !snapshotData.six_forces) {
      // 檢測前：只顯示平均值
      return {
        ...NEW_RADAR_OPTION,
        legend: {
          ...NEW_RADAR_OPTION.legend,
          data: ["平均值"], // 只有平均值
        },
        series: [
          {
            ...NEW_RADAR_OPTION.series[0],
            data: [NEW_RADAR_OPTION.series[0].data[0]], // 只保留平均值數據
          },
        ],
      };
    }

    // 檢測後：顯示平均值 + 客戶名稱
    const { six_forces } = snapshotData;
    return {
      ...NEW_RADAR_OPTION,
      legend: {
        ...NEW_RADAR_OPTION.legend,
        data: [propertyDisplayName, "平均值"], // 兩個都顯示
      },
      series: [
        {
          ...NEW_RADAR_OPTION.series[0],
          data: [
            NEW_RADAR_OPTION.series[0].data[0], // 保留平均值
            {
              value: [
                six_forces.engagementRate || 0,
                six_forces.purchaseRate || 0,
                six_forces.newUserRate || 0,
                six_forces.addToCartRate || 0,
                six_forces.bounceRate || 0,
                six_forces.firstTimePurchaserRate || 0,
              ],
              name: propertyDisplayName,
              itemStyle: { color: "#5B7FDE" },
              lineStyle: { color: "#5B7FDE", width: 2 },
              areaStyle: { color: "#5B7FDE", opacity: 0.6 },
            },
          ],
        },
      ],
    };
  }, [snapshotData, propertyDisplayName]);

  // 🎯 根據 Snapshot Data 計算客群比例圖選項
  const clientRatioOption = useMemo(() => {
    if (!snapshotData || isNoData(snapshotData.newUserRate)) {
      return NEW_CLIENT_RATIO_OPTION; // 使用預設值
    }

    // 使用 API 提供的比例數據
    const newUserRate = snapshotData.newUserRate || 0.74;

    // 新客取整數，舊客 = 100 - 新客
    const newUserPercent = Math.round(newUserRate * 100);
    const oldUserPercent = 100 - newUserPercent;

    return {
      ...NEW_CLIENT_RATIO_OPTION,
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          const percent =
            params.name === "新客" ? newUserPercent : oldUserPercent;
          return `${params.marker}${params.name} ${percent}%`;
        },
      },
      series: [
        {
          ...NEW_CLIENT_RATIO_OPTION.series[0],
          label: {
            show: true,
            position: "center",
            fontSize: 22,
            fontWeight: "bold",
            color: "#1a1a1a",
            lineHeight: 26,
            formatter: () => {
              return `新客比例\n${newUserPercent}%`;
            },
          },
          data: [
            { value: newUserRate, name: "新客" },
            { value: 1 - newUserRate, name: "舊客" },
          ],
        },
      ],
    };
  }, [snapshotData]);

  // 🎯 根據 max_churn_event 生成裝置分佈圖表選項
  const deviceDistributionOption = useMemo(() => {
    // 檢查是否有有效數據
    const hasValidData =
      snapshotData?.裝置的使用者人數差距 &&
      !isNoData(snapshotData.裝置的使用者人數差距);

    const desktopUsers = hasValidData
      ? snapshotData.裝置的使用者人數差距.desktop?.totalUsers || 0
      : 0;
    const tabletUsers = hasValidData
      ? snapshotData.裝置的使用者人數差距.tablet?.totalUsers || 0
      : 0;
    const mobileUsers = hasValidData
      ? snapshotData.裝置的使用者人數差距.mobile?.totalUsers || 0
      : 0;

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params) {
          const param = params[0];
          return `${param.axisValue}<br/>${param.marker}${param.seriesName} ${param.value}人`;
        },
      },
      grid: {
        left: "80px",
        right: "60px",
        top: "20px",
        bottom: "20px",
        containLabel: false,
      },
      xAxis: {
        type: "value",
        axisLabel: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#e0e0e0",
            type: "solid",
          },
        },
      },
      yAxis: {
        type: "category",
        data: ["桌機", "平板", "手機"],
        axisLabel: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      series: [
        {
          name: "流失人數",
          type: "bar",
          label: {
            show: true,
            position: "right",
            formatter: "{c}人",
            fontSize: 16,
            fontWeight: "bold",
            color: "#333",
          },
          emphasis: {
            focus: "series",
          },
          data: [desktopUsers, tabletUsers, mobileUsers],
          itemStyle: {
            color: "#B4D95C",
            borderRadius: [0, 8, 8, 0],
          },
          barMaxWidth: 40,
        },
      ],
    };
  }, [snapshotData, isNoData]);

  // 🎯 根據 tier 數據生成渠道表現表格
  const channelPerformanceData = useMemo(() => {
    // 檢查是否有有效數據
    if (isNoData(snapshotData?.tier)) {
      return [];
    }

    const tier = snapshotData?.tier || {};
    const targetChannels = ["google", "meta", "line"];

    return targetChannels.map((channelKey, index) => {
      const tierValue = tier[channelKey] || 2; // 預設中游
      const tierInfo = TIER_LEVEL_MAPPING[tierValue] || TIER_LEVEL_MAPPING[2];
      const displayName = CHANNEL_NAME_MAPPING[channelKey] || channelKey;

      return {
        key: String(index + 1),
        channel: displayName,
        level: tierInfo.level,
        tagColor: tierInfo.tagColor,
        comparison: tierInfo.comparison,
        suggestion: tierInfo.suggestion,
      };
    });
  }, [snapshotData, isNoData]);

  // 2. 資料串流數量 Data Streams
  const [dataStreams, setDataStreams] = useState(null);
  const [webDataStreams, setWebDataStreams] = useState(null);
  const [androidAppDataStreams, setAndroidAppDataStreams] = useState(null);
  const [iosAppDataStreams, setIosAppDataStreams] = useState(null);

  // 3. 追蹤網域數量 Domains
  const [hostName, setHostName] = useState(null);

  // 4. 是否有跨網域追蹤 Cross Domain Measurement
  const [crossDomain, setCrossDomain] = useState(null);

  // 5. 產業類別設定 Industry Category
  const [industryCategory, setIndustryCategory] = useState(null);

  // 6. 時區設定 Time Zone
  const [timeZone, setTimeZone] = useState(null);

  // 7. 貨幣設定 Currency
  const [currencyCode, setCurrencyCode] = useState(null);

  // 8. 啟用 Google 信號 Google Signals
  const [googleSignalsSettings, setGoogleSignalsSettings] = useState(null);

  // 9. 資料保存期限 Data Retention
  const [ga360, setGa360] = useState(null);
  const [dataRetentionSettings, setDataRetentionSettings] = useState(null);

  // 10. 定義使用者屬性 User Properties
  const [userProperties, setUserProperties] = useState(null);

  // 11. 串接 Google Ads Google Ads Linking
  const [googleAdsLinks, setGoogleAdsLinks] = useState(null);

  // 12. 客戶有效互動率 Engagement Rate
  const [interactionRate, setInteractionRate] = useState(null);

  // 13. 非預設轉換事件 Conversion Events (Non-default)
  const [conversionEvents, setConversionEvents] = useState(null);

  // 14. 定義目標對象 Audiences
  const [audience, setAudience] = useState(null);

  // 15. 廣告預測功能 Predictive Audiences
  const [predicted, setPredicted] = useState(null);

  // 16. 電子商務代碼 E-Commerce
  const [eccomerce, setEccomerce] = useState(null);

  // 17. 工作階段比例 Sessions
  const [medium, setMedium] = useState(null);

  // 18. User-ID
  const [userId, setUserId] = useState(null);

  // 19. Data Streams Measurement Protocol
  const [
    webDataStreamsMeasurementProtocol,
    setWebDataStreamsMeasurementProtocol,
  ] = useState(null);
  const [
    androidAppDataStreamsMeasurementProtocol,
    setAndroidAppDataStreamsMeasurementProtocol,
  ] = useState(null);
  const [
    iosAppDataStreamsMeasurementProtocol,
    setIosAppDataStreamsMeasurementProtocol,
  ] = useState(null);

  // 20. google CPC trans
  const [googleCPCTrans, setGoogleCPCTrans] = useState(null);

  // 21. Unassigned
  const [unassigned, setUnassigned] = useState(null);

  const [googleApiFalse, setGoogleApiFalse] = useState(false);

  // 22. 預設轉換事件 Conversion Events (default)
  const [conversionEventsDefault, setConversionEventsDefault] = useState(null);

  const [reportingAttributionModel, setReportingAttributionModel] =
    useState(null);
  const [
    acquisitionConversionEventLookbackWindow,
    setAcquisitionConversionEventLookbackWindow,
  ] = useState(null);
  const [
    otherConversionEventLookbackWindow,
    setOtherConversionEventLookbackWindow,
  ] = useState(null);

  /* api end */

  /* 市場 api start */
  const [marketCompare, setMarketCompare] = useState(null);
  /* 市場 api end */

  const handleFixQuation = () => {
    utilsIndex.sendGAEvent("fix_problem");
  };

  const [echartsOption, setEchartsOption] = useState({});
  const [marketEchartsOption, setMarketEchartsOption] = useState({});

  const getEchartsOption = (score, type) => {
    // console.log("score = ", score)
    // const color = "#80B900" //进度颜色
    let color = "";
    // const score = "0" // 进度数据
    if (score <= 50) {
      // 數據異常
      color = "#f90000";
    } else if ((score > 50) & (score < 90)) {
      // 建議修正
      color = "#Fdb900";
    } else {
      // 正常運作
      color = "#7fb900";
    }
    // if (type == "market") {
    //   if (score <= 50) {
    //     // 低於平均值
    //     color = "#f90000";
    //   } else if ((score > 50) & (score < 90)) {
    //     // 低於平均值
    //     color = "#Fdb900";
    //   } else {
    //     // 高於平均值
    //     color = "#7fb900";
    //   }
    // } else {
    //   if (score <= 50) {
    //     // 數據異常
    //     color = "#f90000";
    //   } else if ((score > 50) & (score < 90)) {
    //     // 建議修正
    //     color = "#Fdb900";
    //   } else {
    //     // 正常運作
    //     color = "#7fb900";
    //   }
    // }

    if (score < 0) {
      score = 0;
    }

    return {
      tooltip: {
        show: false, // 去除鼠标hover提示框
      },
      title: {
        text: score,
        x: "center",
        y: "center",
        textStyle: {
          color: "#5f6988",
          fontSize: 24,
        },
      },
      series: [
        {
          type: "pie",
          name: "名稱",
          radius: ["80%", "100%"], // 环的宽度
          center: ["50%", "50%"],
          hoverAnimation: false, // 鼠标hover高亮隐藏
          label: {
            normal: {
              position: "inner",
              show: false,
            },
          },
          data: [
            {
              value: score,
              itemStyle: {
                normal: {
                  color: color,
                },
                label: {
                  show: false, // 去掉指示线
                },
                labelLine: {
                  show: false, // 去掉指示线
                },
              },
            },
            {
              value: 100 - score,
              itemStyle: {
                normal: {
                  color: "#d3daf5",
                },
                label: {
                  show: false, // 去掉指示线
                },
                labelLine: {
                  show: false, // 去掉指示线
                },
              },
            },
          ],
        },
      ],
    };
  };

  const callback = (key) => {
    // console.log(key)
    const newKey = key.filter(function (item) {
      // 第 0 個點了不要顯示
      return item != "0";
    });
    // console.log(newKey)
    setCollapseActiveKey(newKey);
  };

  /* api */
  const checkDataStreams = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.dataStreams
        .list({
          parent: property,
        })
        .then(
          function (response) {
            console.log(response);
            if (response.result.dataStreams) {
              let data = response.result.dataStreams.map((item) => {
                switch (item.type) {
                  case "WEB_DATA_STREAM": {
                    return (
                      "Web | " +
                      (item.displayName || item.name) +
                      " | " +
                      item.webStreamData.measurementId
                    );
                  }
                  case "ANDROID_APP_DATA_STREAM": {
                    return (
                      "Android | " +
                      (item.displayName || item.name) +
                      " | " +
                      item.androidAppStreamData.firebaseAppId
                    );
                  }
                  case "IOS_APP_DATA_STREAM": {
                    return (
                      "Ios | " +
                      (item.displayName || item.name) +
                      " | " +
                      item.iosAppStreamData.firebaseAppId
                    );
                  }
                  default: {
                    return (
                      "Unspecified | " +
                      (item.displayName || item.name) +
                      " | " +
                      item.measurementId
                    );
                  }
                }
              });
              console.log("2. dataStreams", data);
              setDataStreams(data);
              resolve(data);
            } else {
              console.log("2. dataStreams", []);
              setDataStreams([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("2. dataStreams", err);
            setDataStreams([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkWebDataStreams = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.dataStreams
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.webDataStreams) {
              let data = response.result.webDataStreams.map(
                (item) =>
                  "Web | " + item.displayName + " | " + item.measurementId
              );
              console.log("2. webDataStreams", data);
              setWebDataStreams(data);
              resolve(data);
            } else {
              console.log("2. webDataStreams", []);
              setWebDataStreams([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("2. webDataStreams", err);
            setWebDataStreams([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkAndroidAppDataStreams = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.androidAppDataStreams
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.androidAppDataStreams) {
              let data = response.result.androidAppDataStreams.map(
                (item) =>
                  "Android | " + item.displayName + " | " + item.firebaseAppId
              );
              console.log("2. androidAppDataStreams", data);
              setAndroidAppDataStreams(data);
              resolve(data);
            } else {
              console.log("2. androidAppDataStreams", []);
              setAndroidAppDataStreams([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("2. androidAppDataStreams error", err);
            setAndroidAppDataStreams([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkIosAppDataStreams = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.iosAppDataStreams
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.iosAppDataStreams) {
              let data = response.result.iosAppDataStreams.map(
                (item) =>
                  "Ios | " + item.displayName + " | " + item.firebaseAppId
              );
              console.log("2. iosAppDataStreams", data);
              setIosAppDataStreams(data);
              resolve(data);
            } else {
              console.log("2. iosAppDataStreams", []);
              setIosAppDataStreams([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("2. iosAppDataStreams error", err);
            setIosAppDataStreams([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkHostName = () => {
    return new Promise((resolve, reject) => {
      gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            dimensions: [
              {
                name: "hostName",
              },
            ],
            dateRanges: [
              {
                startDate: "30daysAgo",
                endDate: "yesterday",
              },
            ],
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              let data = response.result.rows.map(
                (item) => item.dimensionValues[0].value
              );
              data = data.filter((item) => !item.includes("not set"));
              console.log("3. checkHostName", data);
              setHostName(data);
              resolve(data);
            } else {
              console.log("3. checkHostName", []);
              setHostName([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkHostName error", err);
            setHostName([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkAttributionSettings = () => {
    // https://developers.google.com/analytics/devguides/config/admin/v1/rest/v1alpha/properties/getAttributionSettings?hl=zh-tw
    // https://developers.google.com/analytics/devguides/config/admin/v1/rest/v1alpha/AttributionSettings?hl=zh-tw
    // window.gapi.client.analyticsadmin.properties
    //     .getGoogleSignalsSettings({ name: property + "/googleSignalsSettings" })
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties
        .getAttributionSettings({
          name: property + "/attributionSettings",
        })
        .then(
          function (response) {
            console.log("checkAttributionSettings = ", response);
            if (response.result) {
              // reportingAttributionModel
              let reportingAttributionModel =
                response.result.reportingAttributionModel || "";
              setReportingAttributionModel(reportingAttributionModel);

              // acquisitionConversionEventLookbackWindow
              let acquisitionConversionEventLookbackWindow =
                response.result.acquisitionConversionEventLookbackWindow || "";
              setAcquisitionConversionEventLookbackWindow(
                acquisitionConversionEventLookbackWindow
              );

              // otherConversionEventLookbackWindow
              let otherConversionEventLookbackWindow =
                response.result.otherConversionEventLookbackWindow || "";
              setOtherConversionEventLookbackWindow(
                otherConversionEventLookbackWindow
              );

              resolve(response.result);
            }
          },
          function (err) {
            console.error("checkAttributionSettings error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkCrossDomain = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            dimensions: [
              {
                name: "pageReferrer",
              },
            ],
            dateRanges: [
              {
                startDate: "90daysAgo",
                endDate: "yesterday",
              },
            ],
            dimensionFilter: {
              filter: {
                fieldName: "pageReferrer",
                stringFilter: {
                  matchType: "CONTAINS",
                  value: "_gl=",
                },
              },
            },
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              let data = true;
              console.log("4. checkCrossDomain", data);
              setCrossDomain(data);
              resolve(data);
            } else {
              console.log("4. checkCrossDomain", false);
              setCrossDomain(false);
              resolve(false);
            }
          },
          function (err) {
            console.error("checkCrossDomain error", err);
            setCrossDomain(false);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkProperty = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties
        .get({
          name: property,
        })
        .then(
          function (response) {
            if (response.result) {
              console.log(
                "5. industryCategory",
                response.result.industryCategory || ""
              );
              setIndustryCategory(response.result.industryCategory || "");
              console.log(
                "7. currencyCode",
                response.result.currencyCode || ""
              );
              setCurrencyCode(response.result.currencyCode || "");
              console.log("6. timeZone", response.result.timeZone || "");
              setTimeZone(response.result.timeZone || "");
              setGa360(
                response.result.serviceLevel.includes("360") ? true : false
              );
              resolve(response.result);
            }
          },
          function (err) {
            console.error("checkProperty error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkGoogleSignalsSettings = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties
        .getGoogleSignalsSettings({ name: property + "/googleSignalsSettings" })
        .then(
          function (response) {
            if (response.result) {
              console.log(
                "8. checkGoogleSignalsSettings",
                response.result.state || ""
              );
              setGoogleSignalsSettings(response.result.state || "");
              resolve(response.result.state || "");
            } else {
              console.log("8. checkGoogleSignalsSettings", "");
              setGoogleSignalsSettings("");
              resolve("");
            }
          },
          function (err) {
            console.error("checkGoogleSignalsSettings error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkDataRetentionSettings = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties
        .getDataRetentionSettings({ name: property + "/dataRetentionSettings" })
        .then(
          function (response) {
            if (response.result) {
              console.log(
                "9. checkDataRetentionSettings",
                response.result.eventDataRetention || ""
              );
              setDataRetentionSettings(
                response.result.eventDataRetention || ""
              );
              resolve(response.result.eventDataRetention || "");
            }
          },
          function (err) {
            console.error("checkDataRetentionSettings error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkUserId = () => {
    return new Promise((resolve, reject) => {
      gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            dimensions: [
              {
                name: "signedInWithUserId",
              },
            ],
            dateRanges: [
              {
                startDate: "30daysAgo",
                endDate: "yesterday",
              },
            ],
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              let data = response.result.rows.some(
                (item) => item.dimensionValues[0].value === "yes"
              );
              console.log("18. checkUserId", data);
              setUserId(data);
              resolve(data);
            } else {
              console.log("18. checkUserId", false);
              setUserId(false);
              resolve(false);
            }
          },
          function (err) {
            console.error("18. checkUserId error", err);
            setUserId(false);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkUserProperties = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsdata.properties
        .getMetadata({ name: property + "/metadata" })
        .then(
          function (response) {
            if (response.result) {
              let data = response.result.dimensions
                .filter((item) => item.apiName.includes("customUser"))
                .map((item) => item.apiName);
              console.log("10. checkUserProperties", data);

              setUserProperties(data);

              resolve(data);
            }
          },
          function (err) {
            console.error("checkUserProperties error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkGoogleAds = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.googleAdsLinks
        .list({ parent: property })
        .then(
          function (response) {
            if (response.result.googleAdsLinks) {
              let data = response.result.googleAdsLinks.map(
                (item) => item.customerId
              );
              console.log("11. checkGoogleAds", data);
              setGoogleAdsLinks(data);
              resolve(data);
            } else {
              console.log("11. checkGoogleAds", []);
              setGoogleAdsLinks([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkGoogleAds error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkInteractionRate = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            metrics: [
              {
                name: "engagedSessions",
              },
              {
                name: "sessions",
              },
            ],
            dateRanges: [
              {
                startDate: "30daysAgo",
                endDate: "yesterday",
              },
            ],
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              let data = (
                (Number(response.result.rows[0].metricValues[0].value) /
                  Number(response.result.rows[0].metricValues[1].value)) *
                100
              ).toFixed(2);
              console.log("12. checkInteractionRate", data);
              setInteractionRate(data);
              resolve(data);
            } else {
              console.log("12. checkInteractionRate", 0);
              setInteractionRate(0);
              resolve(0);
            }
          },
          function (err) {
            console.error("checkInteractionRate error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkConversionEvents = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.conversionEvents
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.conversionEvents) {
              let data = response.result.conversionEvents
                .filter((item) => item.custom)
                .map((item) => item.eventName);
              console.log("13. checkConversionEvents", data);
              setConversionEvents(data);
              resolve(data);
            } else {
              console.log("13. checkConversionEvents", []);
              setConversionEvents([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkConversionEvents error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkAudience = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            metrics: [
              {
                name: "totalUsers",
              },
            ],
            dimensions: [
              {
                name: "audienceName",
              },
            ],
            dateRanges: [
              {
                startDate: "30daysAgo",
                endDate: "yesterday",
              },
            ],
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              let data_audience = response.result.rows
                .filter(
                  (item) =>
                    !item.dimensionValues[0].value.match(
                      /(All Users)|(Purchasers)|(未來 7 天)|(接下來 28 天)|(Likely 7-day)|(Predicted 28-day)/
                    )
                )
                .map((item) => {
                  return {
                    name: item.dimensionValues[0].value,
                    value: item.metricValues[0].value,
                  };
                });
              console.log("14. checkAudience", data_audience);
              setAudience(data_audience);
              let data_predicted = response.result.rows
                .filter((item) =>
                  item.dimensionValues[0].value.match(
                    /(未來 7 天)|(接下來 28 天)|(Likely 7-day)|(Predicted 28-day)/
                  )
                )
                .map((item) => {
                  return {
                    name: item.dimensionValues[0].value,
                    value: item.metricValues[0].value,
                  };
                });
              console.log("15. checkPredicted", data_predicted);
              setPredicted(data_predicted);
              resolve(data_predicted);
            } else {
              console.log("14. checkAudience", []);
              setAudience([]);
              console.log("15. checkPredicted", []);
              setPredicted([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkAudience error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkEccomerce = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            dimensions: [
              {
                name: "eventName",
              },
            ],
            metrics: [
              {
                name: "eventCount",
              },
            ],
            dateRanges: [
              {
                startDate: "30daysAgo",
                endDate: "yesterday",
              },
            ],
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              let data = [
                "add_payment_info",
                "add_shipping_info",
                "add_to_cart",
                "add_to_wishlist",
                "begin_checkout",
                "in_app_purchase",
                "purchase",
                "refund",
                "remove_from_cart",
                "select_item",
                "select_promotion",
                "view_cart",
                "view_item",
                "view_item_list",
                "view_promotion",
              ]
                .map((event) => {
                  const item = response.result.rows.find(
                    (item) => item.dimensionValues[0].value === event
                  );
                  if (item) {
                    return {
                      name: event,
                      value: item.metricValues[0].value,
                    };
                  } else {
                    return {
                      name: event,
                      value: "0",
                    };
                  }
                })
                .reduce(
                  (acc, cur) => {
                    if (
                      cur.name === "in_app_purchase" ||
                      cur.name === "purchase"
                    ) {
                      acc.find((item) => item.name === "purchase").value =
                        String(
                          Number(
                            acc.find((item) => item.name === "purchase").value
                          ) + Number(cur.value)
                        );
                    } else {
                      acc.push(cur);
                    }
                    return acc;
                  },
                  [
                    {
                      name: "purchase",
                      value: "0",
                    },
                  ]
                )
                .sort((a, b) =>
                  a.name < b.name ? -1 : a.name > b.name ? 1 : 0
                );
              console.log("16. checkEccomerce", data);

              setEccomerce(data);
              resolve(data);
            } else {
              console.log(
                "16. checkEccomerce",
                [
                  "add_payment_info",
                  "add_shipping_info",
                  "add_to_cart",
                  "add_to_wishlist",
                  "begin_checkout",
                  "in_app_purchase",
                  "purchase",
                  "refund",
                  "remove_from_cart",
                  "select_item",
                  "select_promotion",
                  "view_cart",
                  "view_item",
                  "view_item_list",
                  "view_promotion",
                ].map((item) => ({ name: item, value: 0 }))
              );
              setEccomerce(
                [
                  "add_payment_info",
                  "add_shipping_info",
                  "add_to_cart",
                  "add_to_wishlist",
                  "begin_checkout",
                  "in_app_purchase",
                  "purchase",
                  "refund",
                  "remove_from_cart",
                  "select_item",
                  "select_promotion",
                  "view_cart",
                  "view_item",
                  "view_item_list",
                  "view_promotion",
                ].map((item) => ({ name: item, value: 0 }))
              );
              resolve(
                [
                  "add_payment_info",
                  "add_shipping_info",
                  "add_to_cart",
                  "add_to_wishlist",
                  "begin_checkout",
                  "in_app_purchase",
                  "purchase",
                  "refund",
                  "remove_from_cart",
                  "select_item",
                  "select_promotion",
                  "view_cart",
                  "view_item",
                  "view_item_list",
                  "view_promotion",
                ].map((item) => ({ name: item, value: 0 }))
              );
            }
          },
          function (err) {
            console.error("checkEccomerce error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkMedium = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            dimensions: [
              {
                name: "sessionMedium",
              },
            ],
            metrics: [
              {
                name: "sessions",
              },
            ],
            dateRanges: [
              {
                startDate: "30daysAgo",
                endDate: "yesterday",
              },
            ],
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              let data = response.result.rows.reduce(
                (acc, cur) => {
                  switch (cur.dimensionValues[0].value) {
                    case "organic": {
                      acc.organic += Number(cur.metricValues[0].value);
                      break;
                    }
                    case "(none)": {
                      acc.none += Number(cur.metricValues[0].value);
                      break;
                    }
                    case "referral": {
                      acc.referral += Number(cur.metricValues[0].value);
                      break;
                    }
                    default: {
                      acc.others += Number(cur.metricValues[0].value);
                      break;
                    }
                  }
                  acc.session += Number(cur.metricValues[0].value);
                  return acc;
                },
                { organic: 0, none: 0, referral: 0, others: 0, session: 0 }
              );
              data = Object.entries(data).reduce((acc, cur) => {
                if (cur[0] !== "session") {
                  acc.push({
                    name: cur[0],
                    value: ((cur[1] / data.session) * 100).toFixed(2),
                  });
                }
                return acc;
              }, []);

              console.log("17. checkMedium", data);

              setMedium(data);
              resolve(data);
            } else {
              console.log("17. checkMedium", []);
              setMedium([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkMedium error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkWebDataStreamsMeasurementProtocol = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.webDataStreams
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.webDataStreams) {
              Promise.all(
                response.result.webDataStreams.map((item) => {
                  return new Promise((resolve, reject) => {
                    gapi.client.analyticsadmin.properties.webDataStreams.measurementProtocolSecrets
                      .list({
                        parent: item.name,
                      })
                      .then(
                        function (response) {
                          resolve(response.result);
                        },
                        function (err) {
                          console.error("Execute error", err);
                          resolve({});
                        }
                      );
                  });
                })
              ).then((values) => {
                var data = values
                  .filter((item) => Object.keys(item).length)
                  .map((item) => item.measurementProtocolSecrets)
                  .reduce((acc, cur) => {
                    cur.map((item) => {
                      acc.push({
                        type: "Web",
                        name: item.displayName,
                        key: item.secretValue,
                      });
                    });
                    return acc;
                  }, []);
                console.log("19. webDataStreamsMeasurementProtocol", data);
                setWebDataStreamsMeasurementProtocol(data);
                resolve(data);
              });
            } else {
              console.log("19. webDataStreamsMeasurementProtocol", []);
              setWebDataStreamsMeasurementProtocol([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("19. webDataStreamsMeasurementProtocol", err);
            setWebDataStreamsMeasurementProtocol([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkAndroidAppDataStreamsMeasurementProtocol = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.androidAppDataStreams
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.androidAppDataStreams) {
              Promise.all(
                response.result.androidAppDataStreams.map((item) => {
                  return new Promise((resolve, reject) => {
                    gapi.client.analyticsadmin.properties.androidAppDataStreams.measurementProtocolSecrets
                      .list({
                        parent: item.name,
                      })
                      .then(
                        function (response) {
                          resolve(response.result);
                        },
                        function (err) {
                          console.error("Execute error", err);
                          resolve({});
                        }
                      );
                  });
                })
              ).then((values) => {
                var data = values
                  .filter((item) => Object.keys(item).length)
                  .map((item) => item.measurementProtocolSecrets)
                  .reduce((acc, cur) => {
                    cur.map((item) => {
                      acc.push({
                        type: "Android",
                        name: item.displayName,
                        key: item.secretValue,
                      });
                    });
                    return acc;
                  }, []);
                console.log("19. androidDataStreamsMeasurementProtocol", data);
                setAndroidAppDataStreamsMeasurementProtocol(data);
                resolve(data);
              });
            } else {
              console.log("19. androidDataStreamsMeasurementProtocol", []);
              setAndroidAppDataStreamsMeasurementProtocol([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("19. androidDataStreamsMeasurementProtocol", err);
            setAndroidAppDataStreamsMeasurementProtocol([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkIosAppDataStreamsMeasurementProtocol = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.iosAppDataStreams
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.iosAppDataStreams) {
              Promise.all(
                response.result.iosAppDataStreams.map((item) => {
                  return new Promise((resolve, reject) => {
                    gapi.client.analyticsadmin.properties.iosAppDataStreams.measurementProtocolSecrets
                      .list({
                        parent: item.name,
                      })
                      .then(
                        function (response) {
                          resolve(response.result);
                        },
                        function (err) {
                          console.error("Execute error", err);
                          resolve({});
                        }
                      );
                  });
                })
              ).then((values) => {
                var data = values
                  .filter((item) => Object.keys(item).length)
                  .map((item) => item.measurementProtocolSecrets)
                  .reduce((acc, cur) => {
                    cur.map((item) => {
                      item.type = "Ios";
                      acc.push({
                        type: "Ios",
                        name: item.displayName,
                        key: item.secretValue,
                      });
                    });
                    return acc;
                  }, []);
                console.log("19. iosDataStreamsMeasurementProtocol", data);
                setIosAppDataStreamsMeasurementProtocol(data);
                resolve(data);
              });
            } else {
              console.log("19. iosDataStreamsMeasurementProtocol", []);
              setIosAppDataStreamsMeasurementProtocol([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("19. iosDataStreamsMeasurementProtocol", err);
            setIosAppDataStreamsMeasurementProtocol([]);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkGoogleCPCTrans = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            dimensions: [{ name: "sessionSource" }, { name: "sessionMedium" }],
            metrics: [{ name: "eventCount" }],
            dimensionFilter: {
              andGroup: {
                expressions: [
                  {
                    filter: {
                      fieldName: "isConversionEvent",
                      stringFilter: {
                        matchType: "EXACT",
                        value: "true",
                      },
                    },
                  },
                ],
              },
            },
            dateRanges: [
              {
                startDate: "30daysAgo",
                endDate: "yesterday",
              },
            ],
            limit: 100000,
          },
        })
        .then(
          function (response) {
            if (response.result.rows) {
              console.log(response);

              var total = response.result.rows.reduce((acc, cur) => {
                acc = acc += parseInt(cur.metricValues[0].value, 10);
                return acc;
              }, 0);

              var googleCpc = response.result.rows.reduce((acc, cur) => {
                if (
                  cur.dimensionValues[0].value === "google" &&
                  cur.dimensionValues[1].value === "cpc"
                ) {
                  acc = acc += parseInt(cur.metricValues[0].value, 10);
                }
                return acc;
              }, 0);

              var data = Math.floor((googleCpc / total) * 100);

              console.log("20. checkGoogleCPCTrans", googleCpc, total, data);

              setGoogleCPCTrans(data);
              resolve(data);
            } else {
              console.log("20. checkGoogleCPCTrans", []);
              setGoogleCPCTrans([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkGoogleCPCTrans error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkUnassigned = () => {
    return new Promise((resolve, reject) => {
      gapi.client.analyticsdata.properties
        .runReport({
          property: property,
          resource: {
            dimensions: [
              { name: "sessionDefaultChannelGrouping" },
              { name: "sessionMedium" },
              { name: "sessionSource" },
            ],
            metrics: [{ name: "totalUsers" }],
            dateRanges: [{ startDate: "90daysAgo", endDate: "yesterday" }],
            metricAggregations: ["TOTAL"],
          },
        })
        .then(
          function (response) {
            console.log(response);
            if (response.result.rows) {
              var total = response.result.rows.reduce((acc, cur) => {
                acc = acc += parseInt(cur.metricValues[0].value, 10);
                return acc;
              }, 0);
              var unassigned = response.result.rows.reduce((acc, cur) => {
                if (
                  cur.dimensionValues[0].value === "Unassigned" &&
                  cur.dimensionValues[1].value === "(not set)" &&
                  cur.dimensionValues[2].value === "(not set)"
                ) {
                  acc = acc += parseInt(cur.metricValues[0].value, 10);
                }
                return acc;
              }, 0);
              var data = Math.floor((unassigned / total) * 100);

              console.log("21. checkUnassigned", data, unassigned, total);
              setUnassigned(data);
              resolve(data);
            } else {
              console.log("21. checkUnassigned", 0);
              setUnassigned(0);
              resolve(0);
            }
          },
          function (err) {
            console.error("21. checkUnassigned error", err);
            setUnassigned(0);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  const checkConversionEventsDefault = () => {
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.conversionEvents
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.conversionEvents) {
              let data = response.result.conversionEvents
                .filter((item) => {
                  return [
                    "session_start",
                    "scroll",
                    "page_view",
                    "first_visit",
                    "click",
                    "app_clear_data",
                    "app_exception",
                    "app_remove",
                    "app_store_refund",
                    "app_store_subscription_cancel",
                    "dynamic_link_app_open",
                    "dynamic_link_app_update",
                    "first_open",
                    "first_visit",
                    "notification_dismiss",
                    "notification_foreground",
                    "notification_open",
                    "notification_receive",
                    "os_update",
                    "screen_view",
                  ].find((event) => item.eventName === event);
                })
                .map((item) => item.eventName);
              console.log("22. checkConversionEventsDefault", data);
              setConversionEventsDefault(data);
              resolve(data);
            } else {
              console.log("22. checkConversionEventsDefault", []);
              setConversionEventsDefault([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkConversionEventsDefault error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };
  /* api end */

  /* 市場 api start */
  const checkMarketCompare = () => {
    // console.log("checkMarketCompare loginEmail:", google_user_email);
    // console.log("propertyID loginEmail:", property.replace("properties/", ""));
    var url = "https://freeanalysisapi.turingdigital.com.tw/market_performance";
    var data = {
      loginEmail: google_user_email,
      propertyID: property.replace("properties/", ""),
    };

    $.post(url, data)
      .done(function (response) {
        const statusArr = ["數據異常", "低於平均值", "高於平均值"];
        console.log("checkMarketCompare Success:", response);
        setMarketCompare(response);

        setCheckListCompareResult(
          checkListCompareResult.map((item) => {
            console.log("🚀 ~ checkListCompareResult.map ~ item:", item);

            if (item.type === "checkConversionRate") {
              console.log(
                "🚀 ~ checkListCompareResult.map ~ item: checkConversionRate"
              );
              return {
                ...item,
                value: response.average_daily_purchase[0],
                status: statusArr[response.average_daily_purchase[2]],
                // result: "有轉換",
              };
            }
            if (item.type === "checkAddToCartRate") {
              console.log(
                "🚀 ~ checkListCompareResult.map ~ item: checkAddToCartRate"
              );
              return {
                ...item,
                value: response.average_daily_addToCart[0],
                status: statusArr[response.average_daily_addToCart[2]],
                // result: "有轉換",
              };
            }
            if (item.type === "checkEngagementRate") {
              console.log(
                "🚀 ~ checkListCompareResult.map ~ item: checkEngagementRate"
              );
              return {
                ...item,
                value: response.engagement_rate[0],
                status: statusArr[response.engagement_rate[2]],
                // result: "有轉換",
              };
            }
            if (item.type === "checkSessions") {
              console.log(
                "🚀 ~ checkListCompareResult.map ~ item: checkSessions"
              );
              return {
                ...item,
                value: response.sessions[0],
                status: statusArr[response.sessions[2]],
                // result: "有轉換",
              };
            }
            return item;
          })
        );
      })
      .fail(function (xhr, status, error) {
        console.error("Error:", status, error);
        setMarketCompare(0);
      });
    return new Promise((resolve, reject) => {
      window.gapi.client.analyticsadmin.properties.conversionEvents
        .list({
          parent: property,
        })
        .then(
          function (response) {
            if (response.result.conversionEvents) {
              let data = response.result.conversionEvents
                .filter((item) => {
                  return [
                    "session_start",
                    "scroll",
                    "page_view",
                    "first_visit",
                    "click",
                    "app_clear_data",
                    "app_exception",
                    "app_remove",
                    "app_store_refund",
                    "app_store_subscription_cancel",
                    "dynamic_link_app_open",
                    "dynamic_link_app_update",
                    "first_open",
                    "first_visit",
                    "notification_dismiss",
                    "notification_foreground",
                    "notification_open",
                    "notification_receive",
                    "os_update",
                    "screen_view",
                  ].find((event) => item.eventName === event);
                })
                .map((item) => item.eventName);
              console.log("22. checkConversionEventsDefault", data);
              setConversionEventsDefault(data);
              resolve(data);
            } else {
              console.log("22. checkConversionEventsDefault", []);
              setConversionEventsDefault([]);
              resolve([]);
            }
          },
          function (err) {
            console.error("checkConversionEventsDefault error", err);
            setGoogleApiFalse(true);
            reject(err);
          }
        );
    });
  };

  /* 市場 api end */

  const resetTableData = () => {
    setDataStreams(null);
    // setWebDataStreams(null)
    // setAndroidAppDataStreams(null)
    // setIosAppDataStreams(null)
    setHostName(null);
    setCrossDomain(null);
    setIndustryCategory(null);
    setCurrencyCode(null);
    setTimeZone(null);
    setGa360(null);
    setGoogleSignalsSettings(null);
    setDataRetentionSettings(null);
    setUserProperties(null);
    setGoogleAdsLinks(null);
    setAudience(null);
    setPredicted(null);
    setInteractionRate(null);
    setConversionEvents(null);
    setEccomerce(null);
    setMedium(null);
    setUserId(null);
    setScore(0);
    setPrScore(0);
    // setWebDataStreamsMeasurementProtocol(null)
    // setAndroidAppDataStreamsMeasurementProtocol(null)
    // setIosAppDataStreamsMeasurementProtocol(null)
    setGoogleCPCTrans(null);
    setUnassigned(null);
    setReportingAttributionModel(null);
    setAcquisitionConversionEventLookbackWindow(null);
    setOtherConversionEventLookbackWindow(null);
    setMarketCompare(null);

    setConversionEventsDefault(null);

    setCheckListResult(checkListInit);
    setCheckListCompareResult(CheckListCompareInit);
  };

  const getStatusIcon = (name) => {
    if (name === "尚未檢核") {
      const color = "#000";

      return (
        <>
          <MinusCircleFilled style={{ color: color, marginRight: "8px" }} />
          <span style={{ color: color }}>{name}</span>
        </>
      );
    } else if (name === "建議修正") {
      const color = "#fdb900";

      return (
        <>
          <WarningFilled style={{ color: color, marginRight: "8px" }} />
          <span style={{ color: color }}>{name}</span>
        </>
      );
    } else if (name === "數據異常") {
      const color = "#f90000";

      return (
        <>
          <CloseCircleFilled style={{ color: color, marginRight: "8px" }} />
          <span style={{ color: color }}>{name}</span>
        </>
      );
    } else if (name === "正常運作") {
      const color = "#7fb900";

      return (
        <>
          <CheckCircleFilled style={{ color: color, marginRight: "8px" }} />
          <span style={{ color: color }}>{name}</span>
        </>
      );
    }
  };

  const openSuccessModal = () => {
    Modal.success({
      content: "表單送出成功！我們會同步發送一封信件，請確認信箱內容！",
    });
  };

  const openNoticeModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const timesWaringModalOk = () => {
    utilsIndex.sendGAEvent("come_back_tomorrow");
    setIsTimesWaringModalVisible(false);
  };

  const timesWaringModalCancel = () => {
    setIsTimesWaringModalVisible(false);
  };

  const timesWaringModalAnswerNo = () => {
    utilsIndex.sendGAEvent("want_some_help");
    window.open("https://www.turingdigital.com.tw/chek-website");
  };

  const starModalOk = () => {
    // utilsIndex.sendGAEvent("i_have_GA4");
    // docCookies.setItem("startModalCancel_Infinity", 1, Infinity, "/");
    setIsStarModalVisible(false);
  };

  const starModalCancel = () => {
    // utilsIndex.sendGAEvent("i_dont_know");
    setIsStarModalVisible(false);
  };

  const starModal = () => {
    utilsIndex.sendGAEvent("have_problem", {
      turing_01: "? 找不到 GA4 帳戶？",
      turing_02: "Check Assistant頁",
    });
    setIsStarModalVisible(true);
  };

  const handleSubmitFloatForm = (values) => {
    if (!isSubmitFloatForm) {
      setIsSubmitFloatForm(true);

      // utilsIndex.sendGAEvent("submit");

      console.log("🚀 ~ checkListResult:", checkListResult);
      const checkListResultError = checkListResult.filter((item) => {
        if (item.status == "數據異常" || item.status == "建議修正") {
          return true;
        }
      });
      console.log("🚀 ~ checkListResultError:", checkListResultError);

      const checkListCompareResultError = checkListCompareResult.filter(
        (item) => {
          if (item.status == "數據異常" || item.status == "低於平均值") {
            return true;
          }
        }
      );
      console.log("🚀 ~ checkListCompareResult:", checkListCompareResult);
      console.log(
        "🚀 ~ checkListCompareResultError:",
        checkListCompareResultError
      );

      const ResultError = [
        ...checkListResultError,
        ...checkListCompareResultError,
      ];
      console.log("🚀 ~ ResultError:", ResultError);

      const items = ResultError.map((item) => {
        return {
          name: item.name.tw,
          value: item.status,
        };
      });
      console.log("🚀 ~ items:", items);

      let apiData = {
        main: {
          ...checkListSummaries.main,
          Contact: true,
          Contact_Name: values.contact.name,
          Contact_Phone: values.contact.phone,
          Contact_Email: values.contact.email,
          Contact_Others: values.contact.others ? values.contact.others : "",
          Contact_Items: items,
          Contact_Time: Array.isArray(values.contact.time)
            ? values.contact.time
            : [],
          Contact_Topics: [],
        },
      };

      console.log("apiData float submit = ", apiData);

      setCheckListSummaries(apiData);

      // 本地測試不用送 api
      if (isProduction) {
        Modal.success({
          content: "表單送出中請稍候！",
        });

        utilsIndex.sendGAEvent("form_submit", {
          turing_01: "彈跳視窗表單",
          turing_02: "Check Assistant頁",
        });
        fbq("trackCustom", "form_submit");

        axios
          .post(
            `https://freeanalysisapi.turingdigital.com.tw/mains_batch/${apiId}`,
            apiData
          )
          .then(function (response) {
            // console.log("mains_batch submit = ", response)
            Modal.destroyAll();
            openSuccessModal();
          })
          .catch(function (error) {
            console.log("mains_batch flaot submit error = ", error);
          });
      }
    }
  };
  const handleSubmitContactForm = (values, options = {}) => {
    const { formType = "legacy" } = options;

    if (!isSubmitContactForm) {
      setIsSubmitContactForm(true);

      utilsIndex.sendGAEvent("submit");
      // openNotification()

      // setCheckListSummaries({
      //   ...checkListSummaries,
      //   Contact: true,
      //   Contact_Name: values.contact.name,
      //   Contact_Phone: values.contact.phone,
      //   Contact_Email: values.contact.email,
      //   Contact_Others: values.contact.others,
      //   // Contact_Items: [],
      //   Contact_Time: values.contact.time,
      // })

      // let apiData = Object.assign({}, checkListSummaries)

      console.log("🚀 ~ checkListResult:", checkListResult);
      const checkListResultError = checkListResult.filter((item) => {
        if (item.status == "數據異常" || item.status == "建議修正") {
          return true;
        }
      });
      console.log("🚀 ~ checkListResultError:", checkListResultError);

      const checkListCompareResultError = checkListCompareResult.filter(
        (item) => {
          if (item.status == "數據異常" || item.status == "低於平均值") {
            return true;
          }
        }
      );
      console.log("🚀 ~ checkListCompareResult:", checkListCompareResult);
      console.log(
        "🚀 ~ checkListCompareResultError:",
        checkListCompareResultError
      );

      const ResultError = [
        ...checkListResultError,
        ...checkListCompareResultError,
      ];
      console.log("🚀 ~ ResultError:", ResultError);

      // 🎯 根據 formType 決定 Contact_Items 的資料來源
      let items;
      if (formType === "snapshot") {
        // 新版表單：使用六力比較資料
        items = industryComparisonMetrics.map((item) => {
          return {
            name: item.name.tw,
            value: item.status,
          };
        });
      } else {
        // 舊版表單：使用錯誤檢測項目
        items = ResultError.map((item) => {
          return {
            name: item.name.tw,
            value: item.status,
          };
        });
      }
      console.log("🚀 ~ items:", items);

      let apiData = {
        main: {
          ...checkListSummaries.main,
          ...(formType === "snapshot" && { snapshot: 1 }),
          Contact: true,
          Contact_Name: values.contact.name,
          Contact_Phone: values.contact.phone,
          Contact_Email: values.contact.email,
          Contact_Others: values.contact.others ? values.contact.others : "",
          Contact_Items: items,
          Contact_Time: Array.isArray(values.contact.time)
            ? values.contact.time
            : [],
          Contact_Topics: [values.contact.topics]
            ? [values.contact.topics]
            : [],
        },
      };

      console.log("apiData submit = ", apiData);

      setCheckListSummaries(apiData);

      // 本地測試不用送 api
      if (isProduction) {
        Modal.success({
          content: "表單送出中請稍候！",
        });

        fbq("trackCustom", "form_submit");

        // 🎯 根據 formType 決定使用哪個 API
        if (formType === "snapshot") {
          // 新版表單：使用 double11/connect API
          utilsIndex.sendGAEvent("form_submit", {
            turing_01: "客製化服務表單",
            turing_02: "即時數據分析室",
          });

          const snapshotApiData = {
            main: {
              Contact_Name: values.contact.name,
              Contact_Phone: values.contact.phone,
              Contact_Email: values.contact.email,
              Contact_Others: values.contact.others
                ? values.contact.others
                : "",
              Contact_Items: items,
              Contact_Topics: values.contact.topics
                ? [values.contact.topics]
                : [],
              PropertyID: property,
            },
          };

          console.log("snapshot API data = ", snapshotApiData);

          axios
            .post(
              `https://freeanalysisapi.turingdigital.com.tw/double11/connect`,
              snapshotApiData
            )
            .then(function (response) {
              console.log("double11/connect submit = ", response);
              Modal.destroyAll();
              openSuccessModal();
            })
            .catch(function (error) {
              console.log("double11/connect submit error = ", error);
            });
        } else {
          // 舊版表單：使用原本的 mains_batch API

          utilsIndex.sendGAEvent("form_submit", {
            turing_01: "客製化服務表單",
            turing_02: "Check Assistant頁",
          });

          axios
            .post(
              `https://freeanalysisapi.turingdigital.com.tw/mains_batch/${apiId}`,
              apiData
            )
            .then(function (response) {
              // console.log("mains_batch submit = ", response)
              Modal.destroyAll();
              openSuccessModal();
            })
            .catch(function (error) {
              console.log("mains_batch submit error = ", error);
            });
        }
      }
    }
  };

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  useEffect(() => {
    // 每當 score 更新，更新 scoreRef 的當前值
    scoreRef.current = score;
  }, [score]);

  // 滾動頁面顯示浮動提示
  useEffect(() => {
    // 建立 MutationObserver 來偵測元素是否出現
    const mutationObserver = new MutationObserver(() => {
      const target = document.querySelector(".score-1 .show-table");
      // console.log("target = ", target);
      // console.log("score = ", score);
      // console.log("current score = ", scoreRef.current); // 使用 ref 確保獲取最新的 score

      if (target) {
        // 一旦元素出現，開始使用 IntersectionObserver 監控
        const intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              if (scoreRef.current > 0) {
                // console.log("顯示浮動按鈕 ====");
                setIsFloatFormNotificationVisible(true);
                intersectionObserver.disconnect(); // 停止觀察
                mutationObserver.disconnect(); // 停止 MutationObserver
              }
            }
          },
          {
            root: null,
            threshold: 0, // 元素任何部分出現即觸發
          }
        );
        intersectionObserver.observe(target);
      }
    });

    // 監聽 body 的變動
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      mutationObserver.disconnect(); // 清理 observer
    };
  }, [score]);

  // 🎯 點擊即時報表影片時顯示 Modal
  const handleRealTimeVideoClick = () => {
    setIsRealTimeModalVisible(true);
    setHasShownRealTimeModal(true);

    // 🎯 發送點擊事件到 GA（僅在 /rtga 頁面）
    if (isRtgaPage) {
      utilsIndex.sendGAEvent("rtga_click");
    }
  };

  // 🎯 同步行業綜合評比兩個圖表標題的高度
  useEffect(() => {
    const syncChartTitleHeight = () => {
      if (leftChartTitleRef.current && rightChartTitleRef.current) {
        // 先重置右邊的 min-height，以便正確測量左邊的高度
        rightChartTitleRef.current.style.minHeight = "auto";

        // 測量左邊標題的實際高度
        const leftHeight = leftChartTitleRef.current.offsetHeight;

        // 設定右邊標題的最小高度
        rightChartTitleRef.current.style.minHeight = `${leftHeight}px`;
      }
    };

    // 初始同步
    syncChartTitleHeight();

    // 監聽視窗 resize 事件
    window.addEventListener("resize", syncChartTitleHeight);

    // 使用 setTimeout 確保 DOM 完全渲染後再同步
    const timer = setTimeout(syncChartTitleHeight, 100);

    return () => {
      window.removeEventListener("resize", syncChartTitleHeight);
      clearTimeout(timer);
    };
  }, [propertyDisplayName, snapshotData]); // 當資源名稱或資料改變時重新同步

  /* score */
  const calcNumber = () => {
    let number = 100;
    dataStreams;
    if (
      dataStreams.length
      // webDataStreams.length ||
      // iosAppDataStreams.length ||
      // androidAppDataStreams.length
    ) {
    } else {
      number -= 15;
    }
    // hostName
    if (hostName.length) {
    } else {
      number -= 15;
    }
    // crossDomain
    if (hostName.length >= 2 && crossDomain) {
    } else if (hostName.length >= 2 && !crossDomain) {
      number -= 5;
    } else if (hostName.length == 1 && !crossDomain) {
    } else if (!hostName.length) {
      number -= 5;
    }
    // industryCategory
    if (industryCategory) {
    } else {
      number -= 15;
    }
    // timeZone
    if (timeZone) {
    } else {
      number -= 10;
    }
    // googleSignalsSettings
    if (googleSignalsSettings !== "GOOGLE_SIGNALS_ENABLED") {
      number -= 15;
    }
    // dataRetentionSettings
    if (
      dataRetentionSettings !== "FOURTEEN_MONTHS" &&
      dataRetentionSettings !== "FIFTY_MONTHS"
    ) {
      number -= 15;
    }
    // userProperties
    if (!userProperties.length) {
      number -= 0;
    }
    // googleAdsLinks
    if (!googleAdsLinks.length) {
      number -= 0;
    }
    // interactionRate
    // if (Number(interactionRate) < 80) {
    //   number -= 5;
    // } else if (Number(interactionRate) > 100) {
    //   number -= 10;
    // }
    // 非預設轉換事件
    if (!conversionEvents.length) {
      number -= 15;
    }
    // audience
    if (!audience.length) {
      number -= 5;
    }
    // predicted
    if (!predicted.length) {
      number -= 5;
    }
    // eccomerce
    if (
      eccomerce
        .filter((item) => Number(item.value) === 0)
        .filter((item) => item.name !== "purchase").length
    ) {
      number -= 15;
    }
    // medium
    if (!medium.length) {
      number -= 5;
    }
    // userid
    if (!userId) {
      number -= 0;
    }

    // reportingAttributionModel
    if (
      reportingAttributionModel == "REPORTING_ATTRIBUTION_MODEL_UNSPECIFIED"
    ) {
      number -= 15;
    }

    // acquisitionConversionEventLookbackWindow
    if (
      acquisitionConversionEventLookbackWindow ==
      "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED"
    ) {
      number -= 15;
    }

    // otherConversionEventLookbackWindow
    if (
      otherConversionEventLookbackWindow ==
      "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED"
    ) {
      number -= 15;
    }

    // Measurement Protocol (不扣分)
    // if (
    //   !webDataStreamsMeasurementProtocol.length &&
    //   !androidAppDataStreamsMeasurementProtocol.length &&
    //   !iosAppDataStreamsMeasurementProtocol.length
    // ) {
    //   number -= 8
    // }

    // Google Ads 轉換成效 (不扣分)
    // if (!googleCPCTrans.length) {
    //   number -= 8
    // }

    if (unassigned >= 2) {
      number -= 5;
    }

    setScore(number <= 0 ? 1 : number);
  };

  useEffect(() => {
    if (
      dataStreams !== null &&
      // webDataStreams !== null &&
      // androidAppDataStreams !== null &&
      // iosAppDataStreams !== null &&
      hostName !== null &&
      crossDomain !== null &&
      industryCategory !== null &&
      currencyCode !== null &&
      timeZone !== null &&
      googleSignalsSettings !== null &&
      dataRetentionSettings !== null &&
      userProperties !== null &&
      googleAdsLinks !== null &&
      audience !== null &&
      predicted !== null &&
      // interactionRate !== null &&
      conversionEvents !== null &&
      eccomerce !== null &&
      medium !== null &&
      // webDataStreamsMeasurementProtocol !== null &&
      // androidAppDataStreamsMeasurementProtocol !== null &&
      // iosAppDataStreamsMeasurementProtocol !== null &&
      googleCPCTrans !== null &&
      unassigned !== null &&
      reportingAttributionModel !== null &&
      acquisitionConversionEventLookbackWindow !== null &&
      otherConversionEventLookbackWindow !== null
    ) {
      console.log("userId ======", userId);
      // 計算分數
      calcNumber();
    }
  }, [
    dataStreams,
    // webDataStreams,
    // androidAppDataStreams,
    // iosAppDataStreams,
    hostName,
    crossDomain,
    industryCategory,
    currencyCode,
    timeZone,
    googleSignalsSettings,
    dataRetentionSettings,
    userProperties,
    googleAdsLinks,
    interactionRate,
    conversionEvents,
    audience,
    predicted,
    eccomerce,
    medium,
    userId,
    // webDataStreamsMeasurementProtocol,
    // androidAppDataStreamsMeasurementProtocol,
    // iosAppDataStreamsMeasurementProtocol,
    googleCPCTrans,
    unassigned,
    reportingAttributionModel,
    acquisitionConversionEventLookbackWindow,
    otherConversionEventLookbackWindow,
  ]);

  const getCheckListItemStatus = (pItem) => {
    // switch (pItem.type) {
    switch (pItem.status) {
      case null: {
        // 當 status 為 null 時，表示無資料
        return (
          <>
            <MinusCircleFilled style={{ color: "#999", marginRight: "8px" }} />
            <span style={{ color: "#999" }}>--</span>
          </>
        );
      }
      case "正常運作":
      case "高於平均值": {
        return (
          <>
            <CheckCircleFilled
              style={{ color: "#7fb900", marginRight: "8px" }}
            />
            <span style={{ color: "#7fb900" }}>{pItem.status}</span>
          </>
        );
      }
      case "等於平均值": {
        return (
          <>
            <WarningFilled style={{ color: "#fdb900", marginRight: "8px" }} />
            <span style={{ color: "#fdb900" }}>{pItem.status}</span>
          </>
        );
      }
      case "建議修正":
      case "低於平均值": {
        return (
          <>
            <CloseCircleFilled
              style={{ color: "#f90000", marginRight: "8px" }}
            />
            <span style={{ color: "#f90000" }}>{pItem.status}</span>
          </>
        );
      }
      case "數據異常": {
        return (
          <>
            <CloseCircleFilled
              style={{ color: "#f90000", marginRight: "8px" }}
            />
            <span style={{ color: "#f90000" }}>{pItem.status}</span>
          </>
        );
      }
      default: {
        return (
          <>
            <MinusCircleFilled />
            {
              checkListResult.filter(function (item, index, array) {
                return item.type === pItem.type;
              }).status
            }
          </>
        );
      }
    }
  };
  const getCheckListItemResult = (pItem) => {
    switch (pItem.type) {
      case "checkProperty": {
        if (property) {
          return <>{property}</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkDataStreams": {
        if (
          dataStreams !== null
          // webDataStreams !== null &&
          // iosAppDataStreams !== null &&
          // androidAppDataStreams !== null
        ) {
          if (
            dataStreams.length
            // webDataStreams.length ||
            // iosAppDataStreams.length ||
            // androidAppDataStreams.length
          ) {
            return (
              <>
                {dataStreams.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
                {/*
                {webDataStreams.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
                {iosAppDataStreams.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
                {androidAppDataStreams.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              */}
              </>
            );
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkHostName": {
        if (
          hostName !== null &&
          dataStreams !== null
          // webDataStreams !== null &&
          // iosAppDataStreams !== null &&
          // androidAppDataStreams !== null
        ) {
          if (hostName.length) {
            return (
              <>
                {hostName.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              </>
            );
          } else if (
            !hostName.length &&
            dataStreams.length
            // (webDataStreams.length ||
            //   iosAppDataStreams.length ||
            //   androidAppDataStreams.length)
          ) {
            return <span style={{ color: "#f90000" }}>查無網域</span>;
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkCrossDomain": {
        if (crossDomain !== null) {
          return (
            <>
              {crossDomain ? (
                "有跨網追蹤"
              ) : (
                <div>
                  無跨網追蹤（若剛設定完畢，可能會有數據延遲，請耐心等候至少24小時）
                  <p style={{ color: "#f90000" }}>
                    請注意！只要在「追蹤網域數量項目」檢測超過 1
                    個以上的網域，但是沒有偵測到跨網域追蹤，就會被判定為異常。
                  </p>
                </div>
              )}
            </>
          );
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkIndustryCategory": {
        if (industryCategory !== null) {
          if (industryCategory) {
            return <>{industryCategory}</>;
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkTimeZone": {
        if (timeZone !== null) {
          return <>{timeZone}</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkCurrencyCode": {
        if (currencyCode !== null) {
          return <>{currencyCode}</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkGoogleSignalsSettings": {
        if (googleSignalsSettings !== null) {
          if (googleSignalsSettings) {
            return <>{googleSignalsSettings}</>;
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkDataRetentionSettings": {
        if (dataRetentionSettings !== null) {
          return (
            <>
              {ga360 ? "360 | " : ""} {dataRetentionSettings}
            </>
          );
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkUserProperties": {
        if (userProperties !== null) {
          if (userProperties.length) {
            return (
              <>
                {userProperties.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              </>
            );
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkGoogleAdsLinks": {
        if (googleAdsLinks !== null) {
          if (googleAdsLinks.length) {
            return (
              <>
                {googleAdsLinks.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              </>
            );
          } else {
            return <span style={{ color: "#f90000" }}>未串接</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkInteractionRate": {
        if (interactionRate !== null) {
          return <>{interactionRate}%</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkConversionEvents": {
        if (conversionEvents !== null) {
          if (conversionEvents.length) {
            return (
              <>
                {conversionEvents.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              </>
            );
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkAudience": {
        if (audience !== null) {
          if (audience.length) {
            return (
              <>
                {audience.map((item, index) => (
                  <div key={index}>
                    <Tag
                      color={Number(item.value) ? "#87d068" : "#f90000"}
                      style={{ width: "96px", textAlign: "center" }}
                    >
                      {item.value}
                    </Tag>{" "}
                    {item.name}
                  </div>
                ))}
              </>
            );
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkPredicted": {
        if (predicted !== null) {
          if (predicted.length) {
            return (
              <>
                {predicted.map((item, index) => (
                  <div key={index}>
                    <Tag
                      color={Number(item.value) ? "#87d068" : "#f90000"}
                      style={{ width: "96px", textAlign: "center" }}
                    >
                      {item.value}
                    </Tag>{" "}
                    {item.name}
                  </div>
                ))}
              </>
            );
          } else {
            return <span style={{ color: "#f90000" }}>未啟用</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkEccomerce": {
        if (eccomerce !== null) {
          return (
            <>
              {eccomerce.map((item, index) => (
                <div key={index}>
                  <Tag
                    color={Number(item.value) ? "#87d068" : "#f90000"}
                    style={{ width: "96px", textAlign: "center" }}
                  >
                    {item.value}
                  </Tag>{" "}
                  {item.name}
                </div>
              ))}
            </>
          );
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkMedium": {
        if (medium !== null) {
          if (medium.length) {
            return (
              <>
                {medium.map((item, index) => (
                  <div key={index}>
                    <Tag
                      color="#87d068"
                      style={{ width: "96px", textAlign: "center" }}
                    >
                      {item.value + "%"}
                    </Tag>{" "}
                    {item.name}
                  </div>
                ))}
              </>
            );
          } else {
            return <span style={{ color: "#f90000" }}>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkUserId": {
        if (userId !== null) {
          if (userId) {
            return <span>已設定</span>;
          } else {
            return <span>未設定</span>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkDataStreamsMeasurementProtocol": {
        if (
          webDataStreamsMeasurementProtocol !== null &&
          androidAppDataStreamsMeasurementProtocol !== null &&
          iosAppDataStreamsMeasurementProtocol !== null
        ) {
          var result = pItem.result;
          console.log("checkDataStreamsMeasurementProtocol result = ", result);

          if (result != "未申請") {
            return (
              <>
                {pItem.value.map((item, index) => (
                  <div key={index}>{item.key}</div>
                ))}
              </>
            );
          } else {
            return <>{result}</>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkGoogleCPCTrans": {
        if (googleCPCTrans !== null) {
          var result = pItem.result;
          // console.log("googleCPCTrans result = ", result);

          if (googleCPCTrans) {
            return <>{googleCPCTrans}%</>;
          } else {
            return <>{result}</>;
          }
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkUnassigned": {
        if (unassigned !== null) {
          return <>{unassigned === 0 ? 0 : unassigned}%</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkConversionRate": {
        if (marketCompare !== null) {
          return (
            <>
              {typeof marketCompare.average_daily_purchase[0] == "number"
                ? (marketCompare.average_daily_purchase[0] * 100).toFixed(2)
                : marketCompare.average_daily_purchase[0]}
              {typeof marketCompare.average_daily_purchase[0] == "number"
                ? "%"
                : ""}
            </>
          );
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkAddToCartRate": {
        if (marketCompare !== null) {
          return (
            <>
              {typeof marketCompare.average_daily_addToCart[0] == "number"
                ? (marketCompare.average_daily_addToCart[0] * 100).toFixed(2)
                : marketCompare.average_daily_addToCart[0]}
              {typeof marketCompare.average_daily_addToCart[0] == "number"
                ? "%"
                : ""}
            </>
          );
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkEngagementRate": {
        if (marketCompare !== null) {
          return (
            <>
              {typeof marketCompare.engagement_rate[0] == "number"
                ? (marketCompare.engagement_rate[0] * 100).toFixed(2)
                : marketCompare.engagement_rate[0]}
              {typeof marketCompare.engagement_rate[0] == "number" ? "%" : ""}
            </>
          );
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkSessions": {
        if (marketCompare !== null) {
          return <>{marketCompare.sessions[0]}</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkReportingAttributionModel": {
        if (reportingAttributionModel !== null) {
          if (
            reportingAttributionModel == "PAID_AND_ORGANIC_CHANNELS_DATA_DRIVEN"
          ) {
            return <>付費和自然管道 以數據為準</>;
          }
          if (
            reportingAttributionModel == "PAID_AND_ORGANIC_CHANNELS_LAST_CLICK"
          ) {
            return <>付費和自然管道 最終點擊</>;
          }
          if (reportingAttributionModel == "GOOGLE_PAID_CHANNELS_LAST_CLICK") {
            return <>Google 付費管道 最終點擊</>;
          }
          if (
            reportingAttributionModel ==
            "REPORTING_ATTRIBUTION_MODEL_UNSPECIFIED"
          ) {
            return <>未指定歸因模式</>;
          }
          return <>{reportingAttributionModel}</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkAcquisitionConversionEventLookbackWindow": {
        if (acquisitionConversionEventLookbackWindow !== null) {
          if (
            acquisitionConversionEventLookbackWindow ==
            "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_30_DAYS"
          ) {
            return <>30 天回溯期</>;
          }
          if (
            acquisitionConversionEventLookbackWindow ==
            "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_7_DAYS"
          ) {
            return <>7 天回溯期</>;
          }
          if (
            acquisitionConversionEventLookbackWindow ==
            "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED"
          ) {
            return <>未指定回溯期大小</>;
          }
          return <>{acquisitionConversionEventLookbackWindow}</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      case "checkOtherConversionEventLookbackWindow": {
        if (otherConversionEventLookbackWindow !== null) {
          if (
            otherConversionEventLookbackWindow ==
            "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_90_DAYS"
          ) {
            return <>90 天回溯期</>;
          }
          if (
            otherConversionEventLookbackWindow ==
            "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_60_DAYS"
          ) {
            return <>60 天回溯期</>;
          }
          if (
            otherConversionEventLookbackWindow ==
            "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_30_DAYS"
          ) {
            return <>30 天回溯期</>;
          }
          if (
            otherConversionEventLookbackWindow ==
            "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED"
          ) {
            return <>未指定回溯期大小</>;
          }
          return <>{otherConversionEventLookbackWindow}</>;
        } else {
          return (
            <>
              {
                checkListResult.filter(function (item, index, array) {
                  return item.type === pItem.type;
                }).result
              }
            </>
          );
        }
      }
      default: {
        return (
          <>
            {
              checkListResult.filter(function (item, index, array) {
                return item.type === pItem.type;
              }).result
            }
          </>
        );
      }
    }
  };

  useEffect(() => {
    if (marketCompare) {
      setMarketEchartsOption(getEchartsOption(marketCompare.score, "market"));
    } else {
      setMarketEchartsOption(getEchartsOption(0, "market"));
    }
  }, [marketCompare]);

  useEffect(() => {
    if (score && marketCompare) {
      console.log("!!!!!!!!!!!!!", score);
      setEchartsOption(getEchartsOption(score));
      setIsCheckApiFetchFinished(true);
      // console.log("checkListResult = ", checkListResult);

      const DataStreams = checkListResult.find(function (item) {
        return item.type === "checkDataStreams";
      }).value;
      const MeasurementProtocol = checkListResult.find(function (item) {
        return item.type === "checkDataStreamsMeasurementProtocol";
      }).value;

      const apiData = {
        main: {
          TimeStamp: moment().format("YYYY-MM-DD HH:mm:ss"),
          PropertyID: property,
          MarketScore: marketCompare.score,
          PurchaseConversionRate: marketCompare.average_daily_purchase[0],
          AddToCartRate: marketCompare.average_daily_addToCart[0],
          EngagementRate2MonthAgo: marketCompare.engagement_rate[0],
          AvgSessions: marketCompare.sessions[0],
          CrossDomain: crossDomain,
          IndustryCategory: industryCategory,
          TimeZone: timeZone,
          Currency: currencyCode,
          GoogleSignals: googleSignalsSettings,
          DataRetention: dataRetentionSettings,
          LoginEmail: google_user_email,
          Score: score,
          EngagementRate: interactionRate,
          IndataStatus: "UserSelect",
          Is360: ga360,
          DataStreams: DataStreams,
          Domains: hostName,
          UserProperties: userProperties,
          GoogleAdsLinking: googleAdsLinks,
          NondefConvEvents: conversionEvents,
          Audiences: audience,
          PredictiveAudiences: predicted,
          Eccomerce: eccomerce,
          Sessions: medium,
          MeasurementProtocol: MeasurementProtocol,
          googleAdsConversion: googleCPCTrans,
          Unassigned: unassigned,
          ReportingAttributionModel: reportingAttributionModel,
          AcquisitionConversionEventLookbackWindow:
            acquisitionConversionEventLookbackWindow,
          OtherConversionEventLookbackWindow:
            otherConversionEventLookbackWindow,
          Contact: false,
          Contact_Name: "",
          Contact_Phone: "",
          Contact_Email: "",
          Contact_Others: "",
          Contact_Items: [],
          Contact_Time: [],
          Contact_Topics: [],
        },
      };

      console.log("apiData = ", apiData);

      setCheckListSummaries(apiData);

      // 本地測試不用送 api
      // 🎯 只有在 legacy-only 或 full 模式時才呼叫舊版 API
      if (isProduction && displayMode !== "new-content-only") {
        axios
          .post(
            "https://freeanalysisapi.turingdigital.com.tw/mains_batch",
            apiData
          )
          .then(function (response) {
            console.log("mains_batch = ", response);
            setApiId(response.data.id);
            setPrScore(response.data.pr);
            setCookie("td-out_of_quota", response.data.out_of_quota, 0);

            if (response.data.out_of_quota) {
              setOutOfQuota("true");
            }
          })
          .catch(function (error) {
            console.log("mains_batch error = ", error);
          });
      }
    } else {
      setEchartsOption(getEchartsOption(0));
      setMarketEchartsOption(getEchartsOption(0, "market"));
    }
  }, [score]);
  /* score end */

  useEffect(() => {
    // 表單送出
    if (checkListSummaries.Contact) {
      // console.log("checkListSummaries = ", checkListSummaries)
    }
  }, [checkListSummaries]);

  const [checkListResult, setCheckListResult] = useState(checkListInit);
  const [checkListCompareResult, setCheckListCompareResult] =
    useState(CheckListCompareInit);

  useEffect(() => {
    if (reportingAttributionModel !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkReportingAttributionModel") {
            let updatedItem = { ...item };
            // 設定 status
            if (
              reportingAttributionModel !==
              "REPORTING_ATTRIBUTION_MODEL_UNSPECIFIED"
            ) {
              updatedItem.status = "正常運作";
            } else {
              updatedItem.status = "數據異常";
            }
            // 設定 result
            switch (reportingAttributionModel) {
              case "PAID_AND_ORGANIC_CHANNELS_DATA_DRIVEN":
                updatedItem.result = "付費和自然管道 以數據為準";
                break;
              case "PAID_AND_ORGANIC_CHANNELS_LAST_CLICK":
                updatedItem.result = "付費和自然管道 最終點擊";
                break;
              case "GOOGLE_PAID_CHANNELS_LAST_CLICK":
                updatedItem.result = "Google 付費管道 最終點擊";
                break;
              case "REPORTING_ATTRIBUTION_MODEL_UNSPECIFIED":
                updatedItem.result = "未指定歸因模式";
                break;
              default:
                updatedItem.result = reportingAttributionModel;
            }
            return updatedItem;
          }
          return item;
        })
      );
    }
  }, [reportingAttributionModel]);

  useEffect(() => {
    if (acquisitionConversionEventLookbackWindow !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkAcquisitionConversionEventLookbackWindow") {
            let updatedItem = { ...item };
            // 設定 status
            if (
              acquisitionConversionEventLookbackWindow !==
              "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED"
            ) {
              updatedItem.status = "正常運作";
            } else {
              updatedItem.status = "數據異常";
            }
            // 設定 result
            switch (acquisitionConversionEventLookbackWindow) {
              case "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_30_DAYS":
                updatedItem.result = "30 天回溯期";
                break;
              case "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_7_DAYS":
                updatedItem.result = "7 天回溯期";
                break;
              case "ACQUISITION_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED":
                updatedItem.result = "未指定回溯期大小";
                break;
              default:
                updatedItem.result = acquisitionConversionEventLookbackWindow;
            }
            return updatedItem;
          }
          return item;
        })
      );
    }
  }, [acquisitionConversionEventLookbackWindow]);

  useEffect(() => {
    if (otherConversionEventLookbackWindow !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkOtherConversionEventLookbackWindow") {
            let updatedItem = { ...item };
            // 設定 status
            if (
              otherConversionEventLookbackWindow !==
              "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED"
            ) {
              updatedItem.status = "正常運作";
            } else {
              updatedItem.status = "數據異常";
            }
            // 設定 result
            switch (otherConversionEventLookbackWindow) {
              case "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_90_DAYS":
                updatedItem.result = "90 天回溯期";
                break;
              case "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_60_DAYS":
                updatedItem.result = "60 天回溯期";
                break;
              case "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_30_DAYS":
                updatedItem.result = "30 天回溯期";
                break;
              case "OTHER_CONVERSION_EVENT_LOOKBACK_WINDOW_UNSPECIFIED":
                updatedItem.result = "未指定回溯期大小";
                break;
              default:
                updatedItem.result = otherConversionEventLookbackWindow;
            }
            return updatedItem;
          }
          return item;
        })
      );
    }
  }, [otherConversionEventLookbackWindow]);

  /* api result */
  useEffect(() => {
    // console.log("property 變更 = ", property)
    if (property !== "" || property !== null) {
      setGoogleApiFalse(false);
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkProperty") {
            if (property) {
              // console.log("property 111 = ", property)
              return {
                ...item,
                value: property,
                status: "正常運作",
                result: property,
              };
            } else {
              // console.log("property 222 = ", property)
              return {
                ...item,
                value: "",
                status: "尚未檢核",
                result: "",
              };
            }
          }
          return item;
        })
      );
    }
  }, [property]);
  useEffect(() => {
    if (
      dataStreams !== null
      // webDataStreams !== null &&
      // iosAppDataStreams !== null &&
      // androidAppDataStreams !== null
    ) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkDataStreams") {
            if (
              dataStreams.length
              // webDataStreams.length ||
              // iosAppDataStreams.length ||
              // androidAppDataStreams.length
            ) {
              return {
                ...item,
                // value: webDataStreams
                //   .concat(iosAppDataStreams)
                //   .concat(androidAppDataStreams),
                value: dataStreams,
                status: "正常運作",
                result: "",
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [
    dataStreams,
    // webDataStreams, androidAppDataStreams, iosAppDataStreams
  ]);
  useEffect(() => {
    if (
      hostName !== null &&
      dataStreams !== null
      // webDataStreams !== null &&
      // iosAppDataStreams !== null &&
      // androidAppDataStreams !== null
    ) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkHostName") {
            // console.log("hostName.length = ", hostName.length)
            if (hostName.length) {
              return {
                ...item,
                value: hostName,
                status: "正常運作",
                result: hostName,
              };
            } else if (
              !hostName.length &&
              dataStreams.length
              // (webDataStreams.length ||
              //   iosAppDataStreams.length ||
              //   androidAppDataStreams.length)
            ) {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "查無網域",
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [hostName, dataStreams]);
  useEffect(() => {
    if (crossDomain !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkCrossDomain") {
            if (crossDomain) {
              return {
                ...item,
                value: true,
                status: "正常運作",
                result: "有跨網追蹤",
              };
            } else {
              return {
                ...item,
                value: true,
                status: "建議修正",
                result: "無跨網追蹤",
              };
            }
          }
          return item;
        })
      );
    }
  }, [crossDomain, hostName]);
  useEffect(() => {
    if (industryCategory !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkIndustryCategory") {
            if (industryCategory) {
              return {
                ...item,
                value: industryCategory,
                status: "正常運作",
                result: industryCategory,
              };
            } else {
              return {
                ...item,
                value: "",
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [industryCategory]);
  useEffect(() => {
    if (timeZone !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkTimeZone") {
            if (timeZone) {
              return {
                ...item,
                value: timeZone,
                status: "正常運作",
                result: timeZone,
              };
            } else {
              return {
                ...item,
                value: "",
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [timeZone]);
  useEffect(() => {
    if (currencyCode !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkCurrencyCode") {
            if (currencyCode) {
              return {
                ...item,
                value: currencyCode,
                status: "正常運作",
                result: currencyCode,
              };
            } else {
              return {
                ...item,
                value: "",
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [currencyCode]);
  useEffect(() => {
    if (googleSignalsSettings !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkGoogleSignalsSettings") {
            if (googleSignalsSettings === "GOOGLE_SIGNALS_STATE_UNSPECIFIED") {
              return {
                ...item,
                value: googleSignalsSettings,
                status: "數據異常",
                result: "未設定",
              };
            } else if (googleSignalsSettings === "GOOGLE_SIGNALS_DISABLED") {
              return {
                ...item,
                value: googleSignalsSettings,
                status: "建議修正",
                result: "未設定",
              };
            } else {
              return {
                ...item,
                value: googleSignalsSettings,
                status: "正常運作",
                result: googleSignalsSettings,
              };
            }
          }
          return item;
        })
      );
    }
  }, [googleSignalsSettings]);
  useEffect(() => {
    if (dataRetentionSettings !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkDataRetentionSettings") {
            if (
              dataRetentionSettings == "FOURTEEN_MONTHS" ||
              dataRetentionSettings == "FIFTY_MONTHS"
            ) {
              return {
                ...item,
                value: (ga360 ? "360 | " : "") + dataRetentionSettings,
                status: "正常運作",
                result: (ga360 ? "360 | " : "") + dataRetentionSettings,
              };
            } else if (
              dataRetentionSettings == "RETENTION_DURATION_UNSPECIFIED"
            ) {
              return {
                ...item,
                value: "",
                status: "數據異常",
                result: "未設定",
              };
            } else {
              return {
                ...item,
                value: "",
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [dataRetentionSettings, ga360]);
  useEffect(() => {
    if (userProperties !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkUserProperties") {
            if (userProperties.length) {
              return {
                ...item,
                value: userProperties,
                status: "正常運作",
                result: userProperties,
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [userProperties]);
  useEffect(() => {
    if (googleAdsLinks !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkGoogleAdsLinks") {
            if (googleAdsLinks.length) {
              return {
                ...item,
                value: googleAdsLinks,
                status: "正常運作",
                result: googleAdsLinks,
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未串接",
              };
            }
          }
          return item;
        })
      );
    }
  }, [googleAdsLinks]);
  useEffect(() => {
    if (interactionRate !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkInteractionRate") {
            if (Number(interactionRate) > 100) {
              return {
                ...item,
                value: interactionRate + "%",
                status: "數據異常",
                result: interactionRate + "%",
              };
            } else if (Number(interactionRate) >= 80) {
              return {
                ...item,
                value: interactionRate + "%",
                status: "正常運作",
                result: interactionRate + "%",
              };
            } else if (Number(interactionRate) < 80) {
              return {
                ...item,
                value: interactionRate + "%",
                status: "數據異常",
                result: interactionRate + "%",
              };
            }
          }
          return item;
        })
      );
    }
  }, [interactionRate]);
  useEffect(() => {
    if (conversionEvents !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkConversionEvents") {
            if (conversionEvents.length) {
              return {
                ...item,
                value: conversionEvents,
                status: "正常運作",
                result: conversionEvents,
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [conversionEvents]);
  useEffect(() => {
    if (audience !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkAudience") {
            if (audience.length) {
              return {
                ...item,
                value: audience,
                status: "正常運作",
                result: audience,
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [audience]);
  useEffect(() => {
    if (predicted !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkPredicted") {
            if (predicted.length) {
              return {
                ...item,
                value: predicted,
                status: "正常運作",
                result: predicted,
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未啟用",
              };
            }
          }
          return item;
        })
      );
    }
  }, [predicted]);
  useEffect(() => {
    if (eccomerce !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkEccomerce") {
            if (eccomerce.filter((item) => Number(item.value) === 0).length) {
              return {
                ...item,
                value: eccomerce,
                status: "數據異常",
                result: eccomerce,
              };
            } else {
              return {
                ...item,
                value: eccomerce,
                status: "正常運作",
                result: eccomerce,
              };
            }
          }
          return item;
        })
      );
    }
  }, [eccomerce]);
  useEffect(() => {
    if (medium !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkMedium") {
            if (medium.length) {
              return {
                ...item,
                value: medium,
                status: "正常運作",
                result: medium,
              };
            } else {
              return {
                ...item,
                value: [],
                status: "建議修正",
                result: "未設定",
              };
            }
          }
          return item;
        })
      );
    }
  }, [medium]);
  useEffect(() => {
    if (userId !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkUserId") {
            if (userId) {
              return {
                ...item,
                value: userId,
                status: "正常運作",
                result: userId,
              };
            } else {
              return {
                ...item,
                value: false,
                status: "建議修正",
                result: "建議修正",
              };
            }
          }
          return item;
        })
      );
    }
  }, [userId]);
  useEffect(() => {
    if (
      webDataStreamsMeasurementProtocol !== null &&
      androidAppDataStreamsMeasurementProtocol !== null &&
      iosAppDataStreamsMeasurementProtocol !== null
    ) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkDataStreamsMeasurementProtocol") {
            if (
              webDataStreamsMeasurementProtocol.length ||
              androidAppDataStreamsMeasurementProtocol.length ||
              iosAppDataStreamsMeasurementProtocol.length
            ) {
              return {
                ...item,
                value: webDataStreamsMeasurementProtocol
                  .concat(androidAppDataStreamsMeasurementProtocol)
                  .concat(iosAppDataStreamsMeasurementProtocol),
                status: "正常運作",
                result: "有設定",
              };
            } else {
              return {
                ...item,
                value: [],
                status: "正常運作",
                result: "未申請",
              };
            }
          }
          return item;
        })
      );
    }
  }, [
    webDataStreamsMeasurementProtocol,
    androidAppDataStreamsMeasurementProtocol,
    iosAppDataStreamsMeasurementProtocol,
  ]);
  useEffect(() => {
    if (googleCPCTrans !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkGoogleCPCTrans") {
            if (googleCPCTrans) {
              return {
                ...item,
                value: googleCPCTrans,
                status: "正常運作",
                result: "有轉換",
              };
            } else {
              return {
                ...item,
                value: [],
                status: "正常運作",
                result: "無轉換",
              };
            }
          }
          return item;
        })
      );
    }
  }, [googleCPCTrans]);
  useEffect(() => {
    if (unassigned !== null) {
      setCheckListResult((prevCheckListResult) =>
        prevCheckListResult.map((item) => {
          if (item.type === "checkUnassigned") {
            if (unassigned === 0) {
              return {
                ...item,
                value: true,
                status: "正常運作",
                result: "",
              };
            } else {
              return {
                ...item,
                value: true,
                status: "建議修正",
                result: "",
              };
            }
          }
          return item;
        })
      );
    }
  }, [unassigned]);
  useEffect(() => {
    checkListResult.map((item, index) =>
      console.log(
        "====== ",
        index + 1 + ". " + item.type,
        item.status,
        item.result,
        item.value
      )
    );
  }, [checkListResult]);
  /* api result end */

  useEffect(() => {
    // 登入或登出時都先重置狀態
    resetTableData();
    setAccountSummaries([]);
    setAccount("");
    setPropertySummaries([]);
    setProperty("");
    setEchartsOption(getEchartsOption(0));
    setMarketEchartsOption(getEchartsOption(0, "market"));
  }, [google_is_signed_in]);

  useEffect(() => {
    if (
      google_is_signed_in &&
      google_gapi_loaded &&
      !google_gapi_loaded_error &&
      google_gapi_analyticsadmin_loaded &&
      !google_gapi_analyticsadmin_loaded_error &&
      google_gapi_analyticsdata_loaded &&
      !google_gapi_analyticsdata_loaded_error
    ) {
      setAccountSummariesLoading(true);
      setIsModalVisible(false);

      window.gapi.client.analyticsadmin.accountSummaries
        .list({
          pageSize: 200,
        })
        .then(
          (response) => {
            // console.log(response.result)

            setAccountSummaries(
              response.result.accountSummaries
                ? response.result.accountSummaries
                    .filter((item) => item.account !== "accounts/54516992")
                    .filter((item) => item.propertySummaries)
                : []
            );
            setAccountSummariesLoading(false);
            setAccountSummariesLoaded(true);

            setPropertySummaries([]);
            setProperty("");
          },
          (err) => {
            console.error("Execute error", err);
          }
        );
    } else {
      setAccountSummaries([]);
      setAccountSummariesLoaded(false);
    }
  }, [
    google_is_signed_in,
    google_gapi_loaded,
    google_gapi_loaded_error,
    google_gapi_analyticsadmin_loaded,
    google_gapi_analyticsadmin_loaded_error,
    google_gapi_analyticsdata_loaded,
    google_gapi_analyticsdata_loaded_error,
  ]);

  useEffect(() => {
    if (account) {
      const propertySummaries = accountSummaries.find(
        (item) => item.account === account
      ).propertySummaries;

      if (propertySummaries) {
        setPropertySummaries(propertySummaries);
      } else {
        setPropertySummaries([]);
      }
    } else {
      setPropertySummaries([]);
    }
  }, [account]);

  useEffect(() => {
    if (property == "") {
      resetTableData();
    }

    if (account && property) {
      setIsCheckApiFetchFinished(false);

      // 🎯 在 new-content-only 模式下，跳過所有舊版 API 檢查
      if (displayMode === "new-content-only") {
        // 新版頁面不需要執行這些檢查
        // 數據來源改為 snapshot API
        console.log("⏭️ Skipping legacy API checks in new-content-only mode");
        return;
      }

      const apiCalls = [
        checkDataStreams(),
        checkHostName(),
        checkAttributionSettings(),
        checkCrossDomain(),
        checkProperty(),
        checkGoogleSignalsSettings(),
        checkDataRetentionSettings(),
        checkGoogleAds(),
        // checkInteractionRate(),
        checkConversionEvents(),
        checkUserProperties(),
        checkAudience(),
        checkEccomerce(),
        checkMedium(),
        checkGoogleCPCTrans(),
        checkUserId(),
        checkUnassigned(),
        checkConversionEventsDefault(),
        checkMarketCompare(),
      ];

      Promise.allSettled(apiCalls).then(() => {
        // setIsCheckApiFetchFinished(true);
      });
    }
  }, [account, property]);

  if (device == "mobile") {
    submitBtnOffset = 0;
  } else {
    submitBtnOffset = 10;
    // submitBtnOffset = 3
  }

  // 設定多國語系
  const checkListResultI18n = checkListResult.map((item) => {
    // console.log("item = ", item);

    if (item.type === "checkProperty") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-1.name"),
        },
        description: t("check-result.item-1.info"),
      };
    }
    if (item.type === "checkDataStreams") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-2.name"),
        },
        description: t("check-result.item-2.info"),
      };
    }
    if (item.type === "checkHostName") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-3.name"),
        },
        description: t("check-result.item-3.info"),
      };
    }
    if (item.type === "checkCrossDomain") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-4.name"),
        },
        description: t("check-result.item-4.info"),
      };
    }
    if (item.type === "checkIndustryCategory") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-5.name"),
        },
        description: t("check-result.item-5.info"),
      };
    }
    if (item.type === "checkTimeZone") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-6.name"),
        },
        description: t("check-result.item-6.info"),
      };
    }
    if (item.type === "checkCurrencyCode") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-7.name"),
        },
        description: t("check-result.item-7.info"),
      };
    }
    if (item.type === "checkGoogleSignalsSettings") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-8.name"),
        },
        description: t("check-result.item-8.info"),
      };
    }
    if (item.type === "checkDataRetentionSettings") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-9.name"),
        },
        description: t("check-result.item-9.info"),
      };
    }
    if (item.type === "checkUserProperties") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-10.name"),
        },
        description: t("check-result.item-10.info"),
      };
    }
    if (item.type === "checkGoogleAdsLinks") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-11.name"),
        },
        description: t("check-result.item-11.info"),
      };
    }
    if (item.type === "checkInteractionRate") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-12.name"),
        },
        description: t("check-result.item-12.info"),
      };
    }
    if (item.type === "checkConversionEvents") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-13.name"),
        },
        description: t("check-result.item-13.info"),
      };
    }
    if (item.type === "checkAudience") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-14.name"),
        },
        description: t("check-result.item-14.info"),
      };
    }
    if (item.type === "checkPredicted") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-15.name"),
        },
        description: t("check-result.item-15.info"),
      };
    }
    if (item.type === "checkEccomerce") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-16.name"),
        },
        description: t("check-result.item-16.info"),
      };
    }
    if (item.type === "checkMedium") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-17.name"),
        },
        description: t("check-result.item-17.info"),
      };
    }
    if (item.type === "checkUserId") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-18.name"),
        },
        description: t("check-result.item-18.info"),
      };
    }
    if (item.type === "checkDataStreamsMeasurementProtocol") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-19.name"),
        },
        description: t("check-result.item-19.info"),
      };
    }
    if (item.type === "checkGoogleCPCTrans") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-20.name"),
        },
        description: t("check-result.item-20.info"),
      };
    }
    if (item.type === "checkUnassigned") {
      return {
        ...item,
        name: {
          ...item.name,
          tw: t("check-result.item-21.name"),
        },
        description: t("check-result.item-21.info"),
      };
    }

    return item;
  });

  // let status = t("check-result.status.init");
  // if (item.status == "正常運作") {
  //   status = t("check-result.status.normal");
  // } else if (item.status == "建議修正") {
  //   status = t("check-result.status.suggestion");
  // } else if (item.status == "數據異常") {
  //   status = t("check-result.status.error");
  // }
  // 一、市場表現綜合評比
  let checkListResultCompare = checkListCompareResult.filter((item) => {
    if (
      item.type == "checkConversionRate" ||
      item.type == "checkAddToCartRate" ||
      item.type == "checkEngagementRate" ||
      item.type == "checkSessions"
    ) {
      return item;
    }
  });
  let checkListResultCompareError = checkListResultCompare.filter((item) => {
    if (item.status == "數據異常") {
      return item;
    }
  });
  let checkListResultCompareNormal = checkListResultCompare.filter((item) => {
    if (item.status == "高於平均值") {
      return item;
    }
  });
  let checkListResultCompareSuggestion = checkListResultCompare.filter(
    (item) => {
      if (item.status == "低於平均值") {
        return item;
      }
    }
  );
  let checkListResultCompareInit = checkListResultCompare.filter((item) => {
    if (item.status == "尚未檢核") {
      return item;
    }
  });
  checkListResultCompare = [
    ...checkListResultCompareError,
    ...checkListResultCompareSuggestion,
    ...checkListResultCompareNormal,
    ...checkListResultCompareInit,
  ];

  // 新的行業綜合評比指標（假資料，之後會從 API 取得）
  // 🎯 根據 six_forces 分數判斷狀態
  const getStatusFromScore = (score) => {
    // 檢查是否為 "no data"
    if (score === "no data" || score === null || score === undefined) {
      return null; // 返回 null 表示無資料
    }
    if (score >= 1 && score <= 2) return "低於平均值";
    if (score === 3) return "等於平均值";
    if (score >= 4 && score <= 5) return "高於平均值";
    return "等於平均值"; // 預設值
  };

  const industryComparisonMetrics = useMemo(() => {
    // 檢查 six_forces 是否為 "no data"
    const hasSixForcesData =
      snapshotData?.six_forces && !isNoData(snapshotData.six_forces);

    // 如果沒有資料，所有值設為 "no data"，不使用假資料
    const sixForces = hasSixForcesData
      ? snapshotData.six_forces
      : {
          engagementRate: "no data",
          purchaseRate: "no data",
          newUserRate: "no data",
          addToCartRate: "no data",
          bounceRate: "no data",
          firstTimePurchaserRate: "no data",
        };

    // 使用 six_forces_ratio 來顯示百分比（取整數）
    const sixForcesRatio = snapshotData?.six_forces_ratio || null;

    return [
      {
        key: "engagement_rate",
        type: "checkEngagementRate",
        name: {
          tw: "參與度",
          en: "Engagement Rate",
        },
        status: getStatusFromScore(sixForces.engagementRate),
        score: sixForces.engagementRate,
        percentage: sixForcesRatio?.engagementRate
          ? Math.round(sixForcesRatio.engagementRate * 100)
          : null,
        description:
          "參與度：有互動的工作階段占比，用來判斷到站品質與內容吸引力。",
        suggestions: [
          "先看整體參與度，再下鑽到來源／裝置／內容差異。",
          "鎖定落差最大的區塊優先關注（來源、頁面、素材）。",
          "若有自訂門檻，與預設值並列呈現並標註生效日，方便對照。",
        ],
        value: "計算中",
        benchmark: "3分",
        descriptionLink: null,
      },
      {
        key: "purchase_rate",
        type: "checkConversionRate",
        name: {
          tw: "購買率",
          en: "Purchase Rate",
        },
        status: getStatusFromScore(sixForces.purchaseRate),
        score: sixForces.purchaseRate,
        percentage: sixForcesRatio?.purchaseRate
          ? Math.round(sixForcesRatio.purchaseRate * 100)
          : null,
        description: "購買率：完成購買的工作階段占比，用來衡量整體轉換效率。",
        suggestions: [
          "先看整體購買率與走勢，再下鑽到來源／裝置／品類／漏斗步驟的差異。",
          "優先處理落差最大的漏斗步驟。",
          "支援遊客結帳、表單自動帶入／欄位精簡、清楚顯示進度與錯誤提示。",
        ],
        value: "計算中",
        benchmark: "3分",
        descriptionLink: null,
      },
      {
        key: "new_customer_rate",
        type: "checkNewUserRate",
        name: {
          tw: "新客率",
          en: "New Customer Rate",
        },
        status: getStatusFromScore(sixForces.newUserRate),
        score: sixForces.newUserRate,
        percentage: sixForcesRatio?.newUserRate
          ? Math.round(sixForcesRatio.newUserRate * 100)
          : null,
        description:
          "新客率：新加入用戶占全部用戶的比例，用來衡量吸引新用戶與受眾擴張。",
        suggestions: [
          "優化首次訪問體驗，首屏訊息清楚、載入穩定，簡化首次動作。",
          "擴展相似受眾與內容觸及，控管版位重複，優先保留帶來高參與的新客來源。",
          "依來源／活動／裝置分層看新客率，並同看參與度與購買率，聚焦「高品質新客」入口。",
        ],
        value: "計算中",
        benchmark: "3分",
        descriptionLink: null,
      },
      {
        key: "cart_rate",
        type: "checkAddToCartRate",
        name: {
          tw: "購物車率",
          en: "Add to Cart Rate",
        },
        status: getStatusFromScore(sixForces.addToCartRate),
        score: sixForces.addToCartRate,
        percentage: sixForcesRatio?.addToCartRate
          ? Math.round(sixForcesRatio.addToCartRate * 100)
          : null,
        description:
          "購物車率：加入購物車的工作階段次數占整體工作階段的比例，用來評估購買意圖（非購物站可忽略）。",
        suggestions: [
          "聚焦「商品頁 → 加入購物車」瓶頸，按來源／裝置／品類比對落差。",
          "資訊完整（價／規／庫／配）、CTA 易點、變體好選、載入穩定。",
          "以 A/B 驗證 ; 快速加入、預選規格、即時顯示優惠／運費。",
        ],
        value: "計算中",
        benchmark: "3分",
        descriptionLink: null,
      },
      {
        key: "bounce_rate",
        type: "checkBounceRate",
        name: {
          tw: "跳出率",
          en: "Bounce Rate",
        },
        status: getStatusFromScore(sixForces.bounceRate),
        score: sixForces.bounceRate,
        percentage: sixForcesRatio?.bounceRate
          ? Math.round(sixForcesRatio.bounceRate * 100)
          : null,
        description: (
          <>
            跳出率：進站後沒有任何互動就離開的比例；高代表首屏或訊息落差可能有問題。
            <small style={{ fontSize: "0.85em", color: "#666" }}>
              ＊跳出率越低越好，建議與參與度/購買率併讀。
            </small>
          </>
        ),
        suggestions: [
          "先看登陸頁 × 來源 × 裝置，鎖定高跳出熱區（新頁/新投放優先）。",
          "排除技術阻礙：錯誤/重導、過多彈窗、行動版視窗不合、版面位移。",
          "排除機器人/內部流量；設互動門檻避免假性跳出。",
        ],
        value: "計算中",
        benchmark: "3分",
        descriptionLink: null,
      },
      {
        key: "first_purchase_rate",
        type: "checkFirstPurchaseRate",
        name: {
          tw: "初次購買率",
          en: "First Purchase Rate",
        },
        status: getStatusFromScore(sixForces.firstTimePurchaserRate),
        score: sixForces.firstTimePurchaserRate,
        percentage: sixForcesRatio?.firstTimePurchaserRate
          ? Math.round(sixForcesRatio.firstTimePurchaserRate * 100)
          : null,
        description:
          "初次購買率：首次完成購買的使用者占全部購買使用者的比例，用來評估拉新變現與首購誘因的成效。",
        suggestions: [
          "聚焦首次購買的來源／活動／裝置／品類，找出最能帶來首購的入口與頁面。",
          "降低首購摩擦，支援遊客結帳、多元支付；運費／到貨／退換資訊清楚可見。",
          "首購優惠與門檻明確；設放棄結帳召回／再行銷，並以 A/B 驗證。",
        ],
        value: "計算中",
        benchmark: "3分",
        descriptionLink: null,
      },
    ];
  }, [snapshotData]);

  // 二、GA4 基本設定
  // 基本設定
  let checkListResultBasic = checkListResultI18n.filter((item) => {
    if (
      item.type == "checkProperty" ||
      item.type == "checkCrossDomain" ||
      item.type == "checkIndustryCategory" ||
      item.type == "checkTimeZone" ||
      item.type == "checkCurrencyCode" ||
      item.type == "checkDataRetentionSettings" ||
      item.type == "checkHostName" ||
      item.type == "checkReportingAttributionModel" ||
      item.type == "checkAcquisitionConversionEventLookbackWindow" ||
      item.type == "checkOtherConversionEventLookbackWindow"
      // item.type == "checkDataStreamsMeasurementProtocol"
    ) {
      return item;
    }
  });
  let checkListResultBasicError = checkListResultBasic.filter((item) => {
    if (item.status == "數據異常") {
      return item;
    }
  });
  let checkListResultBasicNormal = checkListResultBasic.filter((item) => {
    if (item.status == "正常運作") {
      return item;
    }
  });
  let checkListResultBasicSuggestion = checkListResultBasic.filter((item) => {
    if (item.status == "建議修正") {
      return item;
    }
  });
  let checkListResultBasicInit = checkListResultBasic.filter((item) => {
    if (item.status == "尚未檢核") {
      return item;
    }
  });
  checkListResultBasic = [
    ...checkListResultBasicError,
    ...checkListResultBasicSuggestion,
    ...checkListResultBasicNormal,
    ...checkListResultBasicInit,
  ];
  // console.log("checkListResultBasic = ", checkListResultBasic)

  // 數據收集
  let checkListResultCollect = checkListResultI18n.filter((item) => {
    if (
      item.type == "checkDataStreams" ||
      item.type == "checkGoogleSignalsSettings" ||
      item.type == "checkGoogleAdsLinks" ||
      item.type == "checkEccomerce" ||
      item.type == "checkUserId" ||
      item.type == "checkGoogleCPCTrans" ||
      item.type == "checkUnassigned"
    ) {
      return item;
    }
  });
  let checkListResultCollectError = checkListResultCollect.filter((item) => {
    if (item.status == "數據異常") {
      return item;
    }
  });
  let checkListResultCollectNormal = checkListResultCollect.filter((item) => {
    if (item.status == "正常運作") {
      return item;
    }
  });
  let checkListResultCollectSuggestion = checkListResultCollect.filter(
    (item) => {
      if (item.status == "建議修正") {
        return item;
      }
    }
  );
  let checkListResultCollectInit = checkListResultCollect.filter((item) => {
    if (item.status == "尚未檢核") {
      return item;
    }
  });
  checkListResultCollect = [
    ...checkListResultCollectError,
    ...checkListResultCollectSuggestion,
    ...checkListResultCollectNormal,
    ...checkListResultCollectInit,
  ];
  // console.log("checkListResultCollect ===", checkListResultCollect)

  // 數據運用
  let checkListResultApplication = checkListResultI18n.filter((item) => {
    if (
      item.type == "checkUserProperties" ||
      item.type == "checkInteractionRate" ||
      item.type == "checkConversionEvents" ||
      item.type == "checkAudience" ||
      item.type == "checkPredicted" ||
      item.type == "checkMedium"
    ) {
      return item;
    }
  });
  let checkListResultApplicationError = checkListResultApplication.filter(
    (item) => {
      if (item.status == "數據異常") {
        return item;
      }
    }
  );
  let checkListResultApplicationNormal = checkListResultApplication.filter(
    (item) => {
      if (item.status == "正常運作") {
        return item;
      }
    }
  );
  let checkListResultApplicationSuggestion = checkListResultApplication.filter(
    (item) => {
      if (item.status == "建議修正") {
        return item;
      }
    }
  );
  let checkListResultApplicationInit = checkListResultApplication.filter(
    (item) => {
      if (item.status == "尚未檢核") {
        return item;
      }
    }
  );
  checkListResultApplication = [
    ...checkListResultApplicationError,
    ...checkListResultApplicationSuggestion,
    ...checkListResultApplicationNormal,
    ...checkListResultApplicationInit,
  ];

  // 所有 checkListResult 的狀態結果
  let checkListResultError = checkListResult.filter((item) => {
    if (item.status == "數據異常") {
      return item;
    }
  });
  // console.log("checkListResult = ", checkListResult);
  // console.log("數據異常 = ", checkListResultError);
  let checkListResultNormal = checkListResult.filter((item) => {
    if (item.status == "正常運作") {
      return item;
    }
  });
  // console.log("正常運作 = ", checkListResultNormal);
  let checkListResultSuggestion = checkListResult.filter((item) => {
    if (item.status == "建議修正") {
      return item;
    }
  });
  // console.log("建議修正 = ", checkListResultSuggestion);

  const CollapseOnChange = (keys) => {
    // setCollapseKeys(key);

    // console.log("CollapseOnChange = ", keys);

    // 找出新開啟的 key
    const newlyOpenedKeys = keys.filter(
      (key) => !previousKeysRef.current.includes(key)
    );

    if (newlyOpenedKeys.length > 0) {
      // console.log("Newly opened:", newlyOpenedKeys);

      // 🎯 在 /rtga 頁面發送 rtga_show 事件
      if (isRtgaPage) {
        newlyOpenedKeys.forEach((key) => {
          // 從 industryComparisonMetrics 找到對應的項目
          const item = industryComparisonMetrics.find((m) => m.key === key);
          if (item) {
            utilsIndex.sendGAEvent("rtga_show", {
              block_name: item.name.en, // 英文名稱
              block_name1: item.status, // 狀態（如『低於平均值』）
              block_name2: item.name.tw, // 中文名稱（如『參與度』）
              block_name3: "檢測結果", // 固定值
            });
          }
        });
      } else {
        // 首頁發送 engage 事件
        utilsIndex.sendGAEvent("engage", {
          turing_01: "觀看說明",
          turing_02: "Check Assistant頁",
        });
      }
    }

    // 更新 previousKeysRef 的值
    previousKeysRef.current = keys;
  };

  // console.log('checkListResult ===', checkListResult)

  return (
    <div
      className={
        device == "mobile" ? "check-assistant mobile" : "check-assistant"
      }
    >
      <Modal
        title=""
        visible={isStarModalVisible}
        //onOk={starModalOk}
        onCancel={starModalCancel}
        className="ga4-not-found-modal"
      >
        {accountSummariesLoaded & (accountSummaries.length == 0) ? (
          <div className="no-ga4">
            <div className="title">找不到我的 GA4 帳號？</div>
            <div className="content">
              可能此 email 沒有權限，請點選「登出」，切換「email」後重新登入。
            </div>
            <br />
            <div className="title">GA4 是什麼？</div>
            <div className="content">
              GA4 全名為 Google Analytics 4，為 Google
              開發的免費網站及應用程式分析工具。
              <a target={"_blank"} href="https://lihi2.com/F8IME">
                點此領取 【 GA4 使用指南 】
              </a>
              。
            </div>
          </div>
        ) : (
          <div className="have-ga4">
            <div className="title">找不到我的 GA4 帳戶？</div>
            <div className="content">
              1、若您有多個 GA4 帳戶，請點選 GA4 後台 {">>"} 點擊左上角下拉選單{" "}
              {">>"} <span style={{ color: "red" }}> 確認您的帳戶名稱</span>{" "}
              {">>"} 回到此頁選取該帳戶
              <br />
              <br />
              2、可能此 email
              沒有權限，請點選「登出」，切換「email」後重新登入。
            </div>
          </div>
        )}
      </Modal>

      <div>
        <Modal
          title=""
          visible={isTimesWaringModalVisible}
          onOk={timesWaringModalOk}
          onCancel={timesWaringModalCancel}
          className="check_times_modal"
          footer={[
            <Button onClick={timesWaringModalOk}>
              {t("check-times-modal.yes-btn")}
            </Button>,
            <Button onClick={timesWaringModalAnswerNo}>
              {t("check-times-modal.cancel-btn")}
            </Button>,
          ]}
        >
          <div className="Modal_head">
            <img src={timesCheck} style={{ width: "100px", height: "auto" }} />
            <div className="Modal_head_text" style={{ fontSize: "16px" }}>
              Waring
            </div>
          </div>
          <div className="title">{t("check-times-modal.content")}</div>
        </Modal>
      </div>

      {/* <div className="consult">
        <div className="consult-content">consult-content</div>
        <div className="consult-btn">
          <img src={consultBtn} />
          <div className="consult-num">1</div>
        </div>
      </div> */}

      {/* <div class="interactive-block">
        <div class="info-box">
          <h3>需要專屬的數據優化方案嗎？</h3>
          <ul>
            <li>擺脫 GA4 數據延遲，即時檢視數據表現</li>
            <li>了解競業各項數據指標與排名分析</li>
            <li>客製化提升轉換率/營收優化方案</li>
          </ul>
          <button class="cta-button">立即了解服務</button>
        </div>
        <div class="chat-button">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="40"
              height="40"
            >
              <path
                fill="white"
                d="M12 2C6.48 2 2 5.58 2 10c0 2.24 1.23 4.25 3.21 5.65l-1.18 3.86 3.91-1.22C9.11 19.16 10.5 19.5 12 19.5c5.52 0 10-3.58 10-8S17.52 2 12 2zm0 14c-1.19 0-2.34-.21-3.4-.6l-.32-.12-2.48.77.75-2.44-.2-.3C5.51 12.39 5 11.25 5 10c0-3.07 3.59-5.5 8-5.5s8 2.43 8 5.5-3.59 5.5-8 5.5zm-4-6h8v2H8v-2zm0-3h8v2H8V7z"
              ></path>
            </svg>
          </div>
          <div class="badge">1</div>
        </div>
      </div> */}

      <InteractiveBlock
        google_is_signed_in={google_is_signed_in}
        // isFloatFormNotificationVisible={isFloatFormNotificationVisible} // 移除：不再使用滾動觸發
        checkListResult={checkListResult}
        checkListSummaries={checkListSummaries}
        setCheckListSummaries={setCheckListSummaries}
        checkListCompareResult={checkListCompareResult}
        openSuccessModal={openSuccessModal}
        apiId={apiId}
        isProduction={isProduction}
        currentContentIndex={blockContentIndex} // **獨立的 InteractiveBlock 頁面狀態**
        setCurrentContentIndex={setBlockContentIndex}
        isLoading={isBlockLoading}
        setIsLoading={setBlockLoading}
        isInfoVisible={isBlockInfoVisible}
        setIsInfoVisible={setIsBlockInfoVisible}
        isPopupVisible={isPopupVisible}
        setClearAutoShowTimer={setClearAutoShowTimer} // **讓 InteractiveBlock 傳遞 clearAutoShowTimer**
        // isBadgeDismissed={isBadgeDismissed} // 移除：不再使用 badge
        // setIsBadgeDismissed={setIsBadgeDismissed}
        handleSubmit={(values) => {
          utilsIndex.sendGAEvent("form_submit", {
            turing_01: "諮詢鈕_優化視窗_資料填寫",
            turing_02: "Check Assistant頁",
          });
          fbq("trackCustom", "form_submit");
          handleSubmit(values, setBlockContentIndex, setBlockLoading);
        }}
      />
      <Popup
        isPopupVisible={isPopupVisible}
        closePopup={closePopup}
        google_is_signed_in={google_is_signed_in}
        // isFloatFormNotificationVisible={isFloatFormNotificationVisible} // 移除：Popup 不使用此 prop
        checkListResult={checkListResult}
        checkListSummaries={checkListSummaries}
        setCheckListSummaries={setCheckListSummaries}
        checkListCompareResult={checkListCompareResult}
        openSuccessModal={openSuccessModal}
        apiId={apiId}
        isProduction={isProduction}
        isInfoVisible={isPopupInfoVisible} // **Popup 專用的 InfoBox**
        setIsInfoVisible={setIsPopupInfoVisible}
        currentContentIndex={popupContentIndex} // **獨立的 Popup 頁面狀態**
        setCurrentContentIndex={setPopupContentIndex}
        isLoading={isPopupLoading}
        setIsLoading={setPopupLoading}
        // isBadgeDismissed={isBadgeDismissed} // 移除：不再使用 badge
        // setIsBadgeDismissed={setIsBadgeDismissed}
        handleSubmit={(values) => {
          utilsIndex.sendGAEvent("form_submit", {
            turing_01: "市場綜合指標_優化彈跳視窗_資料填寫",
            turing_02: "Check Assistant頁",
          });
          fbq("trackCustom", "form_submit");
          handleSubmit(values, setPopupContentIndex, setPopupLoading);
        }}
      />

      {/* <div className="top-alert">
        <img src={imgWarn} style={{ width: "14px" }} />
        {t("top-alert")}
      </div> */}
      <div className="top section">
        <div className="logo">
          <a target="_blank" href="https://bit.ly/3C2hmlM">
            <img src={imgLogo} />
          </a>
        </div>
        {/* <Dropdown.Button
          className="language"
          menu={menuProps}
          placement="bottom"
          icon={<GlobalOutlined />}
        >
          {language === "tw" ? "繁體中文" : "簡體中文"}
        </Dropdown.Button> */}
        {isCheckApiFetchFinished && displayMode !== "legacy-only" && (
          <SnapshotCountdown
            remainingSeconds={snapshotRemainingSeconds}
            isPaused={isContactFormFocused}
          />
        )}
        <div className="banner">
          <img className="icon-main" src={imgIconMain} />
          {/* <img className="icon-beta" src={imgIconBeta} /> */}
        </div>
        <h1 className="name">
          即時數據分析室
          {/* {t("top.name-1")}
          <br /> {t("top.name-2")} */}
          <div className="name-intro">
            <img src={laurelLeft} />
            <div className="text">
              一鍵健檢 GA4，即時掌握行業評比
              {/* {t("top.name-intro-1")}
              <br />
              {t("top.name-intro-2")} */}
            </div>
            <img src={laurelReft} />
          </div>
        </h1>
        {/* <div className="present">Presented By Turing Digital</div> */}
        <div className="gmpc">
          {/* <img src={imgPremierPartner} alt="Premier Partner" /> */}
          <img src={imgGooglePartner} alt="Google Partner" />
          {/* <img src={imgGMPC} alt="Google Marketing Platform Certified" /> */}
        </div>
      </div>
      <div className="step section">
        <div className="experiment-wrap">
          <div className="experiment step">
            <div className="title">
              {/* {t("slogan.main-1")}
              <span>、</span>
              <br />
              {t("slogan.main-2")}
              <span>、</span>
              <br />
              {t("slogan.main-3")} */}
              掌握數據現況、辨識自身優劣、挖掘成長機會
            </div>
            <div>
              {/* {t("slogan.sub")} */}
              為您提供專業的數據優化建議，提升競爭力
            </div>
          </div>
        </div>
        <div className={`account ${google_is_signed_in ? "align-left" : ""}`}>
          <Space
            direction={"vertical"}
            style={{
              width: "100%",
              // marginTop: "20px",
              // textAlign: "left",
            }}
          >
            {google_is_signed_in ? (
              <Space
                direction={"horizontal"}
                style={{
                  width: "100%",
                  // marginTop: "20px",
                  textAlign: "left",
                }}
              >
                <h3
                  style={{
                    fontSize: "1rem",
                    margin: "0",
                    fontWeight: "400",
                  }}
                >
                  Step 1. {t("step.step-1")}
                </h3>
                <span style={{ color: "rgb(127, 185, 0)", fontSize: "1rem" }}>
                  {t("step.success")}
                </span>
              </Space>
            ) : (
              ""
            )}
            <GoogleAuthButton />
            {/* <LoginSocialGoogle
              client_id="405430373772-gcumiucgm2059ck0acp691gfflnej3s3.apps.googleusercontent.com"
              onLoginStart={onLoginStart}
              // redirect_uri={REDIRECT_URI}
              scope="https://www.googleapis.com/auth/analytics https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/userinfo.email"
              // discoveryDocs="claims_supported"
              access_type="offline"
              onResolve={({ provider, data }) => {
                console.log("🚀 ~ CheckAssistant ~ provider:", provider);
                console.log("🚀 ~ CheckAssistant ~ data:", data);
                setProvider(provider);
                setProfile(data);
              }}
              onReject={(err) => {
                console.log(err);
              }}
            >
              <GoogleLoginButton />
            </LoginSocialGoogle> */}
            {/* <Modal
              title="使用說明"
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
            >
              <p style={{ fontSize: "18px" }}>
                由於系統目前還在 Beta
                測試版本，假如短時間有大量用戶使用，在登入過程中會跳出安全性驗證的視窗，無需擔心，請依照以下步驟完成登入，感謝！
              </p>
              <img src={imgLoginAuth} />
              <div className="start-wrap">
                <hr style={{ marginBottom: "20px" }} />
              </div>
            </Modal> */}
          </Space>
          {google_is_signed_in && (
            <div className="account-source">
              {/* {accountSummariesLoaded & (accountSummaries.length == 0) ? (
                <div className="no-ga4">此帳號無 GA4 資料</div>
              ) : (
                
              )} */}
              <div>
                <Space
                  direction={"vertical"}
                  style={{
                    width: "100%",
                    marginTop: "18px",
                    textAlign: "left",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "1rem",
                      margin: "0",
                      fontWeight: "400",
                      display: "flex",
                    }}
                  >
                    Step 2. {t("step.step-2")}{" "}
                    {accountSummariesLoaded && (
                      <div className="ga4-not-found" onClick={starModal}>
                        <QuestionCircleOutlined />
                        <span className="word">找不到 GA4 帳戶？</span>
                      </div>
                    )}
                  </h3>
                  <Select
                    defaultValue=""
                    style={{ width: "100%" }}
                    allowClear
                    loading={accountSummariesLoading}
                    onChange={(value) => {
                      setAccount(value);
                      setProperty("");
                      resetTableData();
                      utilsIndex.sendGAEvent("engage", {
                        turing_01: "選擇帳戶",
                        turing_02: "Check Assistant頁",
                      });
                    }}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearch}
                    filterOption={(input, option) => {
                      return (
                        option.children.props.children[0].props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {accountSummaries.map((item) => {
                      return (
                        <Option
                          key={item.account}
                          label={item.displayName}
                          value={item.account}
                        >
                          <Space direction={"vertical"}>
                            <Typography.Text strong>
                              {item.displayName}
                            </Typography.Text>
                            <Typography.Text type={"secondary"}>
                              {item.account}
                            </Typography.Text>
                          </Space>
                        </Option>
                      );
                    })}
                  </Select>
                </Space>
                <Space
                  direction={"vertical"}
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    textAlign: "left",
                  }}
                >
                  <Space direction={"horizontal"}>
                    <h3
                      style={{
                        fontSize: "1rem",
                        margin: "0",
                        fontWeight: "400",
                      }}
                    >
                      Step 3. {t("step.step-3")}
                    </h3>
                    {googleApiFalse ? (
                      <span
                        style={{
                          color: "#f90000",
                          fontSize: "1rem",
                        }}
                      >
                        Opps！Google 的系統似乎有點故障，請晚點再來嘗試
                      </span>
                    ) : property && !score ? (
                      <span
                        style={{
                          color: "rgb(127, 185, 0)",
                          fontSize: "1rem",
                        }}
                      >
                        選擇後會自動執行，請耐心等候
                      </span>
                    ) : property && score ? (
                      <span
                        style={{
                          color: "rgb(127, 185, 0)",
                          fontSize: "1rem",
                        }}
                      >
                        執行完畢
                      </span>
                    ) : (
                      ""
                    )}
                  </Space>

                  <Select
                    defaultValue=""
                    value={property}
                    style={{ width: "100%" }}
                    allowClear
                    onChange={(value) => {
                      // console.log("outOfQuota = ", outOfQuota);
                      utilsIndex.sendGAEvent("choose_property");
                      utilsIndex.sendGAEvent("engage", {
                        turing_01: "選擇GA4 ID",
                        turing_02: "Check Assistant頁",
                      });
                      fbq("trackCustom", "use_tools");

                      if (outOfQuota == "true") {
                        utilsIndex.sendGAEvent("used_10_times");
                        setIsTimesWaringModalVisible(true);
                      } else {
                        setProperty(value);
                      }
                    }}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearch}
                    filterOption={(input, option) => {
                      return (
                        option.children.props.children[0].props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {propertySummaries.map((item) => {
                      return (
                        <Option
                          key={item.property}
                          label={item.displayName}
                          value={item.property}
                        >
                          <Space direction={"vertical"}>
                            <Typography.Text strong>
                              {item.displayName}
                            </Typography.Text>
                            <Typography.Text type={"secondary"}>
                              {item.property}
                            </Typography.Text>
                          </Space>
                        </Option>
                      );
                    })}
                  </Select>
                  {/* <Typography.Text
                  type={"secondary"}
                  style={{ marginLeft: "12px" }}
                >
                  {property}
                </Typography.Text> */}
                </Space>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* 新版內容 */}
      {displayMode !== "legacy-only" && (
        <div className="new-content">
          {/* 顯示 loading 狀態 */}
          {snapshotLoading && property ? (
            <div
              className="loading-container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "400px",
                gap: "20px",
              }}
            >
              <div
                className="loading-spinner"
                style={{
                  border: "4px solid #f3f3f3",
                  borderTop: "4px solid #5B7FDE",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  animation: "spin 1s linear infinite",
                }}
              ></div>
              <div style={{ fontSize: "18px", color: "#666" }}>
                正在分析資料中，請稍候...
              </div>
            </div>
          ) : hasNoData ? (
            <NoDataContent />
          ) : !isCheckApiFetchFinished ? (
            <PreCheckContent />
          ) : (
            <PostCheckContent>
              <div class="title">『{propertyDisplayName}』</div>
              <div className="check-period">
                {new Date().getFullYear()}/
                {String(new Date().getMonth() + 1).padStart(2, "0")}/
                {String(new Date().getDate()).padStart(2, "0")} 即時數據
              </div>
              <div className="report-time-badge">
                報表呈現區間：00:00-{checkEndTime}
                <br />
                ＊每15分鐘更新一次
              </div>
              <div className="radar-chart-wrapper section">
                {isNoData(snapshotData?.six_forces) ? (
                  <div className="no-data-placeholder">此項目暫無數據</div>
                ) : (
                  <ReactECharts
                    className="radar-chart"
                    style={{ height: "400px", width: "100%" }}
                    option={radarOption}
                  />
                )}
              </div>
              <div className="new-score section">
                <div className="new-score-title">
                  {(() => {
                    // 檢查是否有 six_forces 資料
                    if (isNoData(snapshotData?.six_forces)) {
                      return <>此項目暫無數據</>;
                    }

                    const sixForces = snapshotData?.six_forces || {};
                    const avgScore = 3;

                    // 計算低於平均的指標數量（分數 < 3）
                    const belowAvgCount = [
                      sixForces.newUserRate,
                      sixForces.bounceRate,
                      sixForces.engagementRate,
                      sixForces.addToCartRate,
                      sixForces.purchaseRate,
                      sixForces.firstTimePurchaserRate,
                    ].filter((score) => score < avgScore).length;

                    // 根據低於平均的指標數量顯示對應文字
                    if (belowAvgCount >= 4) {
                      return <>大幅落後於產業平均，須盡快改善</>;
                    } else if (belowAvgCount >= 1 && belowAvgCount <= 3) {
                      return <>略低於產業平均，具提升空間</>;
                    } else {
                      // 全部高於平均（belowAvgCount === 0）
                      return <>略高於產業平均，但仍有進步空間</>;
                    }
                  })()}
                </div>
                <div className="next-update-time">
                  下次更新時間：
                  {(() => {
                    // 計算下次更新時間（當前時間 + 15 分鐘）
                    const now = new Date();
                    const nextUpdate = new Date(now.getTime() + 15 * 60 * 1000);
                    const month = String(nextUpdate.getMonth() + 1).padStart(
                      2,
                      "0"
                    );
                    const date = String(nextUpdate.getDate()).padStart(2, "0");
                    const hours = String(nextUpdate.getHours()).padStart(
                      2,
                      "0"
                    );
                    const minutes = String(nextUpdate.getMinutes()).padStart(
                      2,
                      "0"
                    );
                    return `${month}/${date} ${hours}:${minutes}`;
                  })()}
                </div>
                <div className="new-score-notes">
                  <div>＊ 本圖為『GA 預設』產業同類型上百企業對比數據。</div>
                  <div>＊ 產業擷取貴司 GA 預設產業別。</div>
                </div>
              </div>
              <div className="insights-grid section">
                <div className="insights-header">
                  即時客層分佈｜各區域客群佔比
                  <span className="update-notice inline">
                    ＊數據每 15 分鐘更新一次
                  </span>
                </div>
                <div className="insights-left">
                  <div className="taiwan-map">
                    {isNoData(snapshotData?.active_users_region) ? (
                      <div
                        className="no-data-placeholder"
                        style={{ height: "550px" }}
                      >
                        此項目暫無數據
                      </div>
                    ) : (
                      <ReactECharts
                        className="taiwan-map-chart"
                        option={taiwanMapOption}
                        style={{ height: "550px" }}
                      />
                    )}
                  </div>
                </div>
                <div className="insights-right">
                  <div className="country-table">
                    <div className="country-table-header">
                      <span>地區</span>
                      <span>人數</span>
                    </div>
                    <div className="country-table-body">
                      {isNoData(snapshotData?.active_users_region) ? (
                        <div
                          className="no-data-placeholder"
                          style={{ padding: "40px 20px", minHeight: "150px" }}
                        >
                          此項目暫無數據
                        </div>
                      ) : (
                        COUNTRY_ENGAGEMENT_DATA.slice(0, 3).map((item) => {
                          const progress =
                            countryMaxUsers > 0
                              ? Math.max(
                                  (item.users / countryMaxUsers) * 100,
                                  6
                                )
                              : 0;
                          return (
                            <div className="country-row" key={item.region}>
                              <div className="country-row-content">
                                <div className="country-name">
                                  {item.region}
                                </div>
                                <div className="country-metrics">
                                  <span className="users">
                                    {item.users?.toLocaleString() || 0}
                                  </span>
                                </div>
                              </div>
                              <div className="country-progress">
                                <div
                                  className="country-progress-bar"
                                  style={{ width: `${progress}%` }}
                                />
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                  <div className="client-ratio">
                    <div className="title">新舊客比例</div>
                    {isNoData(snapshotData?.newUserRate) ? (
                      <div
                        className="no-data-placeholder"
                        style={{ height: "300px" }}
                      >
                        此項目暫無數據
                      </div>
                    ) : (
                      <ReactECharts
                        className="client-ratio-chart"
                        option={clientRatioOption}
                        style={{ height: "300px" }}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* 即時轉換漏斗 | 流失熱點與裝置分佈 */}
              <div className="funnel-insights-wrapper section">
                <h2 className="section-main-title">
                  即時轉換漏斗｜流失熱點與裝置分佈
                  <span className="update-notice inline">
                    ＊數據每 15 分鐘更新一次
                  </span>
                </h2>

                <div className="funnel-top">
                  <div className="conversion-summary">
                    <div className="summary-card">
                      <div className="summary-label">最多人放棄在</div>
                      <div className="summary-highlight">
                        {(() => {
                          if (
                            !snapshotData ||
                            isNoData(snapshotData.max_churn_event)
                          ) {
                            return "『--』";
                          }

                          const eventName =
                            EVENT_NAME_MAPPING[snapshotData.max_churn_event] ||
                            snapshotData.max_churn_event;
                          return `『${eventName}』`;
                        })()}
                      </div>
                    </div>
                    <div className="summary-card">
                      <div className="summary-label">即時轉換率</div>
                      <div className="summary-value">
                        {snapshotData && !isNoData(snapshotData["即時轉換率"])
                          ? `${(snapshotData["即時轉換率"] * 100).toFixed(2)}%`
                          : "--"}
                      </div>
                    </div>
                    <div className="summary-card">
                      <div className="summary-label">完成一筆轉換需要</div>
                      <div className="summary-value">
                        {snapshotData &&
                        !isNoData(snapshotData["完成一筆轉換需要"])
                          ? snapshotData["完成一筆轉換需要"]
                          : "--"}
                        <span className="summary-unit">人進站</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="funnel-charts-row">
                  {/* 流失率最高之階段的裝置分佈 */}
                  <div className="device-loss-distribution">
                    <h2 className="section-title">
                      流失率最高的階段
                      <br />
                      用戶裝置分佈
                    </h2>
                    <div className="chart-container">
                      <div className="device-icons">
                        <div className="device-icon" title="手機">
                          <svg
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="7"
                              y="3"
                              width="10"
                              height="18"
                              rx="2"
                              ry="2"
                            />
                            <line
                              x1="12"
                              y1="18"
                              x2="12"
                              y2="18"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                        <div className="device-icon" title="平板">
                          <svg
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="5"
                              y="4"
                              width="14"
                              height="16"
                              rx="2"
                              ry="2"
                            />
                            <circle cx="12" cy="17" r="0.5" strokeWidth="1.5" />
                          </svg>
                        </div>
                        <div className="device-icon" title="桌機">
                          <svg
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="3"
                              y="4"
                              width="18"
                              height="11"
                              rx="2"
                              ry="2"
                            />
                            <line
                              x1="8"
                              y1="19"
                              x2="16"
                              y2="19"
                              strokeLinecap="round"
                            />
                            <line
                              x1="12"
                              y1="15"
                              x2="12"
                              y2="19"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                      </div>
                      {isNoData(snapshotData?.裝置的使用者人數差距) ? (
                        <div
                          className="no-data-placeholder"
                          style={{ height: "280px" }}
                        >
                          此項目暫無數據
                        </div>
                      ) : (
                        <ReactECharts
                          option={deviceDistributionOption}
                          style={{ height: "280px", width: "100%" }}
                        />
                      )}
                    </div>

                    {/* 檢查看看 - 桌機版顯示 */}
                    <div className="funnel-checklist-row desktop-only">
                      <div className="checklist-icon">💬 檢查看看✨</div>
                      <div className="checklist-content">
                        <ul>
                          <li>放棄的客群是否都集中於某一種裝置呢？</li>
                          <li>
                            首屏載入速度夠快嗎？設備打開是不是要等超過3秒？
                          </li>
                          <li>廣告素材與落地頁文案是否一致？</li>
                          <li>有沒有「標題說A、頁面卻講B」的情況？</li>
                          <li>
                            你的主力CTA（行動按鈕）是不是在第一屏就能被看到？
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* 行銷漏斗 */}
                  <div className="marketing-funnel">
                    <h2 className="section-title">行銷漏斗分析</h2>
                    <div className="marketing-funnel-notes">
                      ＊以下為工作階段數
                    </div>
                    <div className="chart-container">
                      {isNoData(snapshotData?.churn_users) ||
                      isNoData(snapshotData?.churn_rate) ? (
                        <div
                          className="no-data-placeholder"
                          style={{ height: "500px" }}
                        >
                          此項目暫無數據
                        </div>
                      ) : (
                        <ReactECharts
                          option={(() => {
                            // 🎯 使用 Snapshot Data 的實際數據（churn_users）
                            const churnUsers = snapshotData?.churn_users || {
                              session_start: 43971,
                              view_item: 4181,
                              add_to_cart: 187,
                              begin_checkout: 100,
                              purchase: 66,
                            };

                            const funnelData = [
                              {
                                value: churnUsers.session_start,
                                name: "進站流量",
                                color: "#5B7FDE",
                              },
                              {
                                value: churnUsers.view_item,
                                name: "瀏覽商品",
                                color: "#5CB3E0",
                              },
                              {
                                value: churnUsers.add_to_cart,
                                name: "加入購物車",
                                color: "#7EC5E8",
                              },
                              {
                                value: churnUsers.begin_checkout,
                                name: "開始結帳",
                                color: "#B4D95C",
                              },
                              {
                                value: churnUsers.purchase,
                                name: "完成轉換",
                                color: "#8BC34A",
                              },
                            ];

                            // 🎯 使用 API 提供的 churn_rate（流失率）
                            const churnRate = snapshotData?.churn_rate || {
                              view_item: 0.9043831552698898,
                              add_to_cart: 0.9566097122302158,
                              begin_checkout: 0.4455958549222798,
                              purchase: 0.383177570093458,
                            };

                            // 計算流失率顯示和動態位置
                            const calculateLossRates = () => {
                              const lossRates = [];
                              const chartTop = 5; // 圖表 top 值（%）
                              const chartHeight = 90; // 圖表實際高度（%）
                              const sectionHeight =
                                chartHeight / funnelData.length;

                              // 階段名稱對應到 churn_rate 的 key
                              const stageKeys = [
                                "view_item",
                                "add_to_cart",
                                "begin_checkout",
                                "purchase",
                              ];

                              for (let i = 0; i < stageKeys.length; i++) {
                                const key = stageKeys[i];
                                const lossRate = churnRate[key]
                                  ? Math.round(churnRate[key] * 100)
                                  : 0;

                                // 計算流失率標籤位置
                                const position =
                                  chartTop +
                                  (i + 0.4) * sectionHeight +
                                  sectionHeight / 2;

                                lossRates.push({
                                  position: `${position}%`,
                                  text: `流失率 ${lossRate}%`,
                                });
                              }
                              return lossRates;
                            };

                            const lossRates = calculateLossRates();

                            return {
                              tooltip: {
                                trigger: "item",
                                formatter: function (params) {
                                  return `${params.name}<br/>次數: ${params.value.toLocaleString()}<br/>佔比: ${params.percent}%`;
                                },
                              },
                              series: [
                                {
                                  name: "行銷漏斗",
                                  type: "funnel",
                                  left: "10%",
                                  top: "5%",
                                  bottom: "5%",
                                  width: "80%",
                                  min: 0,
                                  max: Math.max(
                                    ...funnelData.map((d) => d.value)
                                  ),
                                  minSize: "8%",
                                  maxSize: "100%",
                                  sort: "none",
                                  gap: 8,
                                  label: {
                                    show: true,
                                    position: "inside",
                                    fontSize: 16,
                                    fontWeight: "bold",
                                    color: "#fff",
                                    formatter: function (params) {
                                      const displayValue =
                                        params.value === 0
                                          ? "none"
                                          : params.value.toLocaleString();
                                      return `${params.name}\n${displayValue}`;
                                    },
                                  },
                                  labelLine: {
                                    show: false,
                                  },
                                  itemStyle: {
                                    borderColor: "#fff",
                                    borderWidth: 3,
                                  },
                                  emphasis: {
                                    label: {
                                      fontSize: 18,
                                    },
                                  },
                                  data: funnelData.map((item) => ({
                                    value: item.value,
                                    name: item.name,
                                    itemStyle: { color: item.color },
                                  })),
                                },
                              ],
                              graphic: lossRates.map((rate, index) => ({
                                type: "text",
                                left: "right",
                                top: rate.position,
                                style: {
                                  text: rate.text,
                                  fontSize: 14,
                                  fill: "#E57373",
                                  fontWeight: "bold",
                                },
                              })),
                            };
                          })()}
                          style={{ height: "500px", width: "100%" }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* 檢查看看 - 手機版顯示 */}
                <div className="funnel-checklist-row mobile-only">
                  <div className="checklist-icon">💬 檢查看看✨</div>
                  <div className="checklist-content">
                    <ul>
                      <li>廣告素材與落地頁文案是否一致？</li>
                      <li>有沒有「標題說A、頁面卻講B」的情況？</li>
                      <li>你的主力CTA（行動按鈕）是不是在第一屏就能被看到？</li>
                      <li>首屏載入速度夠快嗎？設備打開是不是要等超過3秒？</li>
                      <li>放棄的客群是否都集中於某一種裝置呢？</li>
                    </ul>
                  </div>
                </div>

                {/* 即時報表影片 */}
                <div className="real-time-report-video">
                  <video
                    src={require("../../videos/real-time-report.mp4")}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onClick={handleRealTimeVideoClick}
                  />
                </div>

                {/* 渠道表現表格 */}
                <div className="channel-performance-table">
                  <h2 class="section-title">
                    各渠道產業參與度表現
                    <div className="update-notice">
                      ＊數據每 15 分鐘更新一次
                    </div>
                  </h2>
                  {isNoData(snapshotData?.tier) ? (
                    <div
                      className="no-data-placeholder"
                      style={{ height: "200px" }}
                    >
                      此項目暫無數據
                    </div>
                  ) : (
                    <Table
                      columns={[
                        {
                          title: "渠道",
                          dataIndex: "channel",
                          key: "channel",
                          width: "15%",
                          render: (text) => <strong>{text}</strong>,
                        },
                        {
                          title: "產業表現",
                          dataIndex: "performance",
                          key: "performance",
                          width: "30%",
                          render: (_, record) => (
                            <div>
                              <Tag color={record.tagColor}>{record.level}</Tag>
                              <span>{record.comparison}</span>
                            </div>
                          ),
                        },
                        {
                          title: "圖靈建議",
                          dataIndex: "suggestion",
                          key: "suggestion",
                          width: "55%",
                        },
                      ]}
                      dataSource={channelPerformanceData}
                      pagination={false}
                    />
                  )}
                </div>
              </div>

              {/* 行業綜合評比 */}
              <div className="industry-score-comparison section">
                <h2 className="section-main-title">
                  行業綜合評比
                  <div className="update-notice">＊數據每 15 分鐘更新一次</div>
                </h2>

                <div className="score-charts-row">
                  <div className="score-chart-item">
                    <div className="chart-title" ref={leftChartTitleRef}>
                      『{propertyDisplayName}』
                      <br />
                      行業內綜合評分
                    </div>
                    {isNoData(snapshotData?.["行業內綜合評分"]) ? (
                      <div
                        className="no-data-placeholder"
                        style={{ height: "300px" }}
                      >
                        此項目暫無數據
                      </div>
                    ) : (
                      <ReactECharts
                        className="score-donut-chart"
                        option={{
                          tooltip: {
                            trigger: "item",
                            formatter: "{b}: {c}分",
                          },
                          grid: {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            containLabel: false,
                          },
                          series: [
                            {
                              name: "綜合評分",
                              type: "pie",
                              radius: ["65%", "85%"],
                              center: ["50%", "50%"],
                              avoidLabelOverlap: false,
                              label: {
                                show: true,
                                position: "center",
                                fontSize: 48,
                                fontWeight: "bold",
                                color: "#1a1a1a",
                                formatter: () => {
                                  const score =
                                    snapshotData?.["行業內綜合評分"] || 60;
                                  return score + "分";
                                },
                              },
                              labelLine: {
                                show: false,
                              },
                              data: [
                                {
                                  value: snapshotData?.["行業內綜合評分"] || 60,
                                  name: "已得分",
                                  itemStyle: {
                                    color: "#FDB900",
                                  },
                                },
                                {
                                  value:
                                    100 -
                                    (snapshotData?.["行業內綜合評分"] || 60),
                                  name: "未得分",
                                  itemStyle: {
                                    color: "#E0E0E0",
                                  },
                                },
                              ],
                              emphasis: {
                                scale: false,
                              },
                            },
                          ],
                        }}
                        style={{ height: "300px" }}
                      />
                    )}
                  </div>

                  <div className="score-chart-item">
                    <div className="chart-title" ref={rightChartTitleRef}>
                      圖靈數位
                      <br />
                      評估調整後評分
                    </div>
                    {isNoData(snapshotData?.["評估調整後評分"]) ? (
                      <div
                        className="no-data-placeholder"
                        style={{ height: "300px" }}
                      >
                        此項目暫無數據
                      </div>
                    ) : (
                      <ReactECharts
                        className="score-donut-chart"
                        option={{
                          tooltip: {
                            trigger: "item",
                            formatter: "{b}: {c}分",
                          },
                          grid: {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            containLabel: false,
                          },
                          series: [
                            {
                              name: "調整後評分",
                              type: "pie",
                              radius: ["65%", "85%"],
                              center: ["50%", "50%"],
                              avoidLabelOverlap: false,
                              label: {
                                show: true,
                                position: "center",
                                fontSize: 48,
                                fontWeight: "bold",
                                color: "#1a1a1a",
                                formatter: () => {
                                  const score =
                                    snapshotData?.["評估調整後評分"] || 80;
                                  return score + "分";
                                },
                              },
                              labelLine: {
                                show: false,
                              },
                              data: [
                                {
                                  value: snapshotData?.["評估調整後評分"] || 80,
                                  name: "已得分",
                                  itemStyle: {
                                    color: "#90c21c",
                                  },
                                },
                                {
                                  value:
                                    100 -
                                    (snapshotData?.["評估調整後評分"] || 80),
                                  name: "未得分",
                                  itemStyle: {
                                    color: "#E0E0E0",
                                  },
                                },
                              ],
                              emphasis: {
                                scale: false,
                              },
                            },
                          ],
                        }}
                        style={{ height: "300px" }}
                      />
                    )}
                  </div>
                </div>

                <div className="score-1">
                  {/* google_is_signed_in */}
                  {true && (
                    <>
                      {/* marketCompare */}
                      {true && (
                        <div className="status-sum">
                          <Row>
                            <Col xs={24} sm={8}>
                              <div className="status-sum-error">
                                低於平均值:{" "}
                                {(() => {
                                  const hasNullStatus =
                                    industryComparisonMetrics.some(
                                      (item) => item.status === null
                                    );
                                  if (hasNullStatus) return "--";
                                  return industryComparisonMetrics.filter(
                                    (item) => item.status === "低於平均值"
                                  ).length;
                                })()}
                              </div>
                            </Col>
                            <Col xs={24} sm={8}>
                              <div className="status-sum-suggestion">
                                等於平均值:{" "}
                                {(() => {
                                  const hasNullStatus =
                                    industryComparisonMetrics.some(
                                      (item) => item.status === null
                                    );
                                  if (hasNullStatus) return "--";
                                  return industryComparisonMetrics.filter(
                                    (item) => item.status === "等於平均值"
                                  ).length;
                                })()}
                              </div>
                            </Col>
                            <Col xs={24} sm={8}>
                              <div className="status-sum-normal">
                                高於平均值:{" "}
                                {(() => {
                                  const hasNullStatus =
                                    industryComparisonMetrics.some(
                                      (item) => item.status === null
                                    );
                                  if (hasNullStatus) return "--";
                                  return industryComparisonMetrics.filter(
                                    (item) => item.status === "高於平均值"
                                  ).length;
                                })()}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}

                      <div className="show-table section">
                        <>
                          <p className="table-title">
                            {/* 基本設定 */}
                            {/* {t("check-result.basic.title")} */}
                          </p>
                          <Collapse
                            defaultActiveKey={[]}
                            expandIconPosition="right"
                            onChange={CollapseOnChange}
                          >
                            {industryComparisonMetrics.map((item, index) => {
                              // console.log(index + ". item = ", item)
                              const status = getCheckListItemStatus(item);

                              return (
                                <Panel
                                  key={item.key}
                                  header={
                                    <>
                                      {/* <span className="checklist-idx">{index + 1}</span> */}
                                      <span className="checklist-status">
                                        {status}
                                      </span>
                                      {/* {getStatusIcon(item.status)}
                        <span className="checklist-status" style={{ color: color, marginRight: "4px" }}>{item.status}</span> */}
                                      <span className="checklist-name">
                                        {item.name.tw}
                                      </span>
                                      <Tag>{item.name.en}</Tag>
                                    </>
                                  }
                                >
                                  <p>
                                    {item.description}
                                    {item.descriptionLink && (
                                      <a
                                        target="_blank"
                                        href={item.descriptionLink}
                                      >
                                        {/* 瞭解詳情 */}
                                        {t("check-result.more")}
                                      </a>
                                    )}
                                  </p>

                                  {/* 可以怎麼調整✨ 區塊 */}
                                  {item.suggestions &&
                                    item.suggestions.length > 0 && (
                                      <div className="checklist-suggestions">
                                        <div className="suggestions-title">
                                          可以怎麼調整✨
                                        </div>
                                        <ul className="suggestions-list">
                                          {item.suggestions.map(
                                            (suggestion, idx) => (
                                              <li key={idx}>► {suggestion}</li>
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    )}

                                  <div className="checklist-result">
                                    <div className="checklist-result-val">
                                      <div className="checklist-result-title">
                                        {/* 檢測結果 */}
                                        {t("check-result.result")}
                                      </div>
                                      <div className="checklist-result-content">
                                        {item.percentage !== null
                                          ? `${item.percentage}%`
                                          : "--"}
                                      </div>
                                    </div>
                                    {item.status === "高於平均值" && (
                                      <div
                                        className="btn"
                                        onClick={() =>
                                          handleIndustryMetricButtonClick(item)
                                        }
                                      >
                                        取得更多優化方法
                                      </div>
                                    )}
                                    {item.status === "低於平均值" && (
                                      <div
                                        className="btn"
                                        onClick={() =>
                                          handleIndustryMetricButtonClick(item)
                                        }
                                      >
                                        了解數據優化方案
                                      </div>
                                    )}
                                    {item.status === "等於平均值" && (
                                      <div
                                        className="btn"
                                        onClick={() =>
                                          handleIndustryMetricButtonClick(item)
                                        }
                                      >
                                        了解數據優化方案
                                      </div>
                                    )}
                                  </div>
                                </Panel>
                              );
                            })}
                          </Collapse>
                        </>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* 檢查看看 */}
              <div className="checklist-section section">
                <h2 className="section-main-title">檢查看看✨</h2>

                <div className="checklist-grid">
                  <div className="checklist-card">
                    <div className="card-title">內容對得上嗎？🎯</div>
                    <div className="card-content">
                      <p>廣告說折扣、頁面卻沒看到？</p>
                      <p>👉 圖文一致，三秒內讓人「看懂在賣什麼」。</p>
                    </div>
                  </div>

                  <div className="checklist-card">
                    <div className="card-title">第一眼就心動嗎？👀</div>
                    <div className="card-content">
                      <p>主打商品或優惠 CTA 藏太深？</p>
                      <p>📱 手機滑不到重點＝直接關掉。</p>
                    </div>
                  </div>

                  <div className="checklist-card">
                    <div className="card-title">結帳流程順嗎？🚀</div>
                    <div className="card-content">
                      <p>步驟太多、欄位太長？</p>
                      <p>👉 一頁完成，可自動帶資料，轉換率最高。</p>
                    </div>
                  </div>

                  <div className="checklist-card">
                    <div className="card-title">有安全感嗎？🤝</div>
                    <div className="card-content">
                      <p>付款頁沒看到退換或客服？</p>
                      <p>👉 放上保證與標章，讓人敢按「下單」。</p>
                    </div>
                  </div>

                  <div className="checklist-card">
                    <div className="card-title">數據追得到嗎？📊</div>
                    <div className="card-content">
                      <p>Pixel/CAPI 有回傳成功嗎？</p>
                      <p>👉 沒追到就等於沒發生，先修追蹤再談優化。</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 聯絡表單 */}
              {/* prScore > 0 */}
              {true && (
                <div
                  className="contact-form"
                  onFocus={() => setIsContactFormFocused(true)}
                  onBlur={() => setIsContactFormFocused(false)}
                >
                  <Element
                    name="contact-form-snapshot"
                    className="element"
                  ></Element>
                  <div className="contact-text">
                    <p className="title">{t("contact-form.title")}</p>
                    <p className="sub-title">
                      {/* {t("contact-form.sub")} */}
                      專業的數據顧問服務，根據您目前的網站表現狀況，提供專屬的數據優化方案，提升競爭力與轉換率
                    </p>
                  </div>
                  <Form
                    {...formLayout}
                    name="nest-messages"
                    onFinish={(values) =>
                      handleSubmitContactForm(values, { formType: "snapshot" })
                    }
                    validateMessages={validateMessages}
                    initialValues={{
                      contact: {
                        time: [
                          "平日 09:30 - 12:00",
                          "平日 13:30 - 15:30",
                          "平日 15:30 - 18:30",
                        ],
                      },
                    }}
                  >
                    <Form.Item
                      name={["contact", "name"]}
                      label={t("contact-form.name")}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name={["contact", "phone"]}
                      label={t("contact-form.phone")}
                      rules={[
                        {
                          required: true,
                        },
                        {
                          pattern: /^(09)[0-9]{8}$/,
                          message: "請輸入正確的手機",
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item
                      name={["contact", "email"]}
                      label={t("contact-form.email")}
                      rules={[
                        {
                          required: true,
                          type: "email",
                        },
                        {
                          message: "請輸入正確的信箱",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    {/* <Form.Item name={["contact", "items"]} label="諮詢項目">
              {checkListResult.map((item) => {
                let color = "";
                if (item.status == "數據異常") {
                  color = "#f90000";
                } else if (item.status == "建議修正") {
                  color = "#fdb900";
                }

                if (item.status == "數據異常") {
                  return (
                    <div key={item.key}>
                      <CloseCircleFilled
                        style={{ color: color, marginRight: "8px" }}
                      />
                      <span style={{ color: color }}>{item.status}</span>{" "}
                      {item.name.tw}
                    </div>
                  );
                }
              })}
              {checkListResult.map((item) => {
                // console.log("xxxxxx item = ", item)
                let color = "";
                if (item.status == "數據異常") {
                  color = "#f90000";
                } else if (item.status == "建議修正") {
                  color = "#fdb900";
                }

                if (item.status == "建議修正") {
                  return (
                    <div key={item.key}>
                      <WarningFilled
                        style={{ color: color, marginRight: "8px" }}
                      />
                      <span style={{ color: color }}>{item.status}</span>{" "}
                      {item.name.tw}
                    </div>
                  );
                }
              })}
            </Form.Item> */}
                    <Form.Item name={["contact", "topics"]} label="諮詢內容">
                      <Radio.Group>
                        <Row>
                          <Col span={24}>
                            <Radio
                              value="競業比較分析"
                              style={{
                                lineHeight: "32px",
                              }}
                            >
                              競業比較分析
                            </Radio>
                          </Col>
                          <Col span={24}>
                            <Radio
                              value="即時數據報告"
                              style={{
                                lineHeight: "32px",
                              }}
                            >
                              即時數據報告
                            </Radio>
                          </Col>
                          <Col span={24}>
                            <Radio
                              value="數據優化服務"
                              style={{
                                lineHeight: "32px",
                              }}
                            >
                              數據優化服務
                            </Radio>
                          </Col>
                          <Col span={24}>
                            <Radio
                              value="以上皆是"
                              style={{
                                lineHeight: "32px",
                              }}
                            >
                              以上皆是
                            </Radio>
                          </Col>
                        </Row>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item
                      name={["contact", "others"]}
                      label={t("contact-form.other")}
                    >
                      <Input.TextArea />
                    </Form.Item>
                    {/* <Form.Item name={["contact", "time"]} label="諮詢時間">
              <CheckboxGroup>
                <Row>
                  <Col span={24}>
                    <Checkbox
                      value="平日 09:30 - 12:00"
                      style={{
                        lineHeight: "32px",
                      }}
                      checked="true"
                    >
                      平日 09:30 - 12:00
                    </Checkbox>
                  </Col>
                  <Col span={24}>
                    <Checkbox
                      value="平日 13:30 - 15:30"
                      style={{
                        lineHeight: "32px",
                      }}
                      checked="true"
                    >
                      平日 13:30 - 15:30
                    </Checkbox>
                  </Col>
                  <Col span={24}>
                    <Checkbox
                      value="平日 15:30 - 18:30"
                      style={{
                        lineHeight: "32px",
                      }}
                      checked="true"
                    >
                      平日 15:30 - 18:30
                    </Checkbox>
                  </Col>
                </Row>
              </CheckboxGroup>
            </Form.Item> */}
                    <Form.Item
                      wrapperCol={{
                        span: 24,
                        offset: 0,
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {/* <Form.Item> */}
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={isSubmitContactForm}
                        style={{
                          display: "inline-flex",
                          flexDirection: "row",
                          flexWrap: "nowrap",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "54px",
                          borderRadius: "4px",
                          padding: "8px 12px 8px 3px",
                          backgroundColor: "#4384f3",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "48px",
                            minWidth: "48px",
                            borderRadius: "4px",
                            backgroundColor: "white",
                          }}
                        >
                          <img style={{ width: "36px" }} src={imgIconArrow} />
                        </span>

                        <span
                          style={{
                            display: "inline-flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "12px",
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("contact-form.submit")}
                        </span>
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              )}
            </PostCheckContent>
          )}
        </div>
      )}
      {/* 舊版內容 */}
      {displayMode !== "new-content-only" && (
        <div
          className="legacy-content"
          title="Legacy sections kept for reference"
        >
          <div className="score-card section">
            <div className="wrap">
              <Card title="一、市場表現綜合評比" bordered={false}>
                <div className="score-card-result">
                  <ReactECharts
                    className="score-chart"
                    option={marketEchartsOption}
                  />
                  <div className="score-content">
                    {/* {prScore > 0 ? (
                  <>
                    檢核結果 {score} 分<br />
                    落後 {100 - prScore}% 的網站
                  </>
                ) : google_is_signed_in ? (
                  "選擇帳戶及資源以獲得結果"
                ) : (
                  "登入以獲得結果"
                )} */}
                    {marketCompare && score > 0 ? (
                      <>
                        檢核結果為 {marketCompare.score} 分<br />
                        {/* {marketCompare.score <= 75 ? "低於平均值" : "高於平均值"} */}
                        落後 {marketCompare.marketPerformanceRatio}％ 的網站
                      </>
                    ) : google_is_signed_in ? (
                      "選擇帳戶及資源以獲得結果"
                    ) : (
                      "登入以獲得結果"
                    )}
                    {/* {google_is_signed_in && !marketCompare
                  ? "選擇帳戶及資源以獲得結果"
                  : "登入以獲得結果"} */}
                  </div>
                </div>
                <div className="score-card-status">
                  <div className="score-card-status-item error">
                    數據異常: {marketCompare ? marketCompare.benchmark[0] : "-"}
                  </div>
                  <div className="score-card-status-item low">
                    低於平均值:{" "}
                    {marketCompare ? marketCompare.benchmark[1] : "-"}
                  </div>
                </div>
                <div className="score-card-status-total">共 4 個檢測項目</div>
              </Card>
              <Card title="二、GA4 基本設定" bordered={false}>
                <div className="score-card-result">
                  <ReactECharts
                    className="score-chart"
                    option={echartsOption}
                  />
                  <div className="score-content">
                    {score > 0 && <>檢核結果 {score} 分</>}
                    {prScore > 0 && score > 0 ? (
                      <>
                        <br />
                        落後 {100 - prScore}% 的網站
                      </>
                    ) : google_is_signed_in ? (
                      "選擇帳戶及資源以獲得結果"
                    ) : (
                      "登入以獲得結果"
                    )}
                  </div>
                </div>
                <div className="score-card-status">
                  <div className="score-card-status-item error">
                    數據異常:{" "}
                    {checkListResultError.length
                      ? checkListResultError.length
                      : "-"}
                  </div>
                  <div className="score-card-status-item low">
                    建議修正:{" "}
                    {checkListResultSuggestion.length
                      ? checkListResultSuggestion.length
                      : "-"}
                  </div>
                </div>
                <div className="score-card-status-total">共 22 個檢測項目</div>
              </Card>
            </div>
          </div>

          <div className="score-1">
            {google_is_signed_in && (
              <>
                <div className="score section">
                  <div className="title">一、市場表現綜合評比</div>
                  <ReactECharts
                    className="score-chart"
                    option={marketEchartsOption}
                  />
                  {/* <ScoreChart /> */}
                  {marketCompare && (
                    <div>
                      <div className="score-result">
                        檢核結果 {marketCompare.score} 分，
                        {/* {marketCompare.score <= 75 ? " 低於平均值" : "高於平均值"} */}
                        落後 {marketCompare.marketPerformanceRatio}％ 的網站
                      </div>
                      <div className="fix-quation">
                        <Link
                          activeClass="active"
                          className="test1"
                          to="test1"
                          spy={true}
                          smooth={true}
                          duration={500}
                          onClick={handleFixQuation}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              flexDirection: "row",
                              flexWrap: "nowrap",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "54px",
                              borderRadius: "4px",
                              padding: "8px 12px 8px 3px",
                              cursor: "pointer",
                              backgroundColor:
                                marketCompare.score <= 50
                                  ? "#f90000"
                                  : marketCompare.score < 90
                                    ? "#fdb900"
                                    : "#4384f3",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                minHeight: "48px",
                                minWidth: "48px",
                                borderRadius: "4px",
                                backgroundColor: "white",
                              }}
                            >
                              {/* <img style={{ width: "36px" }} src={imgIconFixBlue} /> */}
                              {marketCompare.score <= 50 ? (
                                <img
                                  style={{ width: "26px" }}
                                  src={imgIconFixRed}
                                />
                              ) : marketCompare.score < 90 ? (
                                <img
                                  style={{ width: "26px" }}
                                  src={imgIconFixYellow}
                                />
                              ) : (
                                <img
                                  style={{ width: "26px" }}
                                  src={imgIconFixGreen}
                                />
                              )}
                            </span>

                            <span
                              style={{
                                display: "inline-flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "12px",
                                fontSize: "16px",
                                fontWeight: "700",
                              }}
                            >
                              {marketCompare.marketPerformanceRatio === 0
                                ? "探索更多優化秘訣"
                                : "立刻修正問題"}
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  )}
                  <div className="score-date">
                    {t("check-date")}:{" "}
                    {moment()
                      .subtract(2, "months")
                      .startOf("month")
                      .format("YYYY/MM/DD")}{" "}
                    -{" "}
                    {moment()
                      .subtract(2, "months")
                      .endOf("month")
                      .format("YYYY/MM/DD")}
                    {/* {moment().subtract(31, "days").format("YYYY/MM/DD")} -{" "}
                {moment().subtract(1, "days").format("YYYY/MM/DD")} */}
                  </div>
                  {/* <div className="score-interval">
                <div className="score-error interval-item">
                  <img src={statusError} />
                  <div className="interval-text">0-49</div>
                </div>
                <div className="score-fix interval-item">
                  <img src={statusFix} />
                  <div className="interval-text">50-89</div>
                </div>
                <div className="score-normal interval-item">
                  <img src={statusNormal} />
                  <div className="interval-text">90-100</div>
                </div>
              </div> */}
                </div>
                {marketCompare && (
                  <div className="status-sum">
                    <Row>
                      <Col xs={24} sm={8}>
                        <div className="status-sum-error">
                          數據異常: {marketCompare.benchmark[0]}
                        </div>
                      </Col>
                      <Col xs={24} sm={8}>
                        <div className="status-sum-suggestion">
                          低於平均值: {marketCompare.benchmark[1]}
                        </div>
                      </Col>
                      <Col xs={24} sm={8}>
                        <div className="status-sum-normal">
                          高於平均值: {marketCompare.benchmark[2]}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                <div className="show-table section">
                  <>
                    <p className="table-title">
                      {/* 基本設定 */}
                      {/* {t("check-result.basic.title")} */}
                    </p>
                    <Collapse
                      defaultActiveKey={[]}
                      expandIconPosition="right"
                      onChange={CollapseOnChange}
                    >
                      {checkListResultCompare.map((item, index) => {
                        // console.log(index + ". item = ", item)
                        const result = getCheckListItemResult(item);
                        const status = getCheckListItemStatus(item);

                        return (
                          <Panel
                            key={item.key}
                            header={
                              <>
                                {/* <span className="checklist-idx">{index + 1}</span> */}
                                <span className="checklist-status">
                                  {status}
                                </span>
                                {/* {getStatusIcon(item.status)}
                      <span className="checklist-status" style={{ color: color, marginRight: "4px" }}>{item.status}</span> */}
                                <span className="checklist-name">
                                  {item.name.tw}
                                </span>
                                <Tag>{item.name.en}</Tag>
                              </>
                            }
                          >
                            <p>
                              {item.description}
                              {item.descriptionLink && (
                                <a target="_blank" href={item.descriptionLink}>
                                  {/* 瞭解詳情 */}
                                  {t("check-result.more")}
                                </a>
                              )}
                            </p>
                            <div className="checklist-result">
                              <div className="checklist-result-val">
                                <div className="checklist-result-title">
                                  {/* 檢測結果 */}
                                  {t("check-result.result")}
                                </div>
                                <div className="checklist-result-content">
                                  {result}
                                </div>
                              </div>
                              {item.status === "高於平均值" && (
                                <div className="btn" onClick={openPopup}>
                                  取得更多優化方法
                                </div>
                              )}
                              {item.status === "低於平均值" && (
                                <div className="btn" onClick={openPopup}>
                                  了解數據優化方案
                                </div>
                              )}
                              {item.status === "數據異常" && (
                                <div className="btn" onClick={openPopup}>
                                  立即提升{item.name.tw}
                                </div>
                              )}
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>
                  </>
                </div>
              </>
            )}
          </div>
          {property && (
            <div className="reminder section">
              <div className="content">
                使用提醒：
                <br />
                以上數據基於<span>兩個月前的全產業市場基準分析</span>（例如：12
                月查看即為 10
                月數據），為您提供初步的關鍵指標比較。若需要更全面的數據分析報告，可以參考
                <a
                  href="javascript:;"
                  onClick={(event) => handleFloatFormOpen(event)}
                >
                  即時數據分析服務。
                </a>
              </div>
            </div>
          )}
          <div className="score-2">
            {google_is_signed_in && (
              <>
                <div className="score section">
                  <div className="title">二、GA4 基本設定</div>
                  <ReactECharts
                    className="score-chart"
                    option={echartsOption}
                  />
                  {/* <ScoreChart /> */}
                  {prScore > 0 && score > 0 && (
                    <div>
                      <div className="score-result">
                        檢核結果 {score} 分，落後 {100 - prScore}% 的網站
                      </div>
                      <div className="fix-quation">
                        <Link
                          activeClass="active"
                          className="test1"
                          to="test1"
                          spy={true}
                          smooth={true}
                          duration={500}
                          onClick={handleFixQuation}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              flexDirection: "row",
                              flexWrap: "nowrap",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "54px",
                              borderRadius: "4px",
                              padding: "8px 12px 8px 3px",
                              backgroundColor:
                                score <= 50
                                  ? "#f90000"
                                  : score < 90
                                    ? "#fdb900"
                                    : "#4384f3",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                minHeight: "48px",
                                minWidth: "48px",
                                borderRadius: "4px",
                                backgroundColor: "white",
                              }}
                            >
                              {/* <img style={{ width: "36px" }} src={imgIconFixBlue} /> */}
                              {score <= 50 ? (
                                <img
                                  style={{ width: "26px" }}
                                  src={imgIconFixRed}
                                />
                              ) : score < 90 ? (
                                <img
                                  style={{ width: "26px" }}
                                  src={imgIconFixYellow}
                                />
                              ) : (
                                <img
                                  style={{ width: "26px" }}
                                  src={imgIconFixGreen}
                                />
                              )}
                            </span>

                            <span
                              style={{
                                display: "inline-flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "12px",
                                fontSize: "16px",
                                fontWeight: "700",
                              }}
                            >
                              立刻修正問題
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  )}
                  <div className="score-date">
                    {t("check-date")}:{" "}
                    {moment().subtract(31, "days").format("YYYY/MM/DD")} -{" "}
                    {moment().subtract(1, "days").format("YYYY/MM/DD")}
                  </div>
                  <div className="score-interval">
                    <div className="score-error interval-item">
                      <img src={statusError} />
                      <div className="interval-text">0-50</div>
                    </div>
                    <div className="score-fix interval-item">
                      <img src={statusFix} />
                      <div className="interval-text">51-89</div>
                    </div>
                    <div className="score-normal interval-item">
                      <img src={statusNormal} />
                      <div className="interval-text">90-100</div>
                    </div>
                  </div>
                </div>
                {prScore > 0 && (
                  <div className="status-sum">
                    <Row>
                      <Col xs={24} sm={8}>
                        <div className="status-sum-error">
                          數據異常: {checkListResultError.length}
                        </div>
                      </Col>
                      <Col xs={24} sm={8}>
                        <div className="status-sum-suggestion">
                          建議修正: {checkListResultSuggestion.length}
                        </div>
                      </Col>
                      <Col xs={24} sm={8}>
                        <div className="status-sum-normal">
                          正常運作: {checkListResultNormal.length}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                <div className="show-table section">
                  <>
                    <p className="table-title">
                      {/* 基本設定 */}
                      {t("check-result.basic.title")}
                    </p>
                    <Collapse
                      defaultActiveKey={[]}
                      expandIconPosition="right"
                      onChange={CollapseOnChange}
                    >
                      {checkListResultBasic.map((item, index) => {
                        // console.log(index + ". item = ", item)
                        const result = getCheckListItemResult(item);
                        const status = getCheckListItemStatus(item);

                        return (
                          <Panel
                            key={item.key}
                            header={
                              <>
                                {/* <span className="checklist-idx">{index + 1}</span> */}
                                <span className="checklist-status">
                                  {status}
                                </span>
                                {/* {getStatusIcon(item.status)}
                      <span className="checklist-status" style={{ color: color, marginRight: "4px" }}>{item.status}</span> */}
                                <span className="checklist-name">
                                  {item.name.tw}
                                </span>
                                <Tag>{item.name.en}</Tag>
                              </>
                            }
                          >
                            <p>
                              {item.description}
                              {item.descriptionLink && (
                                <a target="_blank" href={item.descriptionLink}>
                                  {/* 瞭解詳情 */}
                                  {t("check-result.more")}
                                </a>
                              )}
                            </p>
                            <div className="checklist-result">
                              <div className="checklist-result-title">
                                {/* 檢測結果 */}
                                {t("check-result.result")}
                              </div>
                              <div className="checklist-result-content">
                                {result}
                              </div>
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>

                    <p className="table-title">
                      {/* 數據收集 */}
                      {t("check-result.collect.title")}
                    </p>
                    <Collapse defaultActiveKey={[]} expandIconPosition="right">
                      {checkListResultCollect.map((item, index) => {
                        const result = getCheckListItemResult(item);
                        const status = getCheckListItemStatus(item);

                        return (
                          <Panel
                            key={item.key}
                            header={
                              <>
                                {/* <span className="checklist-idx">{index + 1}</span> */}
                                <span className="checklist-status">
                                  {status}
                                </span>
                                {/* {getStatusIcon(item.status)}
                      <span className="checklist-status" style={{ color: color, marginRight: "4px" }}>{item.status}</span> */}
                                <span className="checklist-name">
                                  {item.name.tw}
                                </span>
                                <Tag>{item.name.en}</Tag>
                              </>
                            }
                          >
                            <p>
                              {item.description}
                              {item.descriptionLink && (
                                <a target="_blank" href={item.descriptionLink}>
                                  {/* 瞭解詳情 */}
                                  {t("check-result.more")}
                                </a>
                              )}
                            </p>
                            <div className="checklist-result">
                              <div className="checklist-result-title">
                                {/* 檢測結果 */}
                                {t("check-result.result")}
                              </div>
                              <div className="checklist-result-content">
                                {result}
                              </div>
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>

                    <p className="table-title">
                      {/* 數據運用 */}
                      {t("check-result.application.title")}
                    </p>
                    <Collapse defaultActiveKey={[]} expandIconPosition="right">
                      {checkListResultApplication.map((item, index) => {
                        const result = getCheckListItemResult(item);
                        const status = getCheckListItemStatus(item);

                        return (
                          <Panel
                            key={item.key}
                            header={
                              <>
                                {/* <span className="checklist-idx">{index + 1}</span> */}
                                <span className="checklist-status">
                                  {status}
                                </span>
                                {/* {getStatusIcon(item.status)}
                      <span className="checklist-status" style={{ color: color, marginRight: "4px" }}>{item.status}</span> */}
                                <span className="checklist-name">
                                  {item.name.tw}
                                </span>
                                <Tag>{item.name.en}</Tag>
                              </>
                            }
                          >
                            <p>
                              {item.description}
                              {item.descriptionLink && (
                                <a target="_blank" href={item.descriptionLink}>
                                  {/* 瞭解詳情 */}
                                  {t("check-result.more")}
                                </a>
                              )}
                            </p>
                            <div className="checklist-result">
                              <div className="checklist-result-title">
                                {/* 檢測結果 */}
                                {t("check-result.result")}
                              </div>
                              <div className="checklist-result-content">
                                {result}
                              </div>
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>
                  </>
                </div>
              </>
            )}
          </div>
          {/* {isFloatFormNotificationVisible && (
        <div className="float-form-notification">
          <CloseOutlined onClick={handleFloatFormNotificationClose} />
          <div className="title">你需要專屬的數據優化方案嗎？</div>
          <ul>
            <li>・即時檢視每日網站數據表現</li>
            <li>・同產業的 PR 值與排名分析</li>
            <li>・電商轉換率 / 營收優化方案</li>
          </ul>
          <div className="btn" onClick={(event) => handleFloatFormOpen(event)}>
            立即了解服務
          </div>
        </div>
      )} */}
          {isFloatFormVisible && (
            <div
              className="contact-form float-form"
              onFocus={() => setIsContactFormFocused(true)}
              onBlur={() => setIsContactFormFocused(false)}
            >
              <CloseOutlined onClick={handleFloatFormClose} />
              <Element name="test1-float" className="element"></Element>
              <div className="contact-text">
                <p className="title">✏️立即填寫資料，解鎖專屬數據優化方案📊</p>
                {/* <p className="sub-title">{t("contact-form.sub")}</p> */}
              </div>
              <Form
                {...formLayout}
                name="nest-messages"
                onFinish={handleSubmitFloatForm}
                validateMessages={validateMessages}
              >
                <Form.Item
                  name={["contact", "name"]}
                  label={t("contact-form.name")}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["contact", "phone"]}
                  label={t("contact-form.phone")}
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern: /^(09)[0-9]{8}$/,
                      message: "請輸入正確的手機",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item
                  name={["contact", "email"]}
                  label={t("contact-form.email")}
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                    {
                      message: "請輸入正確的信箱",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  wrapperCol={{
                    ...formLayout.wrapperCol,
                    offset: submitBtnOffset,
                  }}
                >
                  {/* <Form.Item> */}
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={isSubmitFloatForm}
                    style={{
                      display: "inline-flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "44px",
                      borderRadius: "8px",
                      padding: "8px 44px",
                      backgroundColor: "#4384f3",
                    }}
                  >
                    {/* <span
                style={{
                  display: "inline-flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "48px",
                  minWidth: "48px",
                  borderRadius: "4px",
                  backgroundColor: "white",
                }}
              >
                <img style={{ width: "36px" }} src={imgIconArrow} />
              </span> */}

                    <span
                      style={{
                        display: "inline-flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        // marginLeft: "12px",
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      立即送出表單
                    </span>
                  </Button>
                </Form.Item>
              </Form>
            </div>
          )}
          {prScore > 0 && (
            <div
              className="contact-form"
              onFocus={() => setIsContactFormFocused(true)}
              onBlur={() => setIsContactFormFocused(false)}
            >
              <Element name="test1" className="element"></Element>
              <div className="contact-text">
                <p className="title">{t("contact-form.title")}</p>
                <p className="sub-title">
                  {/* {t("contact-form.sub")} */}
                  專業的數據顧問服務，根據您目前的網站表現狀況，提供專屬的數據優化方案，提升競爭力與轉換率
                </p>
              </div>
              <Form
                {...formLayout}
                name="nest-messages"
                onFinish={handleSubmitContactForm}
                validateMessages={validateMessages}
                initialValues={{
                  contact: {
                    time: [
                      "平日 09:30 - 12:00",
                      "平日 13:30 - 15:30",
                      "平日 15:30 - 18:30",
                    ],
                  },
                }}
              >
                <Form.Item
                  name={["contact", "name"]}
                  label={t("contact-form.name")}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["contact", "phone"]}
                  label={t("contact-form.phone")}
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern: /^(09)[0-9]{8}$/,
                      message: "請輸入正確的手機",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item
                  name={["contact", "email"]}
                  label={t("contact-form.email")}
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                    {
                      message: "請輸入正確的信箱",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                {/* <Form.Item name={["contact", "items"]} label="諮詢項目">
              {checkListResult.map((item) => {
                let color = "";
                if (item.status == "數據異常") {
                  color = "#f90000";
                } else if (item.status == "建議修正") {
                  color = "#fdb900";
                }

                if (item.status == "數據異常") {
                  return (
                    <div key={item.key}>
                      <CloseCircleFilled
                        style={{ color: color, marginRight: "8px" }}
                      />
                      <span style={{ color: color }}>{item.status}</span>{" "}
                      {item.name.tw}
                    </div>
                  );
                }
              })}
              {checkListResult.map((item) => {
                // console.log("xxxxxx item = ", item)
                let color = "";
                if (item.status == "數據異常") {
                  color = "#f90000";
                } else if (item.status == "建議修正") {
                  color = "#fdb900";
                }

                if (item.status == "建議修正") {
                  return (
                    <div key={item.key}>
                      <WarningFilled
                        style={{ color: color, marginRight: "8px" }}
                      />
                      <span style={{ color: color }}>{item.status}</span>{" "}
                      {item.name.tw}
                    </div>
                  );
                }
              })}
            </Form.Item> */}
                <Form.Item
                  name={["contact", "topics"]}
                  label="諮詢內容"
                  rules={[
                    {
                      required: true,
                      // type: "topics",
                    },
                  ]}
                >
                  <Radio.Group>
                    <Row>
                      <Col span={24}>
                        <Radio
                          value="競業比較分析"
                          style={{
                            lineHeight: "32px",
                          }}
                        >
                          競業比較分析
                        </Radio>
                      </Col>
                      <Col span={24}>
                        <Radio
                          value="即時數據報告"
                          style={{
                            lineHeight: "32px",
                          }}
                        >
                          即時數據報告
                        </Radio>
                      </Col>
                      <Col span={24}>
                        <Radio
                          value="數據優化服務"
                          style={{
                            lineHeight: "32px",
                          }}
                        >
                          數據優化服務
                        </Radio>
                      </Col>
                      <Col span={24}>
                        <Radio
                          value="以上皆是"
                          style={{
                            lineHeight: "32px",
                          }}
                        >
                          以上皆是
                        </Radio>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name={["contact", "others"]}
                  label={t("contact-form.other")}
                >
                  <Input.TextArea />
                </Form.Item>
                {/* <Form.Item name={["contact", "time"]} label="諮詢時間">
              <CheckboxGroup>
                <Row>
                  <Col span={24}>
                    <Checkbox
                      value="平日 09:30 - 12:00"
                      style={{
                        lineHeight: "32px",
                      }}
                      checked="true"
                    >
                      平日 09:30 - 12:00
                    </Checkbox>
                  </Col>
                  <Col span={24}>
                    <Checkbox
                      value="平日 13:30 - 15:30"
                      style={{
                        lineHeight: "32px",
                      }}
                      checked="true"
                    >
                      平日 13:30 - 15:30
                    </Checkbox>
                  </Col>
                  <Col span={24}>
                    <Checkbox
                      value="平日 15:30 - 18:30"
                      style={{
                        lineHeight: "32px",
                      }}
                      checked="true"
                    >
                      平日 15:30 - 18:30
                    </Checkbox>
                  </Col>
                </Row>
              </CheckboxGroup>
            </Form.Item> */}
                <Form.Item
                  wrapperCol={{
                    span: 24,
                    offset: 0,
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {/* <Form.Item> */}
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={isSubmitContactForm}
                    style={{
                      display: "inline-flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "54px",
                      borderRadius: "4px",
                      padding: "8px 12px 8px 3px",
                      backgroundColor: "#4384f3",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "48px",
                        minWidth: "48px",
                        borderRadius: "4px",
                        backgroundColor: "white",
                      }}
                    >
                      <img style={{ width: "36px" }} src={imgIconArrow} />
                    </span>

                    <span
                      style={{
                        display: "inline-flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "12px",
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      {t("contact-form.submit")}
                    </span>
                  </Button>
                </Form.Item>
              </Form>
            </div>
          )}
        </div>
      )}

      <div className="service-1">
        <Row>
          <div
            style={{
              padding: "0 1rem",
            }}
          >
            <h2 className="title font-weight">
              <span className="number">100,000+</span> 品牌都在使用
            </h2>
            <div className="sub-title">{t("success-case.sub")}</div>
          </div>
        </Row>
      </div>
      <div className="customer-experience">
        <div className="wrap">
          <div className="title font-weight">{t("user-experience.title")}</div>
          <Swiper
            // install Swiper modules
            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            // autoplay={{ delay: 3000, disableOnInteraction: false }}
          >
            <SwiperSlide>
              <Row>
                <Col xs={24} sm={12}>
                  {/* <div style={{ marginBottom: "10px" }}>
              {device == "mobile" ? (
                <img src={imgService01} />
              ) : (
                <img src={imgService01PC} />
              )}
            </div> */}
                  <div
                    style={{
                      padding: "0 1rem",
                    }}
                  >
                    {t("user-experience.user1.text1")}
                    <div className="customer">
                      {t("user-experience.user1.text2")}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div
                    className={
                      device == "mobile"
                        ? "customer-result mobile"
                        : "customer-result"
                    }
                  >
                    <div>{t("user-experience.user1.text3")}</div>
                    <div className="customer-result-num">
                      {t("user-experience.user1.text4")}
                    </div>
                  </div>
                </Col>
              </Row>
            </SwiperSlide>
            <SwiperSlide>
              <Row>
                <Col xs={24} sm={12}>
                  {/* <div style={{ marginBottom: "10px" }}>
              {device == "mobile" ? (
                <img src={imgService01} />
              ) : (
                <img src={imgService01PC} />
              )}
            </div> */}
                  <div
                    style={{
                      padding: "0 1rem",
                    }}
                  >
                    {t("user-experience.user2.text1")}
                    <div className="customer">
                      {t("user-experience.user2.text2")}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div
                    className={
                      device == "mobile"
                        ? "customer-result mobile"
                        : "customer-result"
                    }
                  >
                    <div>{t("user-experience.user2.text3")}</div>
                    <div className="customer-result-num">
                      {t("user-experience.user2.text4")}
                    </div>
                  </div>
                </Col>
              </Row>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      <div className="service-2">
        <div className="wrap">
          <div className="title">導入三個階段，協助您循序漸進的完成</div>
          {/* <Steps current={3}>
            <Step title="Finished" description="This is a description." />
            <Step
              title="In Progress"
              subTitle="Left 00:00:08"
              description="This is a description."
            />
            <Step title="Waiting" description="This is a description." />
          </Steps> */}
          <div className="wrapper option-1 option-1-1">
            <ol className="c-stepper">
              <li className="c-stepper__item">
                <h3 className="c-stepper__title">導入設定</h3>
                <p className="c-stepper__desc">- 確認帳戶結構</p>
                <p className="c-stepper__desc">- 創建分析資源</p>
                <p className="c-stepper__desc">- 串接 GA4 與 GTM</p>
                <p className="c-stepper__desc">- 完成 GA4 基本設定</p>
                <p className="c-stepper__desc">- 啟用 Google 信號</p>
                <p className="c-stepper__desc">- 串接 Google Ads</p>
              </li>
              <li className="c-stepper__item">
                <h3 className="c-stepper__title">學習使用</h3>
                <p className="c-stepper__desc">- 埋設與轉移自訂事件</p>
                <p className="c-stepper__desc">- 建立 User- ID</p>
                <p className="c-stepper__desc">- 建立事件轉換</p>
                <p className="c-stepper__desc">- 目標對象匯入 Google Ads</p>
                <p className="c-stepper__desc">- 導入加強型電子商務</p>
                <p className="c-stepper__desc">- 比較 Web 與 App 數據</p>
              </li>
              <li className="c-stepper__item">
                <h3 className="c-stepper__title">上手應用</h3>
                <p className="c-stepper__desc">- 學習解讀 GA4 報表</p>
                <p className="c-stepper__desc">- 利用數據優化 Web 或 App</p>
                <p className="c-stepper__desc">- 啟用預測目標對象功能</p>
                <p className="c-stepper__desc">- 利用廣告報表分析轉換歸因</p>
                <p className="c-stepper__desc">- 利用探索中心自訂報表</p>
                <p className="c-stepper__desc">
                  - Measurement Protocol 導入資料
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>

      {google_is_signed_in && (
        <div className="service-3">
          <div className="wrap">
            <h2 className="title">{t("service.title")}</h2>
            <Row>
              <Col xs={24} sm={12} md={6}>
                <div className="plan">
                  <div className="img">
                    <img src={imgService03Plan01} />
                  </div>
                  <h3 className="name">A. {t("service.item-1.name")}</h3>
                  <div className="descript">{t("service.item-1.descript")}</div>
                  <a
                    target="_blank"
                    href="https://www.turingdigital.com.tw/ga4-promotion-plan"
                    className="try"
                    onClick={() => {
                      utilsIndex.sendGAEvent("reserve_service", {
                        turing_01: "A. 推廣試用",
                        turing_02: "Check Assistant頁",
                      });
                    }}
                  >
                    {t("service.btn")}
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="plan">
                  <div className="img">
                    <img src={imgService03Plan02} />
                  </div>
                  <h3 className="name">B. {t("service.item-2.name")}</h3>
                  <div className="descript">{t("service.item-2.descript")}</div>
                  <a
                    target="_blank"
                    href="https://www.turingdigital.com.tw/ga4-promotion-plan"
                    className="try"
                    onClick={() => {
                      utilsIndex.sendGAEvent("reserve_service", {
                        turing_01: "B. 基礎導入",
                        turing_02: "Check Assistant頁",
                      });
                    }}
                  >
                    {t("service.btn")}
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="plan">
                  <div className="img">
                    <img src={imgService03Plan03} />
                  </div>
                  <h3 className="name">C. {t("service.item-3.name")}</h3>
                  <div className="descript">{t("service.item-3.descript")}</div>
                  <a
                    target="_blank"
                    href="https://www.turingdigital.com.tw/ga4-promotion-plan"
                    className="try"
                    onClick={() => {
                      utilsIndex.sendGAEvent("reserve_service", {
                        turing_01: "C. 完整分析",
                        turing_02: "Check Assistant頁",
                      });
                    }}
                  >
                    {t("service.btn")}
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="plan">
                  <div className="img">
                    <img src={imgService03Plan04} />
                  </div>
                  <h3 className="name">D. {t("service.item-4.name")}</h3>
                  <div className="descript">{t("service.item-4.descript")}</div>
                  <a
                    target="_blank"
                    href="https://www.turingdigital.com.tw/ga4-promotion-plan"
                    className="try"
                    onClick={() => {
                      utilsIndex.sendGAEvent("reserve_service", {
                        turing_01: "D. 進階應用",
                        turing_02: "Check Assistant頁",
                      });
                    }}
                  >
                    {t("service.btn")}
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div className="footer section">
        <h2 className="title">{t("notice.title")}</h2>
        <div className="content">
          <div />
          <p
            dangerouslySetInnerHTML={{
              __html: t("notice.item-1"),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("notice.item-2"),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("notice.item-3"),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("notice.item-4"),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("notice.item-5"),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("notice.item-6"),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("notice.item-7"),
            }}
          />
          <p>
            &nbsp;8、本服務由圖靈數位提供。圖靈僅以分析與報表生成為目的使用您提供或授權之資料，不會將任何數據用於商業銷售、再行銷或廣告投放用途。
          </p>
          <p>
            &nbsp;9、當您送出表單或持續使用本服務，即表示您已同意本服務條款與隱私政策，並了解圖靈數位僅在資料分析之範圍內使用所蒐集之資訊。
          </p>
          <p>
            10、圖靈數位保有對本服務條款之最終解釋與修訂權。若有更新，將於網站公告後立即生效。
          </p>
        </div>
        <div className="other">
          <img src={imgFooter} />
        </div>
        <div className="copyright">{t("copyright")}</div>
      </div>
      <div className="contact">
        <MessengerChat
          pageId="1807982896101510"
          language="zh_TW"
          // themeColor={"#F2F3G2"}
          // height={24}
          // loggedInGreeting="Hello logged in user!"
          // loggedOutGreeting="Hello stranger!"
          // autoExpand={true}
          debugMode={false}
          onMessengerShow={() => {
            console.log("onMessengerShow");
          }}
          onMessengerHide={() => {
            console.log("onMessengerHide");
          }}
          onMessengerDialogShow={() => {
            console.log("onMessengerDialogShow");
          }}
          onMessengerDialogHide={() => {
            console.log("onMessengerDialogHide");
          }}
        />
        {/* <a
          target="_blank"
          href="https://www.turingdigital.com.tw/ga4-check-reservation"
        >
          <img src={imgContact} />
        </a> */}

        {/* 浮動諮詢按鈕 */}
        {isCheckApiFetchFinished && displayMode !== "legacy-only" && (
          <FloatingButton
            onClick={() => {
              // 🎯 在 /rtga 頁面發送 rtga_chat 事件
              if (isRtgaPage) {
                utilsIndex.sendGAEvent("rtga_chat");
              }

              scroller.scrollTo("contact-form-snapshot", {
                duration: 500,
                smooth: true,
              });
            }}
          />
        )}

        {/* 即時報表推廣 Modal */}
        <RealTimeReportModal
          visible={isRealTimeModalVisible}
          onClose={() => setIsRealTimeModalVisible(false)}
        />
      </div>
    </div>
  );
};

export default CheckAssistant;
